/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * PENDING·REJECTED 포함 전체 인증서와 원본 파일 URL.
 * @summary 공급사 인증서 전체 조회 (어드민)
 */
export const adminSupplierCertificationsControllerListCertificationsParams = zod
  .object({
    supplierId: zod.coerce.string().describe("공급사 사용자 ID"),
  })
  .strict();

export const adminSupplierCertificationsControllerListCertificationsResponse =
  zod
    .object({
      success: zod.boolean().describe("API 호출 성공 여부"),
      data: zod
        .object({
          id: zod.string().describe("인증서 ID"),
          name: zod.string().describe("인증서 명칭"),
          issuer: zod.object({}).nullish().describe("발급 기관"),
          certNumber: zod.object({}).nullish().describe("인증 번호"),
          issuedAt: zod.object({}).nullish().describe("발급일"),
          expiresAt: zod.object({}).nullish().describe("만료일"),
          status: zod
            .enum(["PENDING", "VERIFIED", "REJECTED"])
            .describe("검증 상태"),
          source: zod
            .enum(["SELF", "CMARKET"])
            .describe(
              "출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가)",
            ),
          kind: zod
            .object({})
            .nullish()
            .describe("종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)"),
          rejectionReason: zod.object({}).nullish().describe("반려 사유"),
          fileUrl: zod
            .object({})
            .nullish()
            .describe("업로드 파일 URL (본인/어드민만)"),
          fileName: zod.object({}).nullish().describe("업로드 파일명"),
          createdAt: zod.string().describe("등록일시"),
        })
        .strict()
        .optional(),
      error: zod
        .object({
          code: zod.string().describe("에러 코드"),
          message: zod.string().describe("에러 메시지"),
          details: zod.object({}).optional().describe("상세 정보"),
        })
        .strict()
        .optional()
        .describe("에러 정보 (실패 시에만 포함)"),
      timestamp: zod
        .string()
        .datetime({})
        .describe("응답 생성 시각 (ISO 8601)"),
      statusCode: zod.number().optional().describe("HTTP 상태 코드"),
      message: zod.string().optional().describe("요청 처리 메시지"),
    })
    .strict();

/**
 * VERIFIED 승인 또는 REJECTED 반려 처리.
 * @summary 인증서 검증 (어드민)
 */
export const adminSupplierCertificationsControllerVerifyCertificationParams =
  zod
    .object({
      supplierId: zod.coerce.string().describe("공급사 사용자 ID"),
      certificationId: zod.coerce.string().describe("인증서 ID"),
    })
    .strict();

export const adminSupplierCertificationsControllerVerifyCertificationBody = zod
  .object({
    status: zod.enum(["VERIFIED", "REJECTED"]).describe("검증 결과"),
    rejectionReason: zod
      .string()
      .optional()
      .describe("반려 사유 (REJECTED 시)"),
  })
  .strict();

export const adminSupplierCertificationsControllerVerifyCertificationResponse =
  zod
    .object({
      success: zod.boolean().describe("API 호출 성공 여부"),
      data: zod
        .object({
          id: zod.string().describe("인증서 ID"),
          name: zod.string().describe("인증서 명칭"),
          issuer: zod.object({}).nullish().describe("발급 기관"),
          certNumber: zod.object({}).nullish().describe("인증 번호"),
          issuedAt: zod.object({}).nullish().describe("발급일"),
          expiresAt: zod.object({}).nullish().describe("만료일"),
          status: zod
            .enum(["PENDING", "VERIFIED", "REJECTED"])
            .describe("검증 상태"),
          source: zod
            .enum(["SELF", "CMARKET"])
            .describe(
              "출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가)",
            ),
          kind: zod
            .object({})
            .nullish()
            .describe("종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)"),
          rejectionReason: zod.object({}).nullish().describe("반려 사유"),
          fileUrl: zod
            .object({})
            .nullish()
            .describe("업로드 파일 URL (본인/어드민만)"),
          fileName: zod.object({}).nullish().describe("업로드 파일명"),
          createdAt: zod.string().describe("등록일시"),
        })
        .strict()
        .optional(),
      error: zod
        .object({
          code: zod.string().describe("에러 코드"),
          message: zod.string().describe("에러 메시지"),
          details: zod.object({}).optional().describe("상세 정보"),
        })
        .strict()
        .optional()
        .describe("에러 정보 (실패 시에만 포함)"),
      timestamp: zod
        .string()
        .datetime({})
        .describe("응답 생성 시각 (ISO 8601)"),
      statusCode: zod.number().optional().describe("HTTP 상태 코드"),
      message: zod.string().optional().describe("요청 처리 메시지"),
    })
    .strict();

/**
 * 모든 회원(공급자 및 구매자)의 신뢰 점수와 백분위수를 즉시 재계산합니다.
 * @summary 신뢰 점수 통합 재계산
 */
export const adminTrustScoresControllerRecalculateTrustScoresResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        updated_count: zod.number().describe("업데이트 성공한 공급업체 수"),
        failed_count: zod.number().describe("업데이트 실패한 공급업체 수"),
        duration_ms: zod.number().describe("작업 소요 시간 (밀리초)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 해당 공급사가 취급하는 전 품목의 단가를 엑셀로 내려받는다. 업체가 신규단가를 채워 [내 단가 엑셀 일괄 등록] 으로 올리면 그 업체 계정의 단가가 된다.
 * @summary 공급사 단가 엑셀 다운로드
 */
export const adminSuppliersControllerExportSupplierPricesParams = zod
  .object({
    id: zod.coerce.string().describe("공급사 사용자 ID(suppliers.id)"),
  })
  .strict();

/**
 * 모든 공급자 목록을 조회하며, 신뢰 점수 기반 필터링 및 정렬을 지원합니다.

**주요 기능**:
- 신뢰 점수 범위 필터링 (minTrustScore, maxTrustScore)
- 백분위 티어 필터링 (1, 5, 10, 15, 20, 30, null)
- 신뢰 점수 컴포넌트별 정렬 (6개 개별 점수, 총점, 백분위)
- 페이지네이션 지원 (1-100 items per page)

**신뢰 점수 컴포넌트** (총 100점):
1. 인증 총점 (certification_total_score): 20점
2. 총 참여 점수 (total_participation_score): 10점
3. 계약 건수 점수 (contract_count_score): 20점
4. 총 금액 점수 (total_amount_score): 20점
5. 총 수수료 점수 (total_commission_score): 20점
6. 최근 참여 점수 (recent_participation_score): 10점

**백분위 티어** (상위 %):
- 1: 상위 1%
- 5: 상위 5%
- 10: 상위 10%
- 15: 상위 15%
- 20: 상위 20%
- 30: 상위 30%
- null: 하위 70%

**예제 쿼리**:
- 상위 10% 공급자: `?percentileTier=10`
- 신뢰 점수 80 이상: `?minTrustScore=80`
- 총점 기준 내림차순 정렬: `?sortBy=trust_score&sortOrder=desc`
    
 * @summary Supplier 목록 조회 (Trust Score 필터링)
 */
export const adminSuppliersControllerGetSuppliersQueryPageDefault = 1;

export const adminSuppliersControllerGetSuppliersQueryLimitDefault = 20;
export const adminSuppliersControllerGetSuppliersQueryLimitMax = 100;

export const adminSuppliersControllerGetSuppliersQuerySortByDefault =
  "created_at";
export const adminSuppliersControllerGetSuppliersQuerySortOrderDefault = "desc";
export const adminSuppliersControllerGetSuppliersQueryMinTrustScoreDefault = 0;
export const adminSuppliersControllerGetSuppliersQueryMinTrustScoreMin = 0;
export const adminSuppliersControllerGetSuppliersQueryMinTrustScoreMax = 100;

export const adminSuppliersControllerGetSuppliersQueryMaxTrustScoreDefault = 100;
export const adminSuppliersControllerGetSuppliersQueryMaxTrustScoreMin = 0;
export const adminSuppliersControllerGetSuppliersQueryMaxTrustScoreMax = 100;

export const adminSuppliersControllerGetSuppliersQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(adminSuppliersControllerGetSuppliersQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(adminSuppliersControllerGetSuppliersQueryLimitMax)
      .default(adminSuppliersControllerGetSuppliersQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod
      .enum([
        "trust_score",
        "certification_total_score",
        "total_participation_score",
        "contract_count_score",
        "total_amount_score",
        "total_commission_score",
        "recent_participation_score",
        "trust_percentile",
        "created_at",
      ])
      .default(adminSuppliersControllerGetSuppliersQuerySortByDefault)
      .describe("정렬 기준 컬럼"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(adminSuppliersControllerGetSuppliersQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    minTrustScore: zod.coerce
      .number()
      .min(adminSuppliersControllerGetSuppliersQueryMinTrustScoreMin)
      .max(adminSuppliersControllerGetSuppliersQueryMinTrustScoreMax)
      .default(adminSuppliersControllerGetSuppliersQueryMinTrustScoreDefault)
      .describe("최소 신뢰 점수 (0-100)"),
    maxTrustScore: zod.coerce
      .number()
      .min(adminSuppliersControllerGetSuppliersQueryMaxTrustScoreMin)
      .max(adminSuppliersControllerGetSuppliersQueryMaxTrustScoreMax)
      .default(adminSuppliersControllerGetSuppliersQueryMaxTrustScoreDefault)
      .describe("최대 신뢰 점수 (0-100)"),
    percentileTier: zod
      .union([
        zod.literal(1),
        zod.literal(5),
        zod.literal(10),
        zod.literal(15),
        zod.literal(20),
        zod.literal(30),
        zod.literal(null),
      ])
      .nullish()
      .describe("백분위 구간 (1, 5, 10, 15, 20, 30, null)"),
  })
  .strict();

export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalMin = 0;
export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalMax = 100;

export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneCertificationTotalScoreMin = 0;
export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneCertificationTotalScoreMax = 20;

export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalParticipationScoreMin = 0;
export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalParticipationScoreMax = 10;

export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneContractCountScoreMin = 0;
export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneContractCountScoreMax = 20;

export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalAmountScoreMin = 0;
export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalAmountScoreMax = 20;

export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalCommissionScoreMin = 0;
export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalCommissionScoreMax = 20;

export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneRecentParticipationScoreMin = 0;
export const adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneRecentParticipationScoreMax = 10;

export const adminSuppliersControllerGetSuppliersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("Supplier ID (UUID)"),
              userId: zod.string().nullable().describe("User ID (로그인 ID)"),
              name: zod.string().nullable().describe("이름"),
              contactEmail: zod.string().nullable().describe("연락용 이메일"),
              phone: zod.string().nullable().describe("전화번호"),
              companyName: zod.string().describe("회사명"),
              businessNumber: zod.string().describe("사업자 등록번호"),
              ceoName: zod.string().describe("CEO 이름"),
              companySealUrl: zod
                .string()
                .nullable()
                .describe("회사 직인 이미지 URL"),
              companyPhone: zod.string().describe("회사 전화번호"),
              managerName: zod
                .string()
                .describe(
                  "담당자 이름 (suppliers.manager_name — users.name 은 상호다)",
                ),
              managerPhone: zod
                .string()
                .describe("담당자 연락처 (suppliers.manager_phone)"),
              externalSupplierId: zod
                .string()
                .nullable()
                .describe("외부 Supplier ID (C-Market ID)"),
              isActive: zod.boolean().describe("활성 상태"),
              autoQuoteEnabled: zod.boolean().describe("자동 견적 활성화 여부"),
              kakaoNotificationEnabled: zod
                .boolean()
                .describe("카카오 알림톡 수신 여부"),
              lastLoginAt: zod
                .string()
                .nullable()
                .describe("마지막 로그인 일시"),
              createdAt: zod.string().nullable().describe("생성 일시"),
              updatedAt: zod
                .string()
                .nullable()
                .describe("마지막 업데이트 일시"),
              trustScore: zod
                .object({
                  total: zod
                    .number()
                    .min(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalMin,
                    )
                    .max(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalMax,
                    )
                    .describe("총점 (6개 컴포넌트 합산, 0-100)"),
                  certificationTotalScore: zod
                    .number()
                    .min(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneCertificationTotalScoreMin,
                    )
                    .max(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneCertificationTotalScoreMax,
                    )
                    .describe("인증 총점 (0-20)"),
                  totalParticipationScore: zod
                    .number()
                    .min(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalParticipationScoreMin,
                    )
                    .max(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalParticipationScoreMax,
                    )
                    .describe("총 참여 점수 (0-10)"),
                  contractCountScore: zod
                    .number()
                    .min(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneContractCountScoreMin,
                    )
                    .max(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneContractCountScoreMax,
                    )
                    .describe("계약 건수 점수 (0-20)"),
                  totalAmountScore: zod
                    .number()
                    .min(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalAmountScoreMin,
                    )
                    .max(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalAmountScoreMax,
                    )
                    .describe("총 금액 점수 (0-20)"),
                  totalCommissionScore: zod
                    .number()
                    .min(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalCommissionScoreMin,
                    )
                    .max(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneTotalCommissionScoreMax,
                    )
                    .describe("총 수수료 점수 (0-20)"),
                  recentParticipationScore: zod
                    .number()
                    .min(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneRecentParticipationScoreMin,
                    )
                    .max(
                      adminSuppliersControllerGetSuppliersResponseTwoDataItemsItemTrustScoreOneRecentParticipationScoreMax,
                    )
                    .describe("최근 참여 점수 (0-10)"),
                  percentile: zod
                    .union([
                      zod.literal(1),
                      zod.literal(5),
                      zod.literal(10),
                      zod.literal(15),
                      zod.literal(20),
                      zod.literal(30),
                      zod.literal(null),
                    ])
                    .nullable()
                    .describe("백분위 구간 (1, 5, 10, 15, 20, 30, null)"),
                  updatedAt: zod
                    .string()
                    .nullable()
                    .describe("신뢰 점수 업데이트 시각"),
                })
                .strict()
                .describe("신뢰 점수 정보 (6개 개별 점수 + 총점 + 백분위)"),
              source: zod
                .enum(["direct", "cmarket"])
                .describe(
                  "가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 관리자가 특정 공급사의 상세 정보를 조회합니다.
 * @summary 공급사 상세 조회 (Admin)
 */
export const adminSuppliersControllerGetSupplierParams = zod
  .object({
    id: zod.coerce.string().describe("공급사 사용자 ID (public.users.id)"),
  })
  .strict();

export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalMin = 0;
export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalMax = 100;

export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneCertificationTotalScoreMin = 0;
export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneCertificationTotalScoreMax = 20;

export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalParticipationScoreMin = 0;
export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalParticipationScoreMax = 10;

export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneContractCountScoreMin = 0;
export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneContractCountScoreMax = 20;

export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalAmountScoreMin = 0;
export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalAmountScoreMax = 20;

export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalCommissionScoreMin = 0;
export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalCommissionScoreMax = 20;

export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneRecentParticipationScoreMin = 0;
export const adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneRecentParticipationScoreMax = 10;

export const adminSuppliersControllerGetSupplierResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("Supplier ID (UUID)"),
        userId: zod.string().nullable().describe("User ID (로그인 ID)"),
        name: zod.string().nullable().describe("이름"),
        contactEmail: zod.string().nullable().describe("연락용 이메일"),
        phone: zod.string().nullable().describe("전화번호"),
        companyName: zod.string().describe("회사명"),
        businessNumber: zod.string().describe("사업자 등록번호"),
        ceoName: zod.string().describe("CEO 이름"),
        companySealUrl: zod
          .string()
          .nullable()
          .describe("회사 직인 이미지 URL"),
        companyPhone: zod.string().describe("회사 전화번호"),
        managerName: zod
          .string()
          .describe(
            "담당자 이름 (suppliers.manager_name — users.name 은 상호다)",
          ),
        managerPhone: zod
          .string()
          .describe("담당자 연락처 (suppliers.manager_phone)"),
        externalSupplierId: zod
          .string()
          .nullable()
          .describe("외부 Supplier ID (C-Market ID)"),
        isActive: zod.boolean().describe("활성 상태"),
        autoQuoteEnabled: zod.boolean().describe("자동 견적 활성화 여부"),
        kakaoNotificationEnabled: zod
          .boolean()
          .describe("카카오 알림톡 수신 여부"),
        lastLoginAt: zod.string().nullable().describe("마지막 로그인 일시"),
        createdAt: zod.string().nullable().describe("생성 일시"),
        updatedAt: zod.string().nullable().describe("마지막 업데이트 일시"),
        trustScore: zod
          .object({
            total: zod
              .number()
              .min(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalMin,
              )
              .max(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalMax,
              )
              .describe("총점 (6개 컴포넌트 합산, 0-100)"),
            certificationTotalScore: zod
              .number()
              .min(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneCertificationTotalScoreMin,
              )
              .max(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneCertificationTotalScoreMax,
              )
              .describe("인증 총점 (0-20)"),
            totalParticipationScore: zod
              .number()
              .min(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalParticipationScoreMin,
              )
              .max(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalParticipationScoreMax,
              )
              .describe("총 참여 점수 (0-10)"),
            contractCountScore: zod
              .number()
              .min(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneContractCountScoreMin,
              )
              .max(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneContractCountScoreMax,
              )
              .describe("계약 건수 점수 (0-20)"),
            totalAmountScore: zod
              .number()
              .min(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalAmountScoreMin,
              )
              .max(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalAmountScoreMax,
              )
              .describe("총 금액 점수 (0-20)"),
            totalCommissionScore: zod
              .number()
              .min(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalCommissionScoreMin,
              )
              .max(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneTotalCommissionScoreMax,
              )
              .describe("총 수수료 점수 (0-20)"),
            recentParticipationScore: zod
              .number()
              .min(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneRecentParticipationScoreMin,
              )
              .max(
                adminSuppliersControllerGetSupplierResponseTwoDataTrustScoreOneRecentParticipationScoreMax,
              )
              .describe("최근 참여 점수 (0-10)"),
            percentile: zod
              .union([
                zod.literal(1),
                zod.literal(5),
                zod.literal(10),
                zod.literal(15),
                zod.literal(20),
                zod.literal(30),
                zod.literal(null),
              ])
              .nullable()
              .describe("백분위 구간 (1, 5, 10, 15, 20, 30, null)"),
            updatedAt: zod
              .string()
              .nullable()
              .describe("신뢰 점수 업데이트 시각"),
          })
          .strict()
          .describe("신뢰 점수 정보 (6개 개별 점수 + 총점 + 백분위)"),
        source: zod
          .enum(["direct", "cmarket"])
          .describe(
            "가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 관리자가 특정 공급사를 강제 탈퇴 처리하고 개인정보를 익명화합니다.
 * @summary 공급사 강제 탈퇴 (Admin)
 */
export const adminSuppliersControllerWithdrawSupplierParams = zod
  .object({
    id: zod.coerce.string().describe("공급사 사용자 ID (public.users.id)"),
  })
  .strict();

/**
 * 관리자가 특정 공급사의 대시보드에 접근할 수 있는 1회용 임베드 URL을 생성합니다.
 * @summary 공급사 임베드 URL 생성 (관리자용)
 */
export const adminSuppliersControllerGetSupplierEmbedUrlParams = zod
  .object({
    id: zod.coerce.string().describe("공급사 사용자 ID (public.users.id)"),
  })
  .strict();

/**
 * 기업회원의 알림톡 수신 여부를 관리자가 켜고 끕니다.

회원 본인이 마이페이지에서 바꾸는 값과 **같은 컬럼**(`suppliers.kakao_notification_enabled`)을
씁니다 — 관리자 전용 컬럼을 따로 두면 두 값이 갈려 「화면엔 꺼져 있는데 실제로는 발송되는」
상태가 생깁니다.

토글이 아니라 **원하는 상태를 그대로** 받습니다(`enabled`). 목록이 30초 폴링이라 화면이
보고 있던 값이 낡았을 수 있고, 뒤집기 방식이면 그때 의도와 반대로 적용됩니다.
 * @summary 공급사 알림톡 수신 on/off (Admin)
 */
export const adminSuppliersControllerSetKakaoNotificationParams = zod
  .object({
    id: zod.coerce.string().describe("공급사 사용자 ID (public.users.id)"),
  })
  .strict();

export const adminSuppliersControllerSetKakaoNotificationBody = zod
  .object({
    enabled: zod
      .boolean()
      .describe("알림톡 수신 여부 — true 면 발송, false 면 미발송"),
  })
  .strict();

/**
 * 기업회원 계정을 정지하거나 되돌립니다(`users.is_active`).

**정지되면 두 문이 함께 닫힙니다** — 세모 자체 로그인과 씨마켓 경유 세션 발급
(`/external/suppliers/auth`) 이 같은 값을 봅니다.

**강제 탈퇴와 다른 축입니다.** 탈퇴는 개인정보를 익명화해 되돌릴 수 없고, 정지는 언제든
`isActive: true` 로 되돌릴 수 있습니다.

외부 인증 RPC 는 `is_active` 를 덮어쓰지 않으므로, 정지된 회원이 씨마켓에서 다시
로그인해도 정지 상태가 유지됩니다.
 * @summary 공급사 정지 / 정지 해제 (Admin)
 */
export const adminSuppliersControllerSetActiveParams = zod
  .object({
    id: zod.coerce.string().describe("공급사 사용자 ID (public.users.id)"),
  })
  .strict();

export const adminSuppliersControllerSetActiveBody = zod
  .object({
    isActive: zod
      .boolean()
      .describe("활성 여부 — false 면 로그인·세션 발급이 모두 막힌다(정지)"),
  })
  .strict();

/**
 * 모든 구매자 목록을 조회하며, 신뢰 점수 기반 필터링 및 정렬을 지원합니다.

**주요 기능**:
- 신뢰 점수 범위 필터링 (minTrustScore, maxTrustScore)
- 백분위 티어 필터링 (1, 5, 10, 15, 20, 30, null = 하위 70%)
- 신뢰 점수 정렬 (총점, 백분위, 생성일)
- 페이지네이션 지원 (1-100 items per page)

**신뢰 점수** (0-100점):
- 총점에 기반한 순위 산정
- 6개 컴포넌트 합산 (각 10-20점 가중치 적용)

**백분위 티어** (상위 %):
- 1: 상위 1%
- 5: 상위 5%
- 10: 상위 10%
- 15: 상위 15%
- 20: 상위 20%
- 30: 상위 30%
- null: 하위 70%

**예제 쿼리**:
- 상위 10% 구매자: `?percentileTier=10`
- 신뢰 점수 80 이상: `?minTrustScore=80`
- 총점 기준 내림차순 정렬: `?sortBy=trust_score&sortOrder=desc`
    
 * @summary 구매자 목록 조회 (Trust Score 필터링)
 */
export const adminBuyersControllerGetBuyersQueryPageDefault = 1;

export const adminBuyersControllerGetBuyersQueryLimitDefault = 20;
export const adminBuyersControllerGetBuyersQueryLimitMax = 100;

export const adminBuyersControllerGetBuyersQuerySortByDefault = "created_at";
export const adminBuyersControllerGetBuyersQuerySortOrderDefault = "desc";
export const adminBuyersControllerGetBuyersQueryMinTrustScoreDefault = 0;
export const adminBuyersControllerGetBuyersQueryMinTrustScoreMin = 0;
export const adminBuyersControllerGetBuyersQueryMinTrustScoreMax = 100;

export const adminBuyersControllerGetBuyersQueryMaxTrustScoreDefault = 100;
export const adminBuyersControllerGetBuyersQueryMaxTrustScoreMin = 0;
export const adminBuyersControllerGetBuyersQueryMaxTrustScoreMax = 100;

export const adminBuyersControllerGetBuyersQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(adminBuyersControllerGetBuyersQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(adminBuyersControllerGetBuyersQueryLimitMax)
      .default(adminBuyersControllerGetBuyersQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod
      .enum(["trust_score", "trust_percentile", "created_at"])
      .default(adminBuyersControllerGetBuyersQuerySortByDefault)
      .describe("정렬 기준 컬럼 (구매자는 3개만 지원)"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(adminBuyersControllerGetBuyersQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    minTrustScore: zod.coerce
      .number()
      .min(adminBuyersControllerGetBuyersQueryMinTrustScoreMin)
      .max(adminBuyersControllerGetBuyersQueryMinTrustScoreMax)
      .default(adminBuyersControllerGetBuyersQueryMinTrustScoreDefault)
      .describe("최소 신뢰 점수 (0-100)"),
    maxTrustScore: zod.coerce
      .number()
      .min(adminBuyersControllerGetBuyersQueryMaxTrustScoreMin)
      .max(adminBuyersControllerGetBuyersQueryMaxTrustScoreMax)
      .default(adminBuyersControllerGetBuyersQueryMaxTrustScoreDefault)
      .describe("최대 신뢰 점수 (0-100)"),
    percentileTier: zod
      .union([
        zod.literal(1),
        zod.literal(5),
        zod.literal(10),
        zod.literal(15),
        zod.literal(20),
        zod.literal(30),
        zod.literal(null),
      ])
      .nullish()
      .describe("백분위 구간 (1, 5, 10, 15, 20, 30, null = 하위 70%)"),
  })
  .strict();

export const adminBuyersControllerGetBuyersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("구매자 ID"),
              userId: zod.string().nullable().describe("사용자 ID (users.id)"),
              contactEmail: zod.string().nullable().describe("연락용 이메일"),
              phone: zod.string().nullable().describe("휴대폰 번호"),
              name: zod.string().nullable().describe("이름"),
              gender: zod.enum(["M", "F"]).nullable().describe("성별 (M/F)"),
              birthDate: zod
                .string()
                .nullable()
                .describe("생년월일 (YYYY-MM-DD)"),
              trustScore: zod.number().nullable().describe("신뢰 점수 (0-100)"),
              trustPercentile: zod
                .union([
                  zod.literal(1),
                  zod.literal(5),
                  zod.literal(10),
                  zod.literal(15),
                  zod.literal(20),
                  zod.literal(30),
                ])
                .nullable()
                .describe(
                  "신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)",
                ),
              isActive: zod.boolean().describe("활성 상태"),
              kakaoNotificationEnabled: zod
                .boolean()
                .describe("카카오 알림톡 수신 여부"),
              lastLoginAt: zod
                .string()
                .nullable()
                .describe("마지막 로그인 일시"),
              createdAt: zod.string().describe("생성 날짜"),
              source: zod
                .enum(["direct", "cmarket"])
                .describe(
                  "가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입",
                ),
              organizationName: zod
                .string()
                .nullish()
                .describe("씨마켓 발주기관명 (자체가입은 null)"),
              externalBuyerId: zod
                .string()
                .nullish()
                .describe("씨마켓 회원 ID (자체가입은 null)"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 구매자의 상세 정보를 조회합니다. 신뢰 점수, 주소, 카드, 구독 정보를 포함합니다.
 * @summary 구매자 상세 조회
 */
export const adminBuyersControllerGetBuyerByIdParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminBuyersControllerGetBuyerByIdResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("구매자 ID"),
        userId: zod.string().nullable().describe("사용자 ID (users.id)"),
        contactEmail: zod.string().nullable().describe("연락용 이메일"),
        phone: zod.string().nullable().describe("휴대폰 번호"),
        name: zod.string().nullable().describe("이름"),
        gender: zod.enum(["M", "F"]).nullable().describe("성별 (M/F)"),
        birthDate: zod.string().nullable().describe("생년월일 (YYYY-MM-DD)"),
        trustScore: zod.number().nullable().describe("신뢰 점수 (0-100)"),
        trustPercentile: zod
          .union([
            zod.literal(1),
            zod.literal(5),
            zod.literal(10),
            zod.literal(15),
            zod.literal(20),
            zod.literal(30),
          ])
          .nullable()
          .describe("신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)"),
        isActive: zod.boolean().describe("활성 상태"),
        kakaoNotificationEnabled: zod
          .boolean()
          .describe("카카오 알림톡 수신 여부"),
        lastLoginAt: zod.string().nullable().describe("마지막 로그인 일시"),
        createdAt: zod.string().describe("생성 날짜"),
        source: zod
          .enum(["direct", "cmarket"])
          .describe(
            "가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입",
          ),
        organizationName: zod
          .string()
          .nullish()
          .describe("씨마켓 발주기관명 (자체가입은 null)"),
        externalBuyerId: zod
          .string()
          .nullish()
          .describe("씨마켓 회원 ID (자체가입은 null)"),
        addresses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("주소 ID (UUID)"),
                userId: zod.string().describe("사용자 ID (UUID)"),
                label: zod
                  .string()
                  .optional()
                  .describe("주소 라벨 (회사, 집, 창고 등)"),
                isDefault: zod.boolean().describe("기본 배송지 여부"),
                postalCode: zod.string().describe("우편번호 (5자리 숫자)"),
                province: zod.string().describe("시/도 (광역시 또는 도 단위)"),
                city: zod.string().describe("시/군/구 (기초자치단체)"),
                district: zod
                  .string()
                  .optional()
                  .describe("읍/면/동 (선택사항)"),
                streetAddress: zod.string().describe("도로명 주소"),
                addressDetail: zod
                  .string()
                  .optional()
                  .describe("상세 주소 (건물명, 동/호 등)"),
                recipientName: zod.string().optional().describe("수령인 이름"),
                recipientPhone: zod
                  .string()
                  .optional()
                  .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
                createdAt: zod
                  .string()
                  .optional()
                  .describe("생성일 (ISO 8601 형식)"),
                updatedAt: zod
                  .string()
                  .optional()
                  .describe("수정일 (ISO 8601 형식)"),
              })
              .strict(),
          )
          .describe("Registered addresses"),
        cards: zod
          .array(
            zod
              .object({
                id: zod.string().describe("카드 고유 식별자 (UUID)"),
                maskedCardNumber: zod
                  .string()
                  .describe("마스킹된 카드번호 (PCI-DSS 준수)"),
                cardCode: zod
                  .string()
                  .optional()
                  .describe("카드사 코드 (01: 비씨, 02: 국민, 06: 신한 등)"),
                isPrimary: zod.boolean().describe("주 결제수단 여부"),
                registeredAt: zod
                  .string()
                  .datetime({})
                  .describe("카드 등록일시"),
              })
              .strict(),
          )
          .describe("Payment cards"),
        subscriptions: zod
          .array(
            zod
              .object({
                id: zod.string().describe("Subscription ID"),
                buyerId: zod.string().describe("Buyer ID"),
                planType: zod
                  .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
                  .describe("Subscription plan type"),
                amount: zod
                  .number()
                  .describe("Monthly subscription amount in KRW"),
                billingCycle: zod.enum(["MONTHLY"]).describe("Billing cycle"),
                nextPaymentDate: zod
                  .string()
                  .describe("Next payment date (YYYY-MM-DD)"),
                status: zod
                  .enum(["ACTIVE", "CANCELED", "FAILED"])
                  .describe("Subscription status"),
                createdAt: zod.string().describe("Created at timestamp"),
                updatedAt: zod.string().describe("Last updated at timestamp"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("Canceled at timestamp (if canceled)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("Cancellation reason (if provided)"),
                pendingPlanType: zod
                  .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
                  .nullish()
                  .describe("Pending plan type (for scheduled plan changes)"),
                scheduledPlanChangeAt: zod
                  .string()
                  .nullish()
                  .describe("Scheduled plan change date (YYYY-MM-DD)"),
                isPromotional: zod
                  .boolean()
                  .describe(
                    "Whether the subscription is currently under a promotion",
                  ),
                isTrial: zod
                  .boolean()
                  .describe(
                    "Whether the subscription is a free trial (e.g. signup bonus)",
                  ),
                promotionCode: zod
                  .string()
                  .nullish()
                  .describe("Applied promotion code (if any)"),
                isPermanent: zod
                  .boolean()
                  .describe(
                    "Whether this is a permanent subscription (no expiry, nextPaymentDate >= 2090)",
                  ),
              })
              .strict(),
          )
          .describe("Subscription plans"),
        termsAgreements: zod
          .array(
            zod
              .object({
                type: zod
                  .string()
                  .describe("Terms type (terms, privacy, marketing)"),
                agreed: zod.boolean().describe("Whether user agreed"),
                version: zod.string().describe("Terms version"),
                agreedAt: zod
                  .string()
                  .datetime({})
                  .describe("Date of agreement"),
                revokedAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe("Date of revocation (if applicable)"),
                consentChannel: zod
                  .string()
                  .nullish()
                  .describe("Channel through which consent was given"),
                ipAddress: zod
                  .string()
                  .nullish()
                  .describe("IP address at time of agreement"),
                userAgent: zod
                  .string()
                  .nullish()
                  .describe("User agent at time of agreement"),
              })
              .strict(),
          )
          .describe("Terms and agreements history"),
        withdrawalReason: zod
          .string()
          .nullish()
          .describe("Withdrawal reason (if withdrawn)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 관리자가 특정 구매자를 강제 탈퇴 처리하고 개인정보를 익명화합니다.
 * @summary 구매자 강제 탈퇴 (Admin)
 */
export const adminBuyersControllerWithdrawBuyerParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

/**
 * 비밀번호 5회 연속 실패로 잠겼는지, 남은 시간과 현재 연속 실패 횟수를 돌려줍니다.
 * @summary 구매자 로그인 잠금 상태 (Admin)
 */
export const adminBuyersControllerGetBuyerLoginLockParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminBuyersControllerGetBuyerLoginLockResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        locked: zod.boolean().describe("지금 잠겨 있는가"),
        failedCount: zod
          .number()
          .describe("마지막 성공 뒤 연속 실패 횟수(풀린 잠금은 0)"),
        lockedUntil: zod
          .string()
          .nullable()
          .describe("잠금이 풀리는 시각(ISO). 잠겨 있지 않으면 null"),
        remainingMinutes: zod
          .number()
          .nullable()
          .describe("잠금이 풀리기까지 남은 분(올림). 잠겨 있지 않으면 null"),
        maxFailedAttempts: zod
          .number()
          .describe("잠금까지 허용하는 연속 실패 횟수"),
        lockMinutes: zod.number().describe("잠그는 시간(분)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 비밀번호 5회 연속 실패 잠금을 바로 풀고 연속 실패 횟수를 0 으로 되돌립니다.
 * @summary 구매자 로그인 잠금 해제 (Admin)
 */
export const adminBuyersControllerClearBuyerLoginLockParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

/**
 * 전체 환불 목록을 조회합니다 (필터링 지원).
 * @summary [어드민] 환불 목록 조회
 */
export const adminPaymentControllerGetRefundsQueryOffsetDefault = 0;
export const adminPaymentControllerGetRefundsQueryLimitDefault = 20;

export const adminPaymentControllerGetRefundsQueryParams = zod
  .object({
    offset: zod
      .unknown()
      .default(adminPaymentControllerGetRefundsQueryOffsetDefault)
      .describe("Offset for pagination"),
    limit: zod
      .unknown()
      .default(adminPaymentControllerGetRefundsQueryLimitDefault)
      .describe("Limit for pagination"),
    status: zod.coerce.string().optional().describe("Refund Status Filter"),
    search: zod.coerce.string().optional().describe("Search term (Reason, ID)"),
  })
  .strict();

export const adminPaymentControllerGetRefundsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("환불 ID"),
              paymentTransactionId: zod.string().describe("결제 트랜잭션 ID"),
              status: zod.string().describe("환불 상태"),
              statusDescription: zod.string().describe("환불 상태 설명"),
              refundAmount: zod.number().describe("환불 금액"),
              refundReason: zod.string().describe("환불 사유"),
              requestedAt: zod.string().describe("환불 요청 일시"),
              requestedBy: zod.string().optional().describe("환불 요청자 ID"),
              approvedAt: zod.string().optional().describe("환불 승인 일시"),
              approvedBy: zod.string().optional().describe("환불 승인자 ID"),
              approvalNote: zod.string().optional().describe("승인 메모"),
              rejectedAt: zod.string().optional().describe("환불 거부 일시"),
              rejectedBy: zod.string().optional().describe("환불 거부자 ID"),
              rejectionReason: zod.string().optional().describe("거부 사유"),
              completedAt: zod.string().optional().describe("환불 완료 일시"),
              failedAt: zod.string().optional().describe("환불 실패 일시"),
              errorCode: zod.string().optional().describe("에러 코드"),
              errorMessage: zod.string().optional().describe("에러 메시지"),
              refundBank: zod.string().optional().describe("환불 은행"),
              refundAccountNumber: zod
                .string()
                .optional()
                .describe("환불 계좌번호"),
              refundAccountHolder: zod
                .string()
                .optional()
                .describe("환불 예금주"),
              createdAt: zod.string().describe("생성 일시"),
              updatedAt: zod.string().describe("수정 일시"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 사용자의 모든 결제 내역(CASH, CARD 포함)을 조회합니다.
 * @summary [어드민] 특정 사용자 결제 목록 조회
 */
export const adminPaymentControllerGetUserPaymentsParams = zod
  .object({
    userId: zod.coerce.string(),
  })
  .strict();

export const adminPaymentControllerGetUserPaymentsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod
              .string()
              .describe("결제 트랜잭션 ID (MOID - Merchant Order ID)"),
            quoteResponseVersionId: zod
              .string()
              .uuid()
              .describe("견적 응답 버전 ID (UUID)"),
            paymentCardId: zod
              .string()
              .uuid()
              .nullable()
              .describe("결제 카드 ID (UUID)"),
            status: zod
              .enum([
                "PENDING",
                "APPROVED",
                "REJECTED",
                "FAILED",
                "CANCELED",
                "EXPIRED",
              ])
              .describe("결제 상태"),
            tid: zod
              .string()
              .nullable()
              .describe("PG 거래 번호 (Innopay 거래 ID)"),
            approvedAt: zod
              .string()
              .nullable()
              .describe("결제 승인 시각 (ISO 8601)"),
            errorCode: zod
              .string()
              .nullable()
              .describe("에러 코드 (Innopay API 에러 코드)"),
            errorMessage: zod
              .string()
              .nullable()
              .describe("에러 메시지 (Innopay API 에러 메시지)"),
            createdAt: zod.string().describe("생성 시각 (ISO 8601)"),
            updatedAt: zod.string().describe("수정 시각 (ISO 8601)"),
            userId: zod.string().uuid().describe("사용자 ID (UUID)"),
            refundId: zod.string().uuid().nullable().describe("환불 ID (UUID)"),
            paymentMethod: zod
              .enum(["CARD", "CASH", "DIRECT"])
              .describe("결제 수단 (CARD | CASH | DIRECT)"),
            expiresAt: zod
              .string()
              .nullable()
              .describe("결제 만료 시각 (ISO 8601)"),
            canceledAt: zod
              .string()
              .nullable()
              .describe("결제 취소 시각 (ISO 8601)"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 15분 이상 PENDING 상태로 멈춰있는 결제 건들을 조회합니다.
 * @summary [어드민] 미결(Stuck) 결제 목록 조회
 */
export const adminPaymentControllerGetStuckPaymentsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("결제 거래 번호 (MOID)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              userName: zod.string().describe("사용자명"),
              userEmail: zod.string().describe("사용자 이메일"),
              amount: zod.number().describe("결제 금액"),
              taxAmount: zod.number().describe("세금"),
              projectName: zod
                .string()
                .nullable()
                .describe("프로젝트명 (nullable)"),
              quoteResponseVersionId: zod
                .string()
                .describe("견적 응답 버전 ID"),
              createdAt: zod.string().describe("생성 시간"),
              expiresAt: zod
                .string()
                .describe("만료 시간 (생성 시간으로부터 15분)"),
              rejectedAt: zod
                .string()
                .nullable()
                .describe("반려 시간 (null이면 아직 반려되지 않음)"),
              rejectionReason: zod
                .string()
                .nullable()
                .describe("반려 사유 (null이면 아직 반려되지 않음)"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 미결 건을 강제로 취소(FAILED) 처리합니다.
 * @summary [어드민] 결제 강제 취소 처리
 */
export const adminPaymentControllerForceCancelPaymentParams = zod
  .object({
    moid: zod.coerce.string(),
  })
  .strict();

/**
 * 현금결제 목록을 조회합니다.
 * @summary [어드민] 현금 결제 전체 목록
 */
export const adminPaymentControllerGetCashPaymentsQueryOffsetDefault = 0;
export const adminPaymentControllerGetCashPaymentsQueryLimitDefault = 20;

export const adminPaymentControllerGetCashPaymentsQueryParams = zod
  .object({
    offset: zod
      .unknown()
      .default(adminPaymentControllerGetCashPaymentsQueryOffsetDefault)
      .describe("Offset for pagination"),
    limit: zod
      .unknown()
      .default(adminPaymentControllerGetCashPaymentsQueryLimitDefault)
      .describe("Limit for pagination"),
    status: zod
      .enum([
        "PENDING",
        "APPROVED",
        "REJECTED",
        "FAILED",
        "CANCELED",
        "EXPIRED",
      ])
      .optional()
      .describe("Payment Status Filter"),
    search: zod.coerce
      .string()
      .optional()
      .describe("Search term (MOID, Buyer Name, Project Name)"),
  })
  .strict();

export const adminPaymentControllerGetCashPaymentsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("MOID"),
              userId: zod.string().describe("User ID"),
              userName: zod.string().describe("User Name"),
              userEmail: zod.string().describe("User Email"),
              contactEmail: zod
                .string()
                .nullable()
                .describe("User Contact Email"),
              amount: zod.number().describe("Payment Amount"),
              taxAmount: zod.number().describe("Tax Amount"),
              projectName: zod.string().nullable().describe("Project Name"),
              quoteResponseVersionId: zod
                .string()
                .describe("Quote Response Version ID"),
              createdAt: zod.string().describe("Created At"),
              expiresAt: zod.string().describe("Expires At"),
              status: zod.string().describe("Payment Status"),
              approvedAt: zod.string().nullable().describe("Approved At"),
              rejectedAt: zod.string().nullable().describe("Rejected At"),
              canceledAt: zod.string().nullable().describe("Canceled At"),
              rejectionReason: zod
                .string()
                .nullable()
                .describe("Rejection Reason"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 관리자가 수동으로 입금을 완료한 후, 환불 상태를 완료로 변경합니다.
 * @summary [어드민] 환불 처리 완료 확인
 */
export const adminPaymentControllerProcessRefundParams = zod
  .object({
    refundId: zod.coerce.string(),
  })
  .strict();

/**
 * 현금결제 상태가 PENDING인 결제 목록을 조회합니다
 * @summary [어드민] 입금 대기 중인 현금 결제 목록
 */
export const adminPaymentControllerGetPendingCashPaymentsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("결제 거래 번호 (MOID)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              userName: zod.string().describe("사용자명"),
              userEmail: zod.string().describe("사용자 이메일"),
              amount: zod.number().describe("결제 금액"),
              taxAmount: zod.number().describe("세금"),
              projectName: zod
                .string()
                .nullable()
                .describe("프로젝트명 (nullable)"),
              quoteResponseVersionId: zod
                .string()
                .describe("견적 응답 버전 ID"),
              createdAt: zod.string().describe("생성 시간"),
              expiresAt: zod
                .string()
                .describe("만료 시간 (생성 시간으로부터 15분)"),
              rejectedAt: zod
                .string()
                .nullable()
                .describe("반려 시간 (null이면 아직 반려되지 않음)"),
              rejectionReason: zod
                .string()
                .nullable()
                .describe("반려 사유 (null이면 아직 반려되지 않음)"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 입금을 확인하고 결제를 승인합니다. 승인 시점에 계약이 체결됩니다.
 * @summary [어드민] 현금 결제 승인 (입금 확인 → 계약 성립)
 */
export const adminPaymentControllerApproveCashPaymentParams = zod
  .object({
    moid: zod.coerce.string(),
  })
  .strict();

/**
 * 현금결제를 반려하고 사용자는 재시도할 수 있습니다
 * @summary [어드민] 현금 결제 반려
 */
export const adminPaymentControllerRejectCashPaymentParams = zod
  .object({
    moid: zod.coerce.string(),
  })
  .strict();

export const adminPaymentControllerRejectCashPaymentBody = zod
  .object({
    reason: zod.string().describe("반려 사유"),
  })
  .strict();

/**
 * @summary 카테고리 엑셀 일괄 등록
 */
export const adminCategoriesControllerBulkUploadCategoriesBody = zod
  .object({
    file: zod
      .instanceof(File)
      .optional()
      .describe("카테고리 일괄 등록 엑셀 파일 (.xlsx)"),
  })
  .strict();

export const adminCategoriesControllerBulkUploadCategoriesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        successCount: zod.number().describe("성공한 행 개수"),
        errorCount: zod.number().describe("실패한 행 개수"),
        errors: zod.array(zod.string()).describe("에러 상세 메시지 목록"),
        successItems: zod
          .array(zod.string())
          .optional()
          .describe("성공한 항목 이름 목록"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 모든 카테고리를 계층 구조로 반환합니다.
 * @summary 📊 카테고리 트리 조회 (계층 구조)
 */
export const adminCategoriesControllerGetCategoryTreeResponseTwoDataItemLevelMax = 4;

export const adminCategoriesControllerGetCategoryTreeResponseTwoDataItemDisplayOrderMin = 0;

export const adminCategoriesControllerGetCategoryTreeResponseTwoDataItemProductCountMin = 0;

export const adminCategoriesControllerGetCategoryTreeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().uuid().describe("카테고리 ID (UUID)"),
            name: zod.string().describe("카테고리 이름"),
            level: zod
              .number()
              .min(1)
              .max(
                adminCategoriesControllerGetCategoryTreeResponseTwoDataItemLevelMax,
              )
              .describe("카테고리 레벨"),
            displayOrder: zod
              .number()
              .min(
                adminCategoriesControllerGetCategoryTreeResponseTwoDataItemDisplayOrderMin,
              )
              .describe("표시 순서"),
            icon: zod.string().nullish().describe("아이콘 이름"),
            description: zod.string().nullish().describe("카테고리 설명"),
            isActive: zod.boolean().describe("활성 상태"),
            children: zod
              .array(zod.unknown())
              .describe("자식 카테고리 목록 (재귀적)"),
            productCount: zod
              .number()
              .min(
                adminCategoriesControllerGetCategoryTreeResponseTwoDataItemProductCountMin,
              )
              .optional()
              .describe("하위 상품 개수"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * categoryId 파라미터가 있으면 해당 카테고리의 물품 반환.
 * @summary 📦 카테고리별 물품 필터링 (관리자)
 */
export const adminCategoriesControllerGetItemsByCategoryQueryParams = zod
  .object({
    categoryId: zod.coerce.string(),
    includeDescendants: zod.coerce.boolean(),
    limit: zod.coerce.number(),
    offset: zod.coerce.number(),
  })
  .strict();

export const adminCategoriesControllerGetItemsByCategoryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              casNo: zod
                .string()
                .nullish()
                .describe(
                  "CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)",
                ),
              keNo: zod
                .string()
                .nullish()
                .describe(
                  "국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null",
                ),
              unNo: zod
                .string()
                .nullish()
                .describe(
                  "UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null",
                ),
              enNo: zod
                .string()
                .nullish()
                .describe("EC 번호 (EU EINECS/ELINCS)"),
              chemNameKor: zod
                .string()
                .nullish()
                .describe("KOSHA 기준 국문 표준 물질명"),
              id: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
              name: zod.string().describe("상품명"),
              categoryId: zod
                .string()
                .nullable()
                .describe("카테고리 ID (items_v2_categories.id - UUID)"),
              categoryPath: zod.string().describe("카테고리 경로 (표시용)"),
              price: zod.number().describe("기준 가격 (정가)"),
              lowestPrice: zod.number().nullable().describe("최저가 거래 단가"),
              lowestPriceDate: zod
                .string()
                .nullable()
                .describe("최저가 거래 날짜"),
              lowestPriceSupplierName: zod
                .string()
                .nullable()
                .describe("최저가 거래 공급자명"),
              level: zod.number().describe("카테고리 레벨 (0-3)"),
              parentId: zod.string().nullable().describe("부모 카테고리 UUID"),
              manufacturer: zod.string().nullable().describe("제조사"),
              brand: zod.string().nullable().describe("브랜드"),
              code: zod.string().nullable().describe("상품코드"),
              unit: zod.string().describe("단위"),
              imageUrl: zod.string().nullable().describe("이미지 URL"),
              spec1: zod.string().nullable().describe("규격1"),
              spec2: zod.string().nullable().describe("규격2"),
              spec3: zod.string().nullable().describe("규격3"),
              supplierCount: zod.number().describe("취급 공급자 수"),
              createdAt: zod.string().describe("생성 일시"),
              updatedAt: zod.string().describe("수정 일시"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 카테고리의 상세 정보를 반환합니다.
 * @summary 📋 카테고리 단일 조회
 */
export const adminCategoriesControllerGetCategoryByIdParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminCategoriesControllerGetCategoryByIdResponseTwoDataLevelMax = 4;

export const adminCategoriesControllerGetCategoryByIdResponseTwoDataDisplayOrderMin = 0;

export const adminCategoriesControllerGetCategoryByIdResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("카테고리 ID (UUID)"),
        name: zod.string().describe("카테고리 이름"),
        parentId: zod
          .string()
          .uuid()
          .nullish()
          .describe("부모 카테고리 ID (null이면 최상위)"),
        level: zod
          .number()
          .min(1)
          .max(adminCategoriesControllerGetCategoryByIdResponseTwoDataLevelMax)
          .describe("카테고리 레벨 (1-4)"),
        displayOrder: zod
          .number()
          .min(
            adminCategoriesControllerGetCategoryByIdResponseTwoDataDisplayOrderMin,
          )
          .describe("표시 순서"),
        icon: zod.string().nullish().describe("아이콘 이름"),
        description: zod.string().nullish().describe("카테고리 설명"),
        isActive: zod.boolean().describe("활성 상태"),
        createdAt: zod.string().datetime({}).describe("생성 일시"),
        updatedAt: zod.string().datetime({}).describe("수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 기존 카테고리를 수정합니다.
 * @summary ✏️ 카테고리 수정
 */
export const adminCategoriesControllerUpdateCategoryParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminCategoriesControllerUpdateCategoryBodyNameMax = 100;

export const adminCategoriesControllerUpdateCategoryBodyDisplayOrderMin = 0;

export const adminCategoriesControllerUpdateCategoryBody = zod
  .object({
    name: zod
      .string()
      .min(1)
      .max(adminCategoriesControllerUpdateCategoryBodyNameMax)
      .optional()
      .describe("카테고리 이름"),
    displayOrder: zod
      .number()
      .min(adminCategoriesControllerUpdateCategoryBodyDisplayOrderMin)
      .optional()
      .describe("표시 순서 (0 이상)"),
    icon: zod.string().nullish().describe("아이콘"),
    description: zod.string().nullish().describe("카테고리 설명"),
    isActive: zod
      .boolean()
      .optional()
      .describe("활성 상태 (true=활성, false=비활성)"),
  })
  .strict();

export const adminCategoriesControllerUpdateCategoryResponseTwoDataLevelMax = 4;

export const adminCategoriesControllerUpdateCategoryResponseTwoDataDisplayOrderMin = 0;

export const adminCategoriesControllerUpdateCategoryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("카테고리 ID (UUID)"),
        name: zod.string().describe("카테고리 이름"),
        parentId: zod
          .string()
          .uuid()
          .nullish()
          .describe("부모 카테고리 ID (null이면 최상위)"),
        level: zod
          .number()
          .min(1)
          .max(adminCategoriesControllerUpdateCategoryResponseTwoDataLevelMax)
          .describe("카테고리 레벨 (1-4)"),
        displayOrder: zod
          .number()
          .min(
            adminCategoriesControllerUpdateCategoryResponseTwoDataDisplayOrderMin,
          )
          .describe("표시 순서"),
        icon: zod.string().nullish().describe("아이콘 이름"),
        description: zod.string().nullish().describe("카테고리 설명"),
        isActive: zod.boolean().describe("활성 상태"),
        createdAt: zod.string().datetime({}).describe("생성 일시"),
        updatedAt: zod.string().datetime({}).describe("수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 카테고리를 삭제합니다.
 * @summary 🗑️ 카테고리 삭제
 */
export const adminCategoriesControllerDeleteCategoryParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

/**
 * 새로운 카테고리를 생성합니다.
 * @summary ➕ 카테고리 생성
 */
export const adminCategoriesControllerCreateCategoryBodyNameMax = 100;

export const adminCategoriesControllerCreateCategoryBodyLevelMax = 4;

export const adminCategoriesControllerCreateCategoryBodyDisplayOrderMin = 0;

export const adminCategoriesControllerCreateCategoryBody = zod
  .object({
    name: zod
      .string()
      .min(1)
      .max(adminCategoriesControllerCreateCategoryBodyNameMax)
      .describe("카테고리 이름"),
    parentId: zod
      .string()
      .uuid()
      .nullish()
      .describe("부모 카테고리 ID (null이면 최상위)"),
    level: zod
      .number()
      .min(1)
      .max(adminCategoriesControllerCreateCategoryBodyLevelMax)
      .describe("카테고리 레벨 (1-4)"),
    displayOrder: zod
      .number()
      .min(adminCategoriesControllerCreateCategoryBodyDisplayOrderMin)
      .optional()
      .describe("표시 순서 (0 이상)"),
    icon: zod.string().optional().describe("아이콘"),
    description: zod.string().optional().describe("카테고리 설명"),
  })
  .strict();

/**
 * 카테고리의 표시 순서를 변경합니다.
 * @summary ↕️ 카테고리 순서 변경
 */
export const adminCategoriesControllerReorderCategoryParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminCategoriesControllerReorderCategoryBodyNewOrderMin = 0;

export const adminCategoriesControllerReorderCategoryBody = zod
  .object({
    newOrder: zod
      .number()
      .min(adminCategoriesControllerReorderCategoryBodyNewOrderMin)
      .describe("새로운 표시 순서 (0 이상)"),
  })
  .strict();

export const adminCategoriesControllerReorderCategoryResponseTwoDataLevelMax = 4;

export const adminCategoriesControllerReorderCategoryResponseTwoDataDisplayOrderMin = 0;

export const adminCategoriesControllerReorderCategoryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("카테고리 ID (UUID)"),
        name: zod.string().describe("카테고리 이름"),
        parentId: zod
          .string()
          .uuid()
          .nullish()
          .describe("부모 카테고리 ID (null이면 최상위)"),
        level: zod
          .number()
          .min(1)
          .max(adminCategoriesControllerReorderCategoryResponseTwoDataLevelMax)
          .describe("카테고리 레벨 (1-4)"),
        displayOrder: zod
          .number()
          .min(
            adminCategoriesControllerReorderCategoryResponseTwoDataDisplayOrderMin,
          )
          .describe("표시 순서"),
        icon: zod.string().nullish().describe("아이콘 이름"),
        description: zod.string().nullish().describe("카테고리 설명"),
        isActive: zod.boolean().describe("활성 상태"),
        createdAt: zod.string().datetime({}).describe("생성 일시"),
        updatedAt: zod.string().datetime({}).describe("수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary Admin 중복 의심 물품 목록 조회 (유사도 기반)
 */
export const adminItemsControllerFindDuplicateCandidatesQueryParams = zod
  .object({
    threshold: zod.coerce
      .number()
      .optional()
      .describe("유사도 임계값 (0.0 ~ 1.0, 기본값: 0.8)"),
    categoryId: zod.coerce
      .string()
      .optional()
      .describe("카테고리 ID (해당 카테고리가 포함된 중복 그룹 조회)"),
    search: zod.coerce
      .string()
      .optional()
      .describe("검색어 (상품명/브랜드 등에 포함된 중복 그룹 조회)"),
    limit: zod.coerce
      .number()
      .optional()
      .describe("가져올 그룹 수 (기본값: 20)"),
    offset: zod.coerce
      .number()
      .optional()
      .describe("건너뛸 그룹 수 (기본값: 0)"),
    minScore: zod.coerce
      .number()
      .optional()
      .describe(
        "구간 하한(포함) — 그룹 최고 유사도 기준. 임계값(threshold)과는 별개다: 임계값을 올리면 약한 구성원이 잘려 그룹이 통째로 사라지므로, 구간 선택에는 이 값을 쓴다.",
      ),
    maxScore: zod.coerce
      .number()
      .optional()
      .describe("구간 상한(미포함) — 그룹 최고 유사도 기준. 비우면 상한 없음."),
  })
  .strict();

export const adminItemsControllerFindDuplicateCandidatesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              groupId: zod
                .string()
                .describe("유사한 항목들을 묶는 그룹 ID (기준 물품의 ID)"),
              itemId: zod.string().describe("물품 ID"),
              name: zod.string().describe("물품명"),
              brand: zod.string().nullish().describe("브랜드"),
              manufacturer: zod.string().nullish().describe("제조사"),
              code: zod.string().nullish().describe("상품 코드(모델명)"),
              price: zod.number().nullish().describe("최저가 거래단가"),
              supplierCount: zod.number().describe("공급사 수"),
              similarityScore: zod
                .number()
                .describe("기준 물품과의 유사도 점수 (0.0 ~ 1.0)"),
              spec1: zod.string().nullish().describe("규격1"),
              spec2: zod.string().nullish().describe("규격2"),
              spec3: zod.string().nullish().describe("규격3"),
              groupMaxScore: zod
                .number()
                .describe(
                  "그룹의 최고 유사도. 목록 정렬과 구간(밴드) 판정이 모두 이 값을 쓴다.",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 화면 상단 칩에 쓰는 집계. 목록과 같은 필터(임계값·카테고리·검색)를 받으므로 칩 숫자와 칩을 눌렀을 때 나오는 그룹 수가 일치한다.
 * @summary Admin 중복 물품 유사도 구간별 그룹 수
 */
export const adminItemsControllerGetDuplicateCandidateBandsQueryParams = zod
  .object({
    threshold: zod.coerce.number().optional(),
    categoryId: zod.coerce.string().optional(),
    search: zod.coerce.string().optional(),
  })
  .strict();

export const adminItemsControllerGetDuplicateCandidateBandsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            bandMin: zod.number().describe("구간 하한 (포함)"),
            bandMax: zod
              .number()
              .nullable()
              .describe(
                "구간 상한 (미포함). null 이면 상한 없음 — 완전 일치(1.0)를 담는 구간이다.",
              ),
            groupCount: zod.number().describe("이 구간에 속하는 그룹 수"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 백그라운드에서 실행 중인 재계산 작업을 취소합니다.
 * @summary Admin 중복 물품 재계산 취소
 */
export const adminItemsControllerCancelDuplicateRecalculationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("API 호출 성공 여부"),
        data: zod
          .object({})
          .optional()
          .describe("응답 데이터 (성공 시에만 포함)"),
        error: zod
          .object({
            code: zod.string().describe("에러 코드"),
            message: zod.string().describe("에러 메시지"),
            details: zod.object({}).optional().describe("상세 정보"),
          })
          .strict()
          .optional()
          .describe("에러 정보 (실패 시에만 포함)"),
        timestamp: zod
          .string()
          .datetime({})
          .describe("응답 생성 시각 (ISO 8601)"),
        statusCode: zod.number().optional().describe("HTTP 상태 코드"),
        message: zod.string().optional().describe("요청 처리 메시지"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 백그라운드에서 실행 중인 재계산 작업이 있는지 확인합니다.
 * @summary Admin 중복 물품 재계산 상태 조회
 */
export const adminItemsControllerGetDuplicateRecalculationStatusResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        isProcessing: zod.boolean().describe("진행 중인 작업 존재 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary Admin 중복 물품 병합 미리보기
 */
export const adminItemsControllerPreviewMergeBody = zod
  .object({
    masterItemId: zod
      .string()
      .describe(
        "대표(마스터) 물품 ID (이 물품으로 거래 이력 등이 모두 이관됩니다)",
      ),
    duplicateItemIds: zod
      .array(zod.string())
      .describe("병합되어 비활성화될 중복 물품 ID 목록"),
  })
  .strict();

export const adminItemsControllerPreviewMergeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        beforeCount: zod.number().describe("마스터 물품의 기존 공급자 수"),
        afterCount: zod.number().describe("병합 후 예상되는 순수 총 공급자 수"),
        overlappingSupplierIds: zod
          .array(zod.string())
          .describe(
            "마스터 물품과 이미 겹치는 공급사들의 ID 목록 (UUID 또는 문자열 ID)",
          ),
        expectedSuppliers: zod
          .array(
            zod
              .object({
                supplierId: zod
                  .string()
                  .describe("공급사 ID (UUID 또는 문자열)"),
                supplierName: zod.string().describe("공급사명"),
                status: zod
                  .enum(["EXISTING", "ADDED", "CONFLICT"])
                  .describe("상태 (기존, 추가, 충돌)"),
                finalPrice: zod.number().describe("최종 예상 단가"),
                originalPrice: zod
                  .number()
                  .optional()
                  .describe("충돌 시 보여줄 참고용 단가 (마스터 단가 등)"),
              })
              .strict(),
          )
          .describe("최종 예상 공급사 목록"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary Admin 중복 물품 병합
 */
export const adminItemsControllerMergeItemsBody = zod
  .object({
    masterItemId: zod
      .string()
      .describe(
        "대표(마스터) 물품 ID (이 물품으로 거래 이력 등이 모두 이관됩니다)",
      ),
    duplicateItemIds: zod
      .array(zod.string())
      .describe("병합되어 비활성화될 중복 물품 ID 목록"),
  })
  .strict();

export const adminItemsControllerMergeItemsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
        masterItemId: zod.string().describe("대표 물품 ID"),
        mergedCount: zod.number().describe("병합된 물품 개수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 상품 엑셀 다운로드 (카테고리별 필터 가능)
 */
export const adminItemsControllerExportItemsQueryIncludeDescendantsDefault =
  "true";

export const adminItemsControllerExportItemsQueryParams = zod
  .object({
    categoryIds: zod.coerce
      .string()
      .optional()
      .describe(
        "선택된 카테고리 ID 목록 (콤마 구분). 지정하지 않으면 전체 다운로드",
      ),
    includeDescendants: zod.coerce
      .string()
      .default(adminItemsControllerExportItemsQueryIncludeDescendantsDefault)
      .describe("하위 카테고리 포함 여부 (기본값: true)"),
  })
  .strict();

/**
 * @summary 상품 엑셀 일괄 등록
 */
export const adminItemsControllerBulkUploadProductsBody = zod
  .object({
    file: zod
      .instanceof(File)
      .optional()
      .describe("상품 일괄 등록 엑셀 파일 (.xlsx)"),
  })
  .strict();

export const adminItemsControllerBulkUploadProductsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        successCount: zod.number().describe("성공한 행 개수"),
        errorCount: zod.number().describe("실패한 행 개수"),
        errors: zod.array(zod.string()).describe("에러 상세 메시지 목록"),
        successItems: zod
          .array(zod.string())
          .optional()
          .describe("성공한 항목 이름 목록"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이미지를 public `assets` 버킷에 영구 저장하고 공개 URL 을 돌려준다. 반환된 imageUrl 을 물품 등록/수정의 imageUrl 필드에 그대로 넣으면 된다.
 * @summary 상품 이미지 업로드 (영구 저장, 공개 URL 반환)
 */
export const adminItemsControllerUploadProductImageBody = zod
  .object({
    file: zod
      .instanceof(File)
      .describe("상품 이미지 (JPG, PNG, GIF, WEBP, BMP / 최대 5MB)"),
  })
  .strict();

/**
 * @summary Admin 물품 등록
 */
export const adminItemsControllerCreateProductBody = zod
  .object({
    name: zod.string().describe("상품명 (필수)"),
    manufacturer: zod.string().optional().describe("제조사 (선택)"),
    brand: zod.string().optional().describe("브랜드 (선택)"),
    code: zod.string().optional().describe("품목코드 (선택)"),
    unit: zod.string().describe("단위 (필수)"),
    price: zod.number().describe("정가 (필수)"),
    imageUrl: zod.string().optional().describe("이미지 URL (선택)"),
    categoryId: zod.string().describe("카테고리 ID (필수, UUID)"),
    spec1: zod.string().optional().describe("규격1 (선택)"),
    spec2: zod.string().optional().describe("규격2 (선택)"),
    spec3: zod.string().optional().describe("규격3 (선택)"),
  })
  .strict();

/**
 * @summary 물품 목록 조회 (전체 또는 카테고리 필터)
 */
export const adminItemsControllerGetItemsQueryLimitDefault = 50;
export const adminItemsControllerGetItemsQueryOffsetDefault = 0;
export const adminItemsControllerGetItemsQueryIncludeDescendantsDefault = true;
export const adminItemsControllerGetItemsQuerySortByDefault = "updated_at";
export const adminItemsControllerGetItemsQuerySortOrderDefault = "desc";

export const adminItemsControllerGetItemsQueryParams = zod
  .object({
    limit: zod.coerce
      .number()
      .default(adminItemsControllerGetItemsQueryLimitDefault)
      .describe("조회 개수 (기본 50)"),
    offset: zod.coerce
      .number()
      .default(adminItemsControllerGetItemsQueryOffsetDefault)
      .describe("페이지네이션 오프셋 (기본 0)"),
    cursor: zod.coerce
      .string()
      .optional()
      .describe("커서 (다음 페이지 조회를 위한 Base64 인코딩 값)"),
    categoryId: zod.coerce
      .string()
      .optional()
      .describe("카테고리 ID (선택 시 해당 카테고리 내 물품 조회)"),
    includeDescendants: zod.coerce
      .boolean()
      .default(adminItemsControllerGetItemsQueryIncludeDescendantsDefault)
      .describe("하위 카테고리 포함 여부 (기본 true)"),
    search: zod.coerce.string().optional().describe("검색어 (상품명 등)"),
    sortBy: zod
      .enum(["name", "price", "updated_at", "supplier_count", "code"])
      .default(adminItemsControllerGetItemsQuerySortByDefault)
      .describe("정렬 기준 컬럼"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(adminItemsControllerGetItemsQuerySortOrderDefault)
      .describe("정렬 순서"),
  })
  .strict();

export const adminItemsControllerGetItemsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              casNo: zod
                .string()
                .nullish()
                .describe(
                  "CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)",
                ),
              keNo: zod
                .string()
                .nullish()
                .describe(
                  "국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null",
                ),
              unNo: zod
                .string()
                .nullish()
                .describe(
                  "UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null",
                ),
              enNo: zod
                .string()
                .nullish()
                .describe("EC 번호 (EU EINECS/ELINCS)"),
              chemNameKor: zod
                .string()
                .nullish()
                .describe("KOSHA 기준 국문 표준 물질명"),
              id: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
              name: zod.string().describe("상품명"),
              categoryId: zod
                .string()
                .nullable()
                .describe("카테고리 ID (items_v2_categories.id - UUID)"),
              categoryPath: zod.string().describe("카테고리 경로 (표시용)"),
              price: zod.number().describe("기준 가격 (정가)"),
              lowestPrice: zod.number().nullable().describe("최저가 거래 단가"),
              lowestPriceDate: zod
                .string()
                .nullable()
                .describe("최저가 거래 날짜"),
              lowestPriceSupplierName: zod
                .string()
                .nullable()
                .describe("최저가 거래 공급자명"),
              level: zod.number().describe("카테고리 레벨 (0-3)"),
              parentId: zod.string().nullable().describe("부모 카테고리 UUID"),
              manufacturer: zod.string().nullable().describe("제조사"),
              brand: zod.string().nullable().describe("브랜드"),
              code: zod.string().nullable().describe("상품코드"),
              unit: zod.string().describe("단위"),
              imageUrl: zod.string().nullable().describe("이미지 URL"),
              spec1: zod.string().nullable().describe("규격1"),
              spec2: zod.string().nullable().describe("규격2"),
              spec3: zod.string().nullable().describe("규격3"),
              supplierCount: zod.number().describe("취급 공급자 수"),
              createdAt: zod.string().describe("생성 일시"),
              updatedAt: zod.string().describe("수정 일시"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary Supplier 요청 조회 (상태 필터 가능)
 */
export const adminItemsControllerFindRequestsQueryParams = zod
  .object({
    limit: zod.coerce.number().optional(),
    offset: zod.coerce.number().optional(),
    status: zod.enum(["pending", "approved", "rejected"]).optional(),
  })
  .strict();

export const adminItemsControllerFindRequestsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("요청 ID"),
              supplierId: zod.string().describe("Supplier ID (UUID)"),
              companyName: zod.string().optional().describe("업체명 (상호)"),
              supplierCode: zod
                .string()
                .optional()
                .describe("업체 코드 (Supplier ID)"),
              name: zod.string().describe("상품명"),
              manufacturer: zod.string().optional().describe("제조사"),
              brand: zod.string().optional().describe("브랜드"),
              unit: zod.string().nullable().describe("단위"),
              spec1: zod.string().optional().describe("규격 1"),
              spec2: zod.string().optional().describe("규격 2"),
              spec3: zod.string().optional().describe("규격 3"),
              categoryId: zod.string().optional().describe("카테고리 ID"),
              categoryName: zod.string().optional().describe("카테고리명"),
              requestReason: zod.string().optional().describe("요청 사유"),
              status: zod
                .enum(["pending", "approved", "rejected"])
                .describe("상태"),
              adminComment: zod.string().optional().describe("Admin 거부 사유"),
              createdAt: zod.string().optional().describe("생성 일시"),
              updatedAt: zod.string().nullable().describe("수정 일시"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 요청 상세 조회
 */
export const adminItemsControllerFindRequestByIdParams = zod
  .object({
    id: zod.coerce.string().describe("요청 ID"),
  })
  .strict();

export const adminItemsControllerFindRequestByIdResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("요청 ID"),
        supplierId: zod.string().describe("Supplier ID"),
        companyName: zod.string().optional().describe("업체명 (상호)"),
        supplierCode: zod
          .string()
          .optional()
          .describe("업체 코드 (Supplier ID)"),
        name: zod.string().describe("상품명"),
        manufacturer: zod.string().optional().describe("제조사"),
        brand: zod.string().optional().describe("브랜드"),
        unit: zod.string().nullable().describe("단위"),
        spec1: zod.string().optional().describe("규격 1"),
        spec2: zod.string().optional().describe("규격 2"),
        spec3: zod.string().optional().describe("규격 3"),
        categoryId: zod.string().optional().describe("카테고리 ID"),
        categoryName: zod.string().optional().describe("카테고리명"),
        additionalCategoryIds: zod
          .object({})
          .optional()
          .describe("추가 카테고리 IDs"),
        requestReason: zod.string().optional().describe("요청 사유"),
        status: zod.enum(["pending", "approved", "rejected"]).describe("상태"),
        adminComment: zod.string().optional().describe("Admin 거부 사유"),
        approvedByAdminId: zod.string().optional().describe("승인한 Admin ID"),
        approvedItemId: zod
          .string()
          .optional()
          .describe("승인 시 생성된 물품 ID"),
        createdAt: zod.string().optional().describe("생성 일시"),
        updatedAt: zod.string().nullable().describe("수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary Supplier 요청 승인
 */
export const adminItemsControllerApproveRequestParams = zod
  .object({
    id: zod.coerce.string().describe("요청 ID"),
  })
  .strict();

export const adminItemsControllerApproveRequestBody = zod
  .object({
    categoryId: zod
      .string()
      .optional()
      .describe("카테고리 ID (승인 시 지정/변경 가능)"),
    name: zod.string().optional().describe("상품명 (승인 시 변경 가능)"),
    unit: zod.string().optional().describe("단위 (승인 시 변경 가능)"),
    manufacturer: zod
      .string()
      .optional()
      .describe("제조사 (승인 시 변경 가능)"),
    brand: zod.string().optional().describe("브랜드 (승인 시 변경 가능)"),
    spec1: zod.string().optional().describe("규격 1 (승인 시 변경 가능)"),
    spec2: zod.string().optional().describe("규격 2 (승인 시 변경 가능)"),
    spec3: zod.string().optional().describe("규격 3 (승인 시 변경 가능)"),
    adminComment: zod
      .string()
      .optional()
      .describe("관리자 코멘트 (승인/반려 시)"),
  })
  .strict();

export const adminItemsControllerApproveRequestResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        status: zod.string().describe("요청 상태"),
        requestId: zod.string().describe("요청 ID"),
        approvedItemId: zod.string().describe("생성된 물품 ID"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary Supplier 요청 거부
 */
export const adminItemsControllerRejectRequestParams = zod
  .object({
    id: zod.coerce.string().describe("요청 ID"),
  })
  .strict();

export const adminItemsControllerRejectRequestBody = zod
  .object({
    comment: zod.string().describe("거부 사유"),
  })
  .strict();

export const adminItemsControllerRejectRequestResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        status: zod.string().describe("요청 상태"),
        requestId: zod.string().describe("요청 ID"),
        comment: zod.string().describe("거부 사유"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 물품 수정
 */
export const adminItemsControllerUpdateProductParams = zod
  .object({
    id: zod.coerce.string().describe("물품 ID"),
  })
  .strict();

export const adminItemsControllerUpdateProductBody = zod
  .object({
    name: zod.string().optional().describe("상품명 (선택)"),
    manufacturer: zod.string().optional().describe("제조사 (선택)"),
    brand: zod.string().optional().describe("브랜드 (선택)"),
    code: zod.string().optional().describe("품목코드 (선택)"),
    unit: zod.string().optional().describe("단위 (선택)"),
    price: zod.number().optional().describe("정가 (선택)"),
    imageUrl: zod.string().optional().describe("이미지 URL (선택)"),
    categoryId: zod.string().optional().describe("카테고리 ID (선택, UUID)"),
    spec1: zod.string().optional().describe("규격1 (선택)"),
    spec2: zod.string().optional().describe("규격2 (선택)"),
    spec3: zod.string().optional().describe("규격3 (선택)"),
  })
  .strict();

export const adminItemsControllerUpdateProductResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("상품 ID"),
        name: zod.string().describe("상품명"),
        manufacturer: zod.string().optional().describe("제조사"),
        brand: zod.string().optional().describe("브랜드"),
        code: zod.string().optional().describe("상품 코드"),
        unit: zod.string().describe("단위"),
        price: zod.number().optional().describe("가격"),
        imageUrl: zod.string().optional().describe("이미지 URL"),
        categoryId: zod.string().optional().describe("카테고리 ID"),
        spec1: zod.string().optional().describe("규격 1"),
        spec2: zod.string().optional().describe("규격 2"),
        spec3: zod.string().optional().describe("규격 3"),
        updatedAt: zod.string().describe("수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 물품 상세 조회
 */
export const adminItemsControllerFindProductByIdParams = zod
  .object({
    id: zod.coerce.string().describe("물품 ID"),
  })
  .strict();

export const adminItemsControllerFindProductByIdResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("상품 ID"),
        name: zod.string().describe("상품명"),
        manufacturer: zod.string().optional().describe("제조사"),
        brand: zod.string().optional().describe("브랜드"),
        code: zod.string().optional().describe("상품 코드"),
        unit: zod.string().describe("단위"),
        price: zod.number().optional().describe("가격"),
        imageUrl: zod.string().optional().describe("이미지 URL"),
        categoryId: zod.string().optional().describe("카테고리 ID"),
        spec1: zod.string().optional().describe("규격 1"),
        spec2: zod.string().optional().describe("규격 2"),
        spec3: zod.string().optional().describe("규격 3"),
        createdByAdminId: zod.string().describe("등록 Admin ID"),
        createdAt: zod.string().describe("생성 일시"),
        updatedAt: zod.string().describe("수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 물품 삭제
 */
export const adminItemsControllerDeleteProductParams = zod
  .object({
    id: zod.coerce.string().describe("물품 ID"),
  })
  .strict();

export const adminItemsControllerDeleteProductResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("삭제된 상품 ID"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 물품별 공급사 가격 순위/통계 조회
 */
export const adminItemsControllerGetVendorStatsParams = zod
  .object({
    id: zod.coerce.string().describe("물품 ID"),
  })
  .strict();

export const adminItemsControllerGetVendorStatsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().describe("공급사 ID"),
            name: zod.string().describe("공급사명 (업체명_상호)"),
            managerName: zod.string().optional().describe("담당자명"),
            managerPhone: zod.string().optional().describe("담당자 휴대폰"),
            price: zod.number().describe("최근 거래가"),
            taxType: zod
              .enum(["EXCLUSIVE", "INCLUSIVE"])
              .describe(
                "최근 거래가의 부가세 축. INCLUSIVE 면 부가세 포함가라, 공급가액 단가와 나란히 놓고 그냥 비교하면 안 된다(10% 만큼 싸 보인다).",
              ),
            updatedAt: zod.string().describe("최근 거래일 (ISO)"),
            isLowest: zod.boolean().describe("최저가 여부"),
            history: zod
              .array(
                zod
                  .object({
                    date: zod.string().describe("날짜 (YYYY-MM-DD or YYYY-MM)"),
                    price: zod.number().describe("가격"),
                  })
                  .strict(),
              )
              .describe("가격 변동 추이"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 공급사 수 일괄 동기화 (DB 및 Elasticsearch)
 */
export const adminItemsControllerSyncSupplierCountsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("삭제된 상품 ID"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 백그라운드에서 실행 중인 동기화 작업이 있는지 확인합니다.
 * @summary 공급사 수 일괄 동기화 상태 조회
 */
export const adminItemsControllerGetSyncSupplierCountsStatusResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        isProcessing: zod.boolean().describe("진행 중인 작업 존재 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 적재된 화학물질 수, KE 번호 보유 수, 최종 적재 시각을 반환합니다.
 * @summary MSDS 카탈로그 적재 현황
 */
export const adminItemsControllerGetMsdsCatalogStatusResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        total: zod.number().describe("적재된 화학물질 수 (CAS 기준)"),
        withKeNo: zod.number().describe("KE 번호를 가진 화학물질 수"),
        lastSyncedAt: zod
          .string()
          .nullable()
          .describe("최종 적재 시각 (한 번도 적재하지 않았으면 null)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 관리자 계정 생성
 * @summary 관리자 회원가입 (Admin Signup)
 */
export const adminAuthControllerAdminSignupBodyUserIdMin = 3;

export const adminAuthControllerAdminSignupBodyPasswordMin = 6;

export const adminAuthControllerAdminSignupBody = zod
  .object({
    userId: zod
      .string()
      .min(adminAuthControllerAdminSignupBodyUserIdMin)
      .describe("관리자 사용자 ID"),
    password: zod
      .string()
      .min(adminAuthControllerAdminSignupBodyPasswordMin)
      .describe("관리자 비밀번호"),
    secretKey: zod.string().describe("가입 인증 키"),
  })
  .strict();

/**
 * 관리자 로그인 (userId + password)
 * @summary 관리자 로그인
 */
export const adminAuthControllerAdminLoginBodyUserIdMin = 3;

export const adminAuthControllerAdminLoginBodyPasswordMin = 6;

export const adminAuthControllerAdminLoginBody = zod
  .object({
    userId: zod
      .string()
      .min(adminAuthControllerAdminLoginBodyUserIdMin)
      .describe("관리자 사용자 ID"),
    password: zod
      .string()
      .min(adminAuthControllerAdminLoginBodyPasswordMin)
      .describe("관리자 비밀번호"),
    rememberMe: zod.boolean().optional().describe("로그인 상태 유지"),
  })
  .strict();

export const adminAuthControllerAdminLoginResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        message: zod.string().describe("성공 메시지"),
        admin: zod
          .object({
            id: zod.string().describe("관리자 ID (UUID)"),
            userId: zod.string().describe("사용자 ID"),
            name: zod.string().optional().describe("관리자 이름"),
            userType: zod.enum(["admin"]).describe("사용자 유형"),
            isActive: zod.boolean().describe("계정 활성화 여부"),
            createdAt: zod.string().describe("생성 시간"),
          })
          .strict()
          .describe("로그인한 관리자 정보"),
        accessToken: zod.string().describe("액세스 토큰 (JWT)"),
        refreshToken: zod.string().describe("Refresh Token"),
        expiresIn: zod.number().describe("Expires In (seconds)"),
        tokenType: zod.string().describe("Token Type"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 품명 검색·등급 필터 지원. 등급 D 는 애초에 적재되지 않는다(노이즈 큼).
 * @summary 가격밴드 SKU 목록 조회
 */
export const adminPriceBandControllerGetPriceBandsQueryPageDefault = 1;

export const adminPriceBandControllerGetPriceBandsQueryLimitDefault = 20;
export const adminPriceBandControllerGetPriceBandsQueryLimitMax = 100;

export const adminPriceBandControllerGetPriceBandsQuerySortByDefault =
  "created_at";
export const adminPriceBandControllerGetPriceBandsQuerySortOrderDefault =
  "desc";

export const adminPriceBandControllerGetPriceBandsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(adminPriceBandControllerGetPriceBandsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(adminPriceBandControllerGetPriceBandsQueryLimitMax)
      .default(adminPriceBandControllerGetPriceBandsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(adminPriceBandControllerGetPriceBandsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(adminPriceBandControllerGetPriceBandsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    grade: zod
      .enum(["A", "B", "C"])
      .optional()
      .describe("신뢰등급 필터 (미지정 시 A/B/C 전체)"),
  })
  .strict();

export const adminPriceBandControllerGetPriceBandsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              skuId: zod.string().describe("SKU ID (12자리 안정 해시)"),
              itemName: zod.string().describe("대표 품명"),
              itemSpec: zod.string().nullable().describe("규격"),
              grade: zod.enum(["A", "B", "C"]).describe("신뢰등급"),
              skuN: zod.number().describe("총 관측수"),
              skuSuppliers: zod.number().describe("고유 공급사 수"),
              trendLabel: zod
                .string()
                .nullable()
                .describe(
                  "가격추세 라벨 — 급등|상승|보합|하락|급락, null 이면 trendBasis 로 사유 확인",
                ),
              trendPct: zod
                .number()
                .nullish()
                .describe("최근/이전 6개월 등락률(%)"),
              trendBasis: zod
                .string()
                .nullable()
                .describe(
                  "trendLabel=null 일 때 사유 — 'no_recent_data'|'insufficient_history'",
                ),
              qtyDiscountPct: zod
                .number()
                .nullable()
                .describe("수량 10배 증가 시 할인율(%), 항상 0~68.4"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 12수량티어 + 월별 시간추이 + 원시 관측치(차트용)를 함께 반환.
 * @summary 가격밴드 SKU 상세 조회
 */
export const adminPriceBandControllerGetPriceBandDetailParams = zod
  .object({
    skuId: zod.coerce.string(),
  })
  .strict();

export const adminPriceBandControllerGetPriceBandDetailResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        skuId: zod.string(),
        skuKey: zod.string(),
        itemName: zod.string(),
        itemSpec: zod.string().nullable(),
        catName: zod.string().nullable(),
        grade: zod.enum(["A", "B", "C"]),
        skuN: zod.number(),
        skuNWon: zod.number(),
        skuSuppliers: zod.number(),
        skuFirstQuote: zod.string().nullable(),
        skuLastQuote: zod.string().nullable(),
        skuP50All: zod
          .number()
          .nullable()
          .describe("전체 관측 가중중앙값(최신성 가중, 티어 무관)"),
        skuQtyMedian: zod.number().nullable(),
        qtyDiscountPct: zod.number().nullable(),
        trendLabel: zod.string().nullable(),
        trendPct: zod.number().nullable(),
        trendMonthsTotal: zod.number().nullable(),
        trendBasis: zod.string().nullable(),
        betaGlobal: zod
          .number()
          .nullable()
          .describe("전역 β (폴백/리포팅용 대표값)"),
        asof: zod
          .string()
          .describe("이 데이터의 배치 기준일 (compute.py --asof)"),
        tiers: zod
          .array(
            zod
              .object({
                tierIdx: zod.number().describe("티어 순번 (0~11)"),
                tier: zod
                  .string()
                  .describe('티어 라벨 (예: \"2-3\", \"1000+\")'),
                tierLo: zod.number().describe("티어 하한 수량"),
                tierHi: zod
                  .number()
                  .nullable()
                  .describe("티어 상한 수량 (null=상한 없음, 마지막 티어)"),
                isEstimated: zod
                  .boolean()
                  .describe("실측 없음(β 보간 추정치) 여부"),
                n: zod.number().describe("실측 관측수 (추정 셀은 0)"),
                nWon: zod.number().describe("낙찰 관측수"),
                suppliers: zod.number().describe("고유 공급사 수"),
                p25: zod
                  .number()
                  .nullable()
                  .describe("가중 25백분위가 (추정 셀은 null)"),
                p50: zod
                  .number()
                  .nullable()
                  .describe("가중 중앙값 (실측 또는 β 보간)"),
                p75: zod
                  .number()
                  .nullable()
                  .describe("가중 75백분위가 (추정 셀은 null)"),
                priceMin: zod.number().nullable(),
                priceMax: zod.number().nullable(),
                wonP50: zod
                  .number()
                  .nullable()
                  .describe("낙찰가 가중중앙값 (낙찰 관측 3건 이상일 때만)"),
                latestQuote: zod.string().nullable(),
                betaUsed: zod
                  .number()
                  .nullable()
                  .describe(
                    "보간에 실제 쓰인 β (beta_sku 와 동일, 하위호환용)",
                  ),
                betaSku: zod
                  .number()
                  .nullable()
                  .describe("SKU 자체 실측 기울기(또는 전역 β 폴백)"),
                slopeSource: zod.string().nullable().describe("'sku'|'global'"),
              })
              .strict(),
          )
          .describe("12개 수량티어"),
        trend: zod
          .array(
            zod
              .object({
                ym: zod.string().describe("연월 (YYYY-MM)"),
                n: zod.number().describe("그 달 관측수"),
                p50Adj: zod
                  .number()
                  .nullable()
                  .describe("SKU 중앙수량 기준 β 수량보정 중앙값"),
                p25Adj: zod.number().nullable().describe("n>=3 일 때만 존재"),
                p75Adj: zod.number().nullable().describe("n>=3 일 때만 존재"),
                p50Raw: zod
                  .number()
                  .nullable()
                  .describe("수량보정 안 한 원본 중앙값"),
              })
              .strict(),
          )
          .describe("월별 시간추이"),
        points: zod
          .array(
            zod
              .object({
                tierIdx: zod.number().describe("이 관측이 속한 티어 순번"),
                qty: zod.number().describe("실제 거래 수량"),
                price: zod.number().nullable().describe("실제 단가"),
                won: zod.boolean().describe("낙찰 관측 여부"),
              })
              .strict(),
          )
          .describe("원시 관측치(최대 500개, 차트 산점도 전용)"),
        supplierTrend: zod
          .array(
            zod
              .object({
                supplierId: zod.string().describe("공급사 ID"),
                supplierName: zod.string().nullable().describe("상호"),
                totalN: zod.number().describe("이 SKU 에 대한 총 응찰 건수"),
                totalWon: zod.number().describe("이 SKU 에 대한 총 낙찰 건수"),
                firstYm: zod.string().describe("첫 응찰 연월 (YYYY-MM)"),
                lastYm: zod.string().describe("마지막 응찰 연월 (YYYY-MM)"),
                points: zod
                  .array(
                    zod
                      .object({
                        ym: zod.string().describe("연월 (YYYY-MM)"),
                        n: zod.number().describe("그 달 이 공급사의 응찰 건수"),
                        nWon: zod
                          .number()
                          .describe("그 달 이 공급사의 낙찰 건수"),
                        p50Adj: zod
                          .number()
                          .nullable()
                          .describe("SKU 중앙수량 기준 β 수량보정 중앙 단가"),
                        p50Raw: zod
                          .number()
                          .nullable()
                          .describe("수량보정 안 한 원본 중앙 단가"),
                        qtyMedian: zod
                          .number()
                          .nullable()
                          .describe(
                            "그 달 응찰 건의 중앙 수량 (보정 근거 확인용)",
                          ),
                      })
                      .strict(),
                  )
                  .describe("월별 시계열 (오름차순)"),
              })
              .strict(),
          )
          .describe(
            "공급사별 월간 가격 추이. 총 응찰 건수 내림차순. 배치에서 SKU당 상위 10곳만 적재하므로 꼬리 공급사는 빠져 있다",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 전체 프로젝트 목록 조회 (Admin)
 */
export const adminProjectsControllerGetProjectsQueryPageDefault = 1;

export const adminProjectsControllerGetProjectsQueryLimitDefault = 20;
export const adminProjectsControllerGetProjectsQueryLimitMax = 100;

export const adminProjectsControllerGetProjectsQuerySortByDefault =
  "created_at";
export const adminProjectsControllerGetProjectsQuerySortOrderDefault = "desc";
export const adminProjectsControllerGetProjectsQueryDeletedDefault = false;
export const adminProjectsControllerGetProjectsQueryUnmatchedDefault = false;
export const adminProjectsControllerGetProjectsQueryStalledDefault = false;

export const adminProjectsControllerGetProjectsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(adminProjectsControllerGetProjectsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(adminProjectsControllerGetProjectsQueryLimitMax)
      .default(adminProjectsControllerGetProjectsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(adminProjectsControllerGetProjectsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(adminProjectsControllerGetProjectsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce
      .string()
      .optional()
      .describe(
        "검색어. 공고명·설명뿐 아니라 목록에 보이는 값으로도 찾을 수 있어야 한다 — 견적번호(`request_number`), 발주기관명(`buyers.organization_name`·`users.name`), 공급기업명(`suppliers.company_name`, 채팅방으로 이어진 공고)을 함께 훑는다. 회사 이름은 다른 표에 있어 먼저 id 를 모아 온 뒤 거르며, 한 번에 모으는 양에 상한이 있다(초과 시 서버 로그에 경고).",
      ),
    status: zod
      .enum([
        "IN_PROGRESS",
        "CLOSED",
        "DEADLINE_PASSED",
        "CLOSED_BY_BUYER",
        "CLOSED_BY_ADMIN",
      ])
      .optional()
      .describe(
        "상태 필터.\n\n- `IN_PROGRESS` — 진행중\n- `CLOSED` — 마감 전부. DB 의 `ON_HOLD`(마감일 경과로 스케줄러가 내린 값)와 `CLOSED`(사람이 누른 값)를 함께 뜻한다.\n- `DEADLINE_PASSED` — 마감 «안쪽» 중 아무도 누르지 않은 것만(`ON_HOLD`)\n- `CLOSED_BY_BUYER` — 발주기관이 직접 [마감하기] 를 누른 것만\n- `CLOSED_BY_ADMIN` — 관리자가 대신 마감한 것만\n\n뒤 세 값은 마감 한 칸을 **주체**로 다시 가른다 — 시간이 지나 저절로 내려간 건, 발주기관이 스스로 끝낸 건, 관리자가 대신 끝낸 건은 이후에 할 일이 서로 다르다. 계약까지 갔는지는 이 필터가 아니라 응답의 `status`(계약 파생값)로 가른다 — 마감 목록을 열어 그 안에서 계약 여부를 훑는 게 이 화면을 쓰는 방식이라, 계약 건을 필터에서 빼면 찾던 것이 목록에서 사라진다. (`ON_HOLD` 로 들어와도 마감 전부로 받아준다)",
      ),
    deleted: zod.coerce
      .boolean()
      .default(adminProjectsControllerGetProjectsQueryDeletedDefault)
      .describe(
        '\"삭제됨\" 탭. true 면 삭제된 프로젝트만, 기본값(false)이면 살아있는 것만 조회한다.',
      ),
    autoQuote: zod.coerce
      .string()
      .optional()
      .describe(
        "자동견적 진행 상태 필터(`quote_requests.auto_quote_status`). 쉼표로 여러 값을 줄 수 있다. `none,failed` 가 실제로 쓰이는 조합이다 — 발송이 안 나갔거나 실패한 공고는 사람이 보지 않으면 드러나지 않는다.",
      ),
    unmatched: zod.coerce
      .boolean()
      .default(adminProjectsControllerGetProjectsQueryUnmatchedDefault)
      .describe(
        "매칭이 남은 공고만. 파생 컬럼 `unmatched_item_count > 0` 으로 거른다 — 페이지를 받아 온 뒤 거르면 총 건수와 페이지 수가 어긋난다.",
      ),
    stalled: zod.coerce
      .boolean()
      .default(adminProjectsControllerGetProjectsQueryStalledDefault)
      .describe(
        "마감 48시간 이내인데 견적이 0건인 진행중 공고만. 자동견적이 닿지 않았거나 매칭이 비어 있는 건이 대부분 여기 걸린다.",
      ),
    source: zod
      .enum(["direct", "cmarket"])
      .optional()
      .describe(
        "가입 경로 필터(`users.source`). 씨마켓 연동 건과 세모 직가입 건을 가른다.",
      ),
  })
  .strict();

export const adminProjectsControllerGetProjectsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("프로젝트 ID"),
              projectName: zod.string().describe("프로젝트명"),
              requestNumber: zod.string().describe("견적 요청 번호"),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                  "CONTRACT_CANCELED",
                ])
                .describe(
                  '상태. 계약 이력이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)이고, 있으면 조회 전용 파생값으로 덮어써 실려 나간다 — 취소되지 않은 계약이 있으면 `CONTRACT_IN_PROGRESS`(계약 진행), 남은 것이 전부 취소분이면 `CONTRACT_CANCELED`(계약 취소). 파생값은 DB 에 저장되지 않는다. 화면은 `ON_HOLD`·`CLOSED` 를 모두 \"시간 마감\" 한 칸으로 그린다.',
                ),
              transactionModel: zod
                .enum(["brokerage", "agency"])
                .describe(
                  "거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다)",
                ),
              activeContractCount: zod
                .number()
                .describe(
                  '취소되지 않은 계약 수. 계약 이력이 없거나 전부 취소됐으면 0. 2 이상이면 화면은 상태 대신 \"계약 N건\" 만 보여준다 — 여러 계약의 상태를 하나로 접으면 그게 어느 계약 얘기인지 알 수 없어지기 때문이다.',
                ),
              userId: zod.string().describe("구매자 ID"),
              createdAt: zod.string().describe("생성일"),
              updatedAt: zod.string().describe("수정일"),
              description: zod.string().optional().describe("설명"),
              address: zod
                .object({
                  id: zod.string().describe("주소 ID"),
                  recipientName: zod.string().optional().describe("수령인명"),
                  phone: zod.string().optional().describe("연락처"),
                  postalCode: zod.string().optional().describe("우편번호"),
                  province: zod.string().optional().describe("시/도"),
                  city: zod.string().optional().describe("시/군/구"),
                  district: zod.string().optional().describe("읍/면/동"),
                  addressLine1: zod
                    .string()
                    .optional()
                    .describe("기본 주소 (도로명)"),
                  addressLine2: zod.string().optional().describe("상세 주소"),
                })
                .strict()
                .describe("주소 정보"),
              user: zod
                .object({
                  id: zod.string().describe("사용자 ID"),
                  name: zod.string().describe("사용자명"),
                  contactEmail: zod.string().describe("연락처 이메일"),
                  phone: zod.string().describe("연락처"),
                  companyName: zod.string().optional().describe("회사명"),
                  profileImageUrl: zod
                    .string()
                    .optional()
                    .describe("프로필 이미지 URL"),
                  trustPercentile: zod
                    .number()
                    .optional()
                    .describe("신뢰도 백분위"),
                })
                .strict()
                .describe("구매자 정보"),
              managerName: zod.string().optional().describe("담당자명"),
              managerContact: zod.string().describe("담당자 연락처"),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리 타입"),
              closeReason: zod.string().optional().describe("마감 사유"),
              closedAt: zod
                .string()
                .nullish()
                .describe(
                  "마감 시각 (ISO 8601). 마감 전이면 null. 마감일이 지나 스케줄러가 내린 건은 누른 사람이 없으므로 이 값도 비어 있다 — 그때의 기준 시각은 `deadline` 이다.",
                ),
              closedBy: zod
                .enum(["BUYER", "ADMIN", "DEADLINE"])
                .nullish()
                .describe(
                  "마감 주체. `BUYER`(발주기관이 직접 [마감하기]) · `ADMIN`(관리자 대행 마감) · `DEADLINE`(마감일이 지나 스케줄러가 내림). 아직 진행중이면 null. 이 컬럼이 생기기 전에 마감된 건은 `BUYER` 로 읽는다 — 그때는 관리자에게 마감 수단 자체가 없었다.",
                ),
              closedByName: zod
                .string()
                .nullish()
                .describe(
                  "마감을 누른 사람 이름. 주체가 `ADMIN` 일 때 «관리자 · 홍길동» 으로 쓴다. 이름을 되찾을 수 없는 예전 건은 null 이며, 그때는 주체 라벨만 보여준다.",
                ),
              deadline: zod.string().describe("마감일"),
              participantCount: zod
                .number()
                .describe(
                  '참여 업체 수. 이 공고에 열린 채팅방 개수이며 상세 화면의 \"참여 업체\" 와 같은 정의다.',
                ),
              participants: zod
                .array(
                  zod
                    .object({
                      supplierId: zod.string().describe("공급사 ID"),
                      companyName: zod
                        .string()
                        .describe("업체명 (없으면 사용자 이름)"),
                      totalAmount: zod
                        .number()
                        .nullish()
                        .describe(
                          "최신 견적 금액(원). 아직 견적을 내지 않았으면 null",
                        ),
                    })
                    .strict(),
                )
                .describe(
                  '참여 업체 요약(업체명·견적금액). 목록에서 마우스 오버로 \"누가 얼마에\" 를 보여준다.',
                ),
              sameRegionOnly: zod
                .boolean()
                .nullish()
                .describe(
                  "동일 지역만 허용 여부. true 이면 발주자 시/도 + 인접 2개 시/도 (총 3개 지역) 공급사만 참여 가능.",
                ),
              items: zod
                .array(
                  zod
                    .object({
                      name: zod.string().describe("품목명"),
                      quantity: zod.number().describe("수량"),
                      unit: zod.string().describe("단위"),
                      amount: zod.number().describe("금액"),
                      spec1: zod.string().optional().describe("규격 1"),
                      spec2: zod.string().optional().describe("규격 2"),
                      spec3: zod.string().optional().describe("규격 3"),
                      itemCode: zod.string().optional().describe("품목 코드"),
                      manufacturer: zod.string().optional().describe("제조사"),
                      brand: zod.string().optional().describe("브랜드"),
                      itemId: zod.string().optional().describe("품목 ID"),
                      itemName: zod
                        .string()
                        .optional()
                        .describe("매칭된 표준 품목명"),
                      itemCodeMatch: zod
                        .string()
                        .optional()
                        .describe("매칭된 표준 품목 코드"),
                      itemPrice: zod
                        .number()
                        .optional()
                        .describe("매칭된 표준 품목 단가"),
                      itemImageUrl: zod
                        .string()
                        .optional()
                        .describe("매칭된 표준 품목 이미지 URL"),
                      itemSpec: zod
                        .string()
                        .optional()
                        .describe("매칭된 표준 품목 규격 요약"),
                      quotedSupplierNames: zod
                        .array(zod.string())
                        .optional()
                        .describe(
                          "이 줄로 이미 견적을 낸 업체명 목록. 비어 있지 않으면 매칭을 바꿀 수 없다(서버도 409 로 막는다) — 매칭을 바꾸면 이미 나간 견적이 무엇에 대한 금액인지 알 수 없게 되기 때문이다.",
                        ),
                    })
                    .strict(),
                )
                .optional()
                .describe("물품 목록"),
              attachments: zod
                .array(
                  zod
                    .object({
                      fileName: zod.string().describe("파일명"),
                      url: zod.string().url().describe("파일 공개 URL"),
                      filePath: zod
                        .string()
                        .optional()
                        .describe(
                          "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                        ),
                      fileSize: zod.number().describe("파일 크기 (바이트)"),
                      contentType: zod
                        .string()
                        .optional()
                        .describe("MIME 타입"),
                    })
                    .strict(),
                )
                .optional()
                .describe("첨부파일 목록"),
              deletedAt: zod
                .string()
                .nullish()
                .describe(
                  '삭제 시각. 값이 있으면 \"삭제됨\" 상태이며 일반 목록·발주기관·공급사 화면에서 보이지 않는다. 데이터는 지워지지 않는다.',
                ),
              deletedByName: zod
                .string()
                .nullish()
                .describe("삭제한 관리자 이름"),
              noteCount: zod
                .number()
                .describe(
                  "이 공고에 달린 운영 메모 개수. 목록에서 어느 공고에 인수인계 맥락이 있는지 한눈에 보여주기 위한 것이라, 0 이면 아이콘 자체를 그리지 않는다.",
                ),
              latestNote: zod
                .object({
                  id: zod.string().describe("메모 ID"),
                  body: zod.string().describe("메모 내용"),
                  authorId: zod
                    .string()
                    .nullish()
                    .describe(
                      "작성 관리자 users.id. 계정이 삭제되면 null 이 되고 본문은 남는다. 삭제 버튼 노출 판단에 쓴다(자기 메모만 지울 수 있다).",
                    ),
                  authorName: zod
                    .string()
                    .describe(
                      '작성자 표시명. 이름이 없으면 이메일, 둘 다 없으면 \"알 수 없음\"',
                    ),
                  createdAt: zod.string().describe("작성 시각 (ISO 8601)"),
                })
                .strict()
                .nullish()
                .describe(
                  "가장 최근 메모. 목록의 마우스 오버 미리보기에 쓴다 — 메모가 있는지 알려면 상세로 들어가야 하는 동선을 없앤다. 메모가 없으면 null.",
                ),
              buyer: zod
                .object({
                  organizationName: zod
                    .string()
                    .nullish()
                    .describe(
                      "발주기관명(`buyers.organization_name`). 세모 직가입 개인 구매자는 값이 없다.",
                    ),
                  accountName: zod
                    .string()
                    .describe(
                      "계정 이름(`users.name`). 씨마켓 연동 건에서는 기관명이 아니라 담당자 직함이다 — 기관명 아래 보조 정보로만 쓴다.",
                    ),
                  externalBuyerId: zod
                    .string()
                    .nullish()
                    .describe(
                      "씨마켓 회원 아이디(`buyers.external_buyer_id`). 씨마켓 연동 건에만 값이 있다.",
                    ),
                  source: zod
                    .enum(["direct", "cmarket"])
                    .describe(
                      "가입 경로. `cmarket` 이면 씨마켓을 통해 들어온 공고다(`users.source`).",
                    ),
                  managerName: zod
                    .string()
                    .nullish()
                    .describe("실무 담당자명(`buyers.manager_name`)"),
                  managerTitle: zod
                    .string()
                    .nullish()
                    .describe(
                      "담당자 부서/직위 — 툴팁에서 계정 이름의 정체를 설명한다.",
                    ),
                  contactEmail: zod.string().describe("연락처 이메일"),
                  phone: zod.string().nullish().describe("연락처"),
                })
                .strict()
                .describe(
                  "발주기관 신원. 목록의 「발주기관」 칸은 `user.name` 이 아니라 이 값을 쓴다.",
                ),
              contracts: zod
                .array(
                  zod
                    .object({
                      id: zod.string().describe("계약 ID"),
                      contractNumber: zod
                        .string()
                        .nullish()
                        .describe("계약번호"),
                      status: zod.string().describe("계약 상태 DB 원값"),
                      totalAmount: zod
                        .number()
                        .nullish()
                        .describe("계약 금액(원)"),
                      createdAt: zod.string().nullish().describe("계약 체결일"),
                    })
                    .strict(),
                )
                .describe(
                  '이 공고에 걸린 계약들. 취소분도 포함한다 — 목록에서 계약서로 바로 넘어가기 위한 것이라 \"엎어진 계약을 확인하는\" 동선도 같은 자리에서 처리한다. 계약이 없으면 빈 배열.',
                ),
              matchSummary: zod
                .object({
                  totalItems: zod
                    .number()
                    .describe("물품 줄 수. 0 이면 물품 목록이 없는 공고다."),
                  matchedItems: zod
                    .number()
                    .describe("표준 물품에 매칭된 줄 수"),
                  quotableItems: zod
                    .number()
                    .describe(
                      "자동견적이 실제로 나갈 수 있는 줄 수 — 매칭됐고 취급 공급사가 1곳 이상인 줄. matchedItems 보다 작으면 매칭을 더 해도 견적이 늘지 않는다.",
                    ),
                })
                .strict()
                .describe("물품 매칭 요약(전체/매칭/발송가능 줄 수)."),
              autoQuoteStatus: zod
                .string()
                .nullish()
                .describe(
                  "자동견적 진행 상태(`none`·`pending`·`processing`·`completed`·`failed`). `failed` 는 사람이 보지 않으면 드러나지 않아 목록에 표시한다.",
                ),
              budgetAmount: zod.number().nullish().describe("예산 금액(원)"),
              isPublic: zod
                .boolean()
                .nullish()
                .describe(
                  "공개 공고 여부. false 면 지정한 공급사만 본다 — 참여가 적은 이유가 된다.",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 프로젝트 상세 및 채팅방 목록 조회 (Admin)
 */
export const adminProjectsControllerGetProjectDetailParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerGetProjectDetailResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        project: zod
          .object({
            id: zod.string().describe("프로젝트 ID"),
            projectName: zod.string().describe("프로젝트명"),
            requestNumber: zod.string().describe("견적 요청 번호"),
            status: zod
              .enum([
                "IN_PROGRESS",
                "ON_HOLD",
                "CLOSED",
                "CONTRACT_IN_PROGRESS",
                "CONTRACT_CANCELED",
              ])
              .describe(
                '상태. 계약 이력이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)이고, 있으면 조회 전용 파생값으로 덮어써 실려 나간다 — 취소되지 않은 계약이 있으면 `CONTRACT_IN_PROGRESS`(계약 진행), 남은 것이 전부 취소분이면 `CONTRACT_CANCELED`(계약 취소). 파생값은 DB 에 저장되지 않는다. 화면은 `ON_HOLD`·`CLOSED` 를 모두 \"시간 마감\" 한 칸으로 그린다.',
              ),
            transactionModel: zod
              .enum(["brokerage", "agency"])
              .describe(
                "거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다)",
              ),
            activeContractCount: zod
              .number()
              .describe(
                '취소되지 않은 계약 수. 계약 이력이 없거나 전부 취소됐으면 0. 2 이상이면 화면은 상태 대신 \"계약 N건\" 만 보여준다 — 여러 계약의 상태를 하나로 접으면 그게 어느 계약 얘기인지 알 수 없어지기 때문이다.',
              ),
            userId: zod.string().describe("구매자 ID"),
            createdAt: zod.string().describe("생성일"),
            updatedAt: zod.string().describe("수정일"),
            description: zod.string().optional().describe("설명"),
            address: zod
              .object({
                id: zod.string().describe("주소 ID"),
                recipientName: zod.string().optional().describe("수령인명"),
                phone: zod.string().optional().describe("연락처"),
                postalCode: zod.string().optional().describe("우편번호"),
                province: zod.string().optional().describe("시/도"),
                city: zod.string().optional().describe("시/군/구"),
                district: zod.string().optional().describe("읍/면/동"),
                addressLine1: zod
                  .string()
                  .optional()
                  .describe("기본 주소 (도로명)"),
                addressLine2: zod.string().optional().describe("상세 주소"),
              })
              .strict()
              .describe("주소 정보"),
            user: zod
              .object({
                id: zod.string().describe("사용자 ID"),
                name: zod.string().describe("사용자명"),
                contactEmail: zod.string().describe("연락처 이메일"),
                phone: zod.string().describe("연락처"),
                companyName: zod.string().optional().describe("회사명"),
                profileImageUrl: zod
                  .string()
                  .optional()
                  .describe("프로필 이미지 URL"),
                trustPercentile: zod
                  .number()
                  .optional()
                  .describe("신뢰도 백분위"),
              })
              .strict()
              .describe("구매자 정보"),
            managerName: zod.string().optional().describe("담당자명"),
            managerContact: zod.string().describe("담당자 연락처"),
            categoryType: zod
              .enum(["product", "construction", "manufacturing", "used"])
              .describe("카테고리 타입"),
            closeReason: zod.string().optional().describe("마감 사유"),
            closedAt: zod
              .string()
              .nullish()
              .describe(
                "마감 시각 (ISO 8601). 마감 전이면 null. 마감일이 지나 스케줄러가 내린 건은 누른 사람이 없으므로 이 값도 비어 있다 — 그때의 기준 시각은 `deadline` 이다.",
              ),
            closedBy: zod
              .enum(["BUYER", "ADMIN", "DEADLINE"])
              .nullish()
              .describe(
                "마감 주체. `BUYER`(발주기관이 직접 [마감하기]) · `ADMIN`(관리자 대행 마감) · `DEADLINE`(마감일이 지나 스케줄러가 내림). 아직 진행중이면 null. 이 컬럼이 생기기 전에 마감된 건은 `BUYER` 로 읽는다 — 그때는 관리자에게 마감 수단 자체가 없었다.",
              ),
            closedByName: zod
              .string()
              .nullish()
              .describe(
                "마감을 누른 사람 이름. 주체가 `ADMIN` 일 때 «관리자 · 홍길동» 으로 쓴다. 이름을 되찾을 수 없는 예전 건은 null 이며, 그때는 주체 라벨만 보여준다.",
              ),
            deadline: zod.string().describe("마감일"),
            participantCount: zod
              .number()
              .describe(
                '참여 업체 수. 이 공고에 열린 채팅방 개수이며 상세 화면의 \"참여 업체\" 와 같은 정의다.',
              ),
            participants: zod
              .array(
                zod
                  .object({
                    supplierId: zod.string().describe("공급사 ID"),
                    companyName: zod
                      .string()
                      .describe("업체명 (없으면 사용자 이름)"),
                    totalAmount: zod
                      .number()
                      .nullish()
                      .describe(
                        "최신 견적 금액(원). 아직 견적을 내지 않았으면 null",
                      ),
                  })
                  .strict(),
              )
              .describe(
                '참여 업체 요약(업체명·견적금액). 목록에서 마우스 오버로 \"누가 얼마에\" 를 보여준다.',
              ),
            sameRegionOnly: zod
              .boolean()
              .nullish()
              .describe(
                "동일 지역만 허용 여부. true 이면 발주자 시/도 + 인접 2개 시/도 (총 3개 지역) 공급사만 참여 가능.",
              ),
            items: zod
              .array(
                zod
                  .object({
                    name: zod.string().describe("품목명"),
                    quantity: zod.number().describe("수량"),
                    unit: zod.string().describe("단위"),
                    amount: zod.number().describe("금액"),
                    spec1: zod.string().optional().describe("규격 1"),
                    spec2: zod.string().optional().describe("규격 2"),
                    spec3: zod.string().optional().describe("규격 3"),
                    itemCode: zod.string().optional().describe("품목 코드"),
                    manufacturer: zod.string().optional().describe("제조사"),
                    brand: zod.string().optional().describe("브랜드"),
                    itemId: zod.string().optional().describe("품목 ID"),
                    itemName: zod
                      .string()
                      .optional()
                      .describe("매칭된 표준 품목명"),
                    itemCodeMatch: zod
                      .string()
                      .optional()
                      .describe("매칭된 표준 품목 코드"),
                    itemPrice: zod
                      .number()
                      .optional()
                      .describe("매칭된 표준 품목 단가"),
                    itemImageUrl: zod
                      .string()
                      .optional()
                      .describe("매칭된 표준 품목 이미지 URL"),
                    itemSpec: zod
                      .string()
                      .optional()
                      .describe("매칭된 표준 품목 규격 요약"),
                    quotedSupplierNames: zod
                      .array(zod.string())
                      .optional()
                      .describe(
                        "이 줄로 이미 견적을 낸 업체명 목록. 비어 있지 않으면 매칭을 바꿀 수 없다(서버도 409 로 막는다) — 매칭을 바꾸면 이미 나간 견적이 무엇에 대한 금액인지 알 수 없게 되기 때문이다.",
                      ),
                  })
                  .strict(),
              )
              .optional()
              .describe("물품 목록"),
            attachments: zod
              .array(
                zod
                  .object({
                    fileName: zod.string().describe("파일명"),
                    url: zod.string().url().describe("파일 공개 URL"),
                    filePath: zod
                      .string()
                      .optional()
                      .describe(
                        "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                      ),
                    fileSize: zod.number().describe("파일 크기 (바이트)"),
                    contentType: zod.string().optional().describe("MIME 타입"),
                  })
                  .strict(),
              )
              .optional()
              .describe("첨부파일 목록"),
            deletedAt: zod
              .string()
              .nullish()
              .describe(
                '삭제 시각. 값이 있으면 \"삭제됨\" 상태이며 일반 목록·발주기관·공급사 화면에서 보이지 않는다. 데이터는 지워지지 않는다.',
              ),
            deletedByName: zod
              .string()
              .nullish()
              .describe("삭제한 관리자 이름"),
            noteCount: zod
              .number()
              .describe(
                "이 공고에 달린 운영 메모 개수. 목록에서 어느 공고에 인수인계 맥락이 있는지 한눈에 보여주기 위한 것이라, 0 이면 아이콘 자체를 그리지 않는다.",
              ),
            latestNote: zod
              .object({
                id: zod.string().describe("메모 ID"),
                body: zod.string().describe("메모 내용"),
                authorId: zod
                  .string()
                  .nullish()
                  .describe(
                    "작성 관리자 users.id. 계정이 삭제되면 null 이 되고 본문은 남는다. 삭제 버튼 노출 판단에 쓴다(자기 메모만 지울 수 있다).",
                  ),
                authorName: zod
                  .string()
                  .describe(
                    '작성자 표시명. 이름이 없으면 이메일, 둘 다 없으면 \"알 수 없음\"',
                  ),
                createdAt: zod.string().describe("작성 시각 (ISO 8601)"),
              })
              .strict()
              .nullish()
              .describe(
                "가장 최근 메모. 목록의 마우스 오버 미리보기에 쓴다 — 메모가 있는지 알려면 상세로 들어가야 하는 동선을 없앤다. 메모가 없으면 null.",
              ),
            buyer: zod
              .object({
                organizationName: zod
                  .string()
                  .nullish()
                  .describe(
                    "발주기관명(`buyers.organization_name`). 세모 직가입 개인 구매자는 값이 없다.",
                  ),
                accountName: zod
                  .string()
                  .describe(
                    "계정 이름(`users.name`). 씨마켓 연동 건에서는 기관명이 아니라 담당자 직함이다 — 기관명 아래 보조 정보로만 쓴다.",
                  ),
                externalBuyerId: zod
                  .string()
                  .nullish()
                  .describe(
                    "씨마켓 회원 아이디(`buyers.external_buyer_id`). 씨마켓 연동 건에만 값이 있다.",
                  ),
                source: zod
                  .enum(["direct", "cmarket"])
                  .describe(
                    "가입 경로. `cmarket` 이면 씨마켓을 통해 들어온 공고다(`users.source`).",
                  ),
                managerName: zod
                  .string()
                  .nullish()
                  .describe("실무 담당자명(`buyers.manager_name`)"),
                managerTitle: zod
                  .string()
                  .nullish()
                  .describe(
                    "담당자 부서/직위 — 툴팁에서 계정 이름의 정체를 설명한다.",
                  ),
                contactEmail: zod.string().describe("연락처 이메일"),
                phone: zod.string().nullish().describe("연락처"),
              })
              .strict()
              .describe(
                "발주기관 신원. 목록의 「발주기관」 칸은 `user.name` 이 아니라 이 값을 쓴다.",
              ),
            contracts: zod
              .array(
                zod
                  .object({
                    id: zod.string().describe("계약 ID"),
                    contractNumber: zod.string().nullish().describe("계약번호"),
                    status: zod.string().describe("계약 상태 DB 원값"),
                    totalAmount: zod
                      .number()
                      .nullish()
                      .describe("계약 금액(원)"),
                    createdAt: zod.string().nullish().describe("계약 체결일"),
                  })
                  .strict(),
              )
              .describe(
                '이 공고에 걸린 계약들. 취소분도 포함한다 — 목록에서 계약서로 바로 넘어가기 위한 것이라 \"엎어진 계약을 확인하는\" 동선도 같은 자리에서 처리한다. 계약이 없으면 빈 배열.',
              ),
            matchSummary: zod
              .object({
                totalItems: zod
                  .number()
                  .describe("물품 줄 수. 0 이면 물품 목록이 없는 공고다."),
                matchedItems: zod.number().describe("표준 물품에 매칭된 줄 수"),
                quotableItems: zod
                  .number()
                  .describe(
                    "자동견적이 실제로 나갈 수 있는 줄 수 — 매칭됐고 취급 공급사가 1곳 이상인 줄. matchedItems 보다 작으면 매칭을 더 해도 견적이 늘지 않는다.",
                  ),
              })
              .strict()
              .describe("물품 매칭 요약(전체/매칭/발송가능 줄 수)."),
            autoQuoteStatus: zod
              .string()
              .nullish()
              .describe(
                "자동견적 진행 상태(`none`·`pending`·`processing`·`completed`·`failed`). `failed` 는 사람이 보지 않으면 드러나지 않아 목록에 표시한다.",
              ),
            budgetAmount: zod.number().nullish().describe("예산 금액(원)"),
            isPublic: zod
              .boolean()
              .nullish()
              .describe(
                "공개 공고 여부. false 면 지정한 공급사만 본다 — 참여가 적은 이유가 된다.",
              ),
          })
          .strict(),
        chatRooms: zod.array(
          zod
            .object({
              id: zod.string().describe("채팅방 ID"),
              quote_request_id: zod.string().describe("견적 요청 ID"),
              supplier: zod
                .object({
                  id: zod.string().describe("사용자 ID"),
                  name: zod.string().describe("사용자명"),
                  contactEmail: zod.string().describe("연락처 이메일"),
                  phone: zod.string().describe("연락처"),
                  companyName: zod.string().optional().describe("회사명"),
                  profileImageUrl: zod
                    .string()
                    .optional()
                    .describe("프로필 이미지 URL"),
                  trustPercentile: zod
                    .number()
                    .optional()
                    .describe("신뢰도 백분위"),
                })
                .strict()
                .describe("공급자 정보"),
              buyer: zod
                .object({
                  id: zod.string().describe("사용자 ID"),
                  name: zod.string().describe("사용자명"),
                  contactEmail: zod.string().describe("연락처 이메일"),
                  phone: zod.string().describe("연락처"),
                  companyName: zod.string().optional().describe("회사명"),
                  profileImageUrl: zod
                    .string()
                    .optional()
                    .describe("프로필 이미지 URL"),
                  trustPercentile: zod
                    .number()
                    .optional()
                    .describe("신뢰도 백분위"),
                })
                .strict()
                .describe("구매자 정보"),
              last_message_at: zod
                .string()
                .optional()
                .describe("마지막 메시지 시간"),
              quote: zod
                .object({
                  id: zod.string().describe("견적 ID"),
                  totalAmount: zod.number().optional().describe("견적 금액"),
                  status: zod
                    .enum(["pending", "submitted", "withdrawn", "expired"])
                    .optional()
                    .describe("견적 상태"),
                })
                .strict()
                .optional()
                .describe("연관된 견적 정보"),
              status: zod.string().optional().describe("상태"),
              participationState: zod
                .enum(["visible", "hidden"])
                .describe(
                  "참여 노출 상태. visible=정상, hidden=마스터에만 흐리게",
                ),
              hasContracted: zod
                .boolean()
                .describe(
                  "계약이 체결된 참여인지. true 면 숨기기도 삭제도 막힌다.",
                ),
              hiddenAt: zod
                .string()
                .nullish()
                .describe("감춘 시각 (ISO 8601). 정상 상태면 null."),
            })
            .strict(),
        ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 프로젝트를 "삭제됨" 으로 옮깁니다. 행은 지워지지 않으며 견적·채팅 이력도 그대로 남습니다. 일반 목록과 발주기관·공급사 화면에서만 사라지고, 어드민 "삭제됨" 탭에서 복원할 수 있습니다.
 * @summary 프로젝트 삭제 (Admin)
 */
export const adminProjectsControllerDeleteProjectParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerDeleteProjectResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 아이템을 표준 물품에 매칭하여 정보를 저장합니다.
 * @summary 아이템 수동 매칭 정보 저장
 */
export const adminProjectsControllerMatchItemParams = zod
  .object({
    id: zod.coerce.string(),
    index: zod.coerce.number(),
  })
  .strict();

export const adminProjectsControllerMatchItemBody = zod
  .object({
    baseItemId: zod.string().describe("표준 물품 UUID (items_v2_base.id)"),
    confirmRematch: zod
      .boolean()
      .optional()
      .describe(
        "이 줄로 이미 견적을 낸 업체가 있는데도 물품을 바꾸겠다는 확인. 마스터 화면이 어긋날 견적을 보여주고 체크를 받은 뒤에 true 로 보낸다. 확인 없이 바꾸려 하면 409 로 되돌아온다.",
      ),
  })
  .strict();

export const adminProjectsControllerMatchItemResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 카탈로그에 없는 물품을 새로 등록하고, 그 견적 아이템에 곧바로 매칭합니다. 등록 계약은 관리자 물품등록(POST /admin/items)과 동일합니다.
 * @summary 새 물품 등록 + 아이템 매칭
 */
export const adminProjectsControllerRegisterAndMatchItemParams = zod
  .object({
    id: zod.coerce.string(),
    index: zod.coerce.number(),
  })
  .strict();

export const adminProjectsControllerRegisterAndMatchItemBody = zod
  .object({
    name: zod.string().describe("상품명 (필수)"),
    manufacturer: zod.string().optional().describe("제조사 (선택)"),
    brand: zod.string().optional().describe("브랜드 (선택)"),
    code: zod.string().optional().describe("품목코드 (선택)"),
    unit: zod.string().describe("단위 (필수)"),
    price: zod.number().describe("정가 (필수)"),
    imageUrl: zod.string().optional().describe("이미지 URL (선택)"),
    categoryId: zod.string().describe("카테고리 ID (필수, UUID)"),
    spec1: zod.string().optional().describe("규격1 (선택)"),
    spec2: zod.string().optional().describe("규격2 (선택)"),
    spec3: zod.string().optional().describe("규격3 (선택)"),
    confirmRematch: zod
      .boolean()
      .optional()
      .describe(
        "이 줄로 이미 견적을 낸 업체가 있는데도 물품을 바꾸겠다는 확인. 마스터 화면이 어긋날 견적을 보여주고 체크를 받은 뒤에 true 로 보낸다. 확인 없이 바꾸려 하면 409 로 되돌아온다.",
      ),
  })
  .strict();

export const adminProjectsControllerRegisterAndMatchItemResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
        result: zod
          .object({
            itemId: zod
              .string()
              .describe("생성된 표준 물품 UUID (items_v2_base.id)"),
            productCode: zod
              .string()
              .nullable()
              .describe("자동 채번된 물품코드"),
            name: zod.string().describe("등록된 물품명"),
          })
          .strict()
          .describe("등록 결과"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이 공고의 각 줄에 견적을 낸 업체들의 단가와, 각 단가가 이미 카탈로그에 있는지 돌려줍니다.
 * @summary 공고의 줄별 제출 단가 및 카탈로그 등재 현황 조회
 */
export const adminProjectsControllerGetQuotedPricesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerGetQuotedPricesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            itemIndex: zod.number().describe("공고 줄 인덱스"),
            itemName: zod.string().describe("공고 줄 이름"),
            itemId: zod
              .string()
              .nullable()
              .describe(
                "매칭된 표준 물품 ID. null 이면 아직 매칭 전이라 연결할 대상이 없다",
              ),
            candidates: zod
              .array(
                zod
                  .object({
                    supplierId: zod.string().describe("공급사 ID (users.id)"),
                    supplierName: zod.string().describe("공급사명"),
                    unitPrice: zod
                      .number()
                      .nullable()
                      .describe(
                        "그 줄에 제시한 단가. 견적서에 값이 없으면 null",
                      ),
                    taxType: zod
                      .enum(["EXCLUSIVE", "INCLUSIVE"])
                      .describe(
                        "단가의 부가세 축. INCLUSIVE 면 부가세 포함가라 그대로 등재된다(가산하지 않는다)",
                      ),
                    submittedAt: zod
                      .string()
                      .nullable()
                      .describe("견적 제출 시각"),
                    linked: zod
                      .boolean()
                      .describe(
                        "이 공급사의 단가가 이미 카탈로그에 있는가. true 면 연결 버튼을 막는다 — 공급사가 스스로 관리하는 단가를 관리자가 덮지 않는다.",
                      ),
                    catalogPrice: zod
                      .number()
                      .nullable()
                      .describe("카탈로그에 이미 있는 단가"),
                    catalogTaxType: zod
                      .enum(["EXCLUSIVE", "INCLUSIVE"])
                      .nullable()
                      .describe("카탈로그 단가의 부가세 축"),
                  })
                  .strict(),
              )
              .describe("이 줄에 견적을 낸 업체들"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 지정한 업체가 이 줄에 낸 단가를 매칭된 표준 물품의 공급 단가로 등재합니다. 이미 단가가 있으면 유지하고 아무것도 바꾸지 않습니다.
 * @summary 제출 단가를 카탈로그에 연결
 */
export const adminProjectsControllerLinkQuotedPriceParams = zod
  .object({
    id: zod.coerce.string(),
    index: zod.coerce.number(),
    supplierId: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerLinkQuotedPriceResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("요청 성공 여부"),
        created: zod
          .boolean()
          .describe(
            "이번에 새로 등재했는가. false 면 이미 단가가 있어 그대로 두었다는 뜻이다",
          ),
        itemId: zod.string().describe("등재된 표준 물품 ID"),
        supplierId: zod.string().describe("공급사 ID"),
        price: zod.number().describe("카탈로그에 남은 단가"),
        taxType: zod
          .enum(["EXCLUSIVE", "INCLUSIVE"])
          .describe("그 단가의 부가세 축"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 관리자가 새 마감일시를 지정해 공고를 연장합니다. 마감일이 지나 ON_HOLD 로 내려간 공고는 IN_PROGRESS 로 되살아나며, 구매자가 종결한 CLOSED 공고는 연장할 수 없습니다.
 * @summary 견적 요청 마감일 연장 (Admin)
 */
export const adminProjectsControllerExtendDeadlineParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerExtendDeadlineBody = zod
  .object({
    deadline: zod
      .string()
      .describe(
        "새 마감일시 (ISO 8601). 현재 시각과 기존 마감일시보다 뒤여야 하며, 한 번에 30일까지 연장할 수 있습니다.",
      ),
  })
  .strict();

export const adminProjectsControllerExtendDeadlineResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
        result: zod
          .object({
            id: zod.string().describe("견적 요청 ID"),
            deadline: zod.string().describe("연장된 마감일시 (ISO 8601)"),
            status: zod
              .string()
              .describe(
                "연장 후 상태. 마감일이 지나 ON_HOLD 로 내려가 있던 공고는 IN_PROGRESS 로 되살아납니다.",
              ),
          })
          .strict()
          .describe("연장 결과"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 관리자가 발주기관 대신 공고를 마감합니다. 마감 사유는 필수이며, 마감 주체는 «관리자» 로 기록돼 발주기관이 직접 마감한 건과 목록에서 구분됩니다. 이미 마감(CLOSED)된 공고는 409 입니다. 마감은 되돌릴 수 없습니다 — 마감 연장도 CLOSED 는 거절합니다.
 * @summary 공고 마감 (Admin)
 */
export const adminProjectsControllerCloseProjectParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerCloseProjectBodyReasonMin = 2;
export const adminProjectsControllerCloseProjectBodyReasonMax = 200;

export const adminProjectsControllerCloseProjectBody = zod
  .object({
    reason: zod
      .string()
      .min(adminProjectsControllerCloseProjectBodyReasonMin)
      .max(adminProjectsControllerCloseProjectBodyReasonMax)
      .describe("마감 사유. 목록의 상태 위에 그대로 뜹니다."),
  })
  .strict();

export const adminProjectsControllerCloseProjectResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
        result: zod
          .object({
            id: zod.string().describe("견적 요청 ID"),
            status: zod.string().describe("마감 후 상태"),
            closedAt: zod.string().nullable().describe("마감 시각 (ISO 8601)"),
            closeReason: zod.string().nullable().describe("마감 사유"),
          })
          .strict()
          .describe("마감 결과"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 참여업체 중 가장 싼 견적을 매입 대상으로 잡아 엔씨하이 명의의 구매대행 견적을 공고에 제출한다.
 * @summary 세모 엔씨하이 구매대행 제출 (Admin)
 */
export const adminProjectsControllerSubmitAgencyQuoteParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

/**
 * 중개 ↔ 구매대행 전환. 살아 있는 공고 + 참여업체 1곳 이상 + 계약 전에만 가능하다.
 * @summary 거래 모델 전환 (Admin)
 */
export const adminProjectsControllerSetTransactionModelParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerSetTransactionModelBody = zod
  .object({
    transactionModel: zod
      .enum(["brokerage", "agency"])
      .describe(
        "거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다)",
      ),
  })
  .strict();

export const adminProjectsControllerSetTransactionModelResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        projectId: zod.string().describe("공고 ID"),
        transactionModel: zod
          .enum(["brokerage", "agency"])
          .describe("전환된 거래 모델"),
        participantCount: zod.number().describe("전환 시점의 참여업체 수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 매칭된 정보를 바탕으로 발송 가능한 공급사들에게 자동견적을 일괄 생성 및 전송합니다.
 * @summary 프로젝트 자동견적 일괄 발송 트리거
 */
export const adminProjectsControllerTriggerAutoQuotesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerTriggerAutoQuotesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
        result: zod
          .object({
            quoteRequestId: zod.string().describe("견적 요청 ID"),
            totalEligibleSuppliers: zod.number().describe("적격 공급자 총 수"),
            successCount: zod.number().describe("발송 성공 수"),
            failureCount: zod.number().describe("발송 실패 수"),
            alreadyRespondedCount: zod
              .number()
              .describe("이미 응답한 공급자 수"),
            failedSuppliers: zod
              .array(
                zod
                  .object({
                    supplierId: zod.string().describe("공급자 ID"),
                    supplierName: zod.string().describe("공급자명"),
                    error: zod.string().describe("에러 메시지"),
                  })
                  .strict(),
              )
              .describe("실패한 공급자 목록"),
          })
          .strict()
          .describe("상세 결과"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 공고의 각 줄(매칭된 표준품목명 우선)로 유사 품목을 찾고, 그 품목들을 거래한 이력이 있는 공급사를 모읍니다. 이미 이 공고에 참여 중인 업체는 제외합니다. 발송은 하지 않습니다.
 * @summary 비슷한 제품 취급 업체 후보 조회 (Admin)
 */
export const adminProjectsControllerGetSimilarSuppliersParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerGetSimilarSuppliersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        candidates: zod.array(
          zod
            .object({
              supplierId: zod
                .string()
                .describe("공급사 사용자 ID (알림톡 수신자)"),
              companyName: zod.string().describe("업체명"),
              basisItemName: zod
                .string()
                .describe("이 업체를 뽑은 근거가 된 유사 품목명"),
              requestItemName: zod.string().describe("근거가 된 공고 줄 이름"),
              lastTransactionDate: zod
                .string()
                .nullish()
                .describe("근거 품목의 가장 최근 거래일"),
              unreachableReason: zod
                .string()
                .nullish()
                .describe(
                  "알림톡을 받을 수 없는 이유(연락처 없음·수신 거부). null 이면 발송 가능하다.",
                ),
            })
            .strict(),
        ),
        excludedParticipantCount: zod
          .number()
          .describe(
            "이미 이 공고에 참여 중이라 후보에서 제외한 업체 수(채팅방이 열렸거나 견적을 낸 곳).",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 고른 공급사들에게 카카오 알림톡으로 이 공고를 안내합니다. 공고 등록 시 자동 발송과 같은 템플릿·같은 조립 경로를 씁니다. 이미 참여 중인 업체는 요청에 섞여 있어도 보내지 않습니다.
 * @summary 비슷한 제품 취급 업체에 안내 발송 (Admin)
 */
export const adminProjectsControllerNotifySimilarSuppliersParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerNotifySimilarSuppliersBody = zod
  .object({
    supplierIds: zod
      .array(zod.string())
      .describe(
        "안내를 보낼 공급사 사용자 ID 목록. 후보 조회 결과에서 마스터가 고른 것만 담는다.",
      ),
  })
  .strict();

export const adminProjectsControllerNotifySimilarSuppliersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
        result: zod
          .object({
            sent: zod.number().describe("알림톡을 보낸 곳"),
            skipped: zod
              .number()
              .describe("연락처가 없거나 카카오 알림을 꺼 둬서 보내지 못한 곳"),
            failed: zod.number().describe("발송 중 오류가 난 곳"),
            ignored: zod
              .number()
              .optional()
              .describe(
                "요청에는 있었지만 이미 참여 중이거나 공급사가 아니어서 제외한 ID 수",
              ),
          })
          .strict()
          .describe("발송 결과"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이 공고에 달린 마스터 운영 메모를 최신순으로 반환합니다. 어드민 전용이며 발주기관·공급사 화면에는 어떤 경로로도 노출되지 않습니다.
 * @summary 공고 운영 메모 목록 (Admin)
 */
export const adminProjectsControllerGetProjectNotesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerGetProjectNotesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        notes: zod
          .array(
            zod
              .object({
                id: zod.string().describe("메모 ID"),
                body: zod.string().describe("메모 내용"),
                authorId: zod
                  .string()
                  .nullish()
                  .describe(
                    "작성 관리자 users.id. 계정이 삭제되면 null 이 되고 본문은 남는다. 삭제 버튼 노출 판단에 쓴다(자기 메모만 지울 수 있다).",
                  ),
                authorName: zod
                  .string()
                  .describe(
                    '작성자 표시명. 이름이 없으면 이메일, 둘 다 없으면 \"알 수 없음\"',
                  ),
                createdAt: zod.string().describe("작성 시각 (ISO 8601)"),
              })
              .strict(),
          )
          .describe("최신순 메모 목록"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 메모를 한 줄 추가합니다. 기존 메모를 덮어쓰지 않습니다 — 여러 마스터가 같은 공고를 만지므로 수정 API 를 두면 앞사람이 남긴 맥락이 말없이 사라집니다.
 * @summary 공고 운영 메모 작성 (Admin)
 */
export const adminProjectsControllerCreateProjectNoteParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerCreateProjectNoteBodyBodyMax = 2000;

export const adminProjectsControllerCreateProjectNoteBody = zod
  .object({
    body: zod
      .string()
      .max(adminProjectsControllerCreateProjectNoteBodyBodyMax)
      .describe("메모 내용"),
  })
  .strict();

export const adminProjectsControllerCreateProjectNoteResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("성공 여부"),
        result: zod
          .object({
            id: zod.string().describe("메모 ID"),
            body: zod.string().describe("메모 내용"),
            authorId: zod
              .string()
              .nullish()
              .describe(
                "작성 관리자 users.id. 계정이 삭제되면 null 이 되고 본문은 남는다. 삭제 버튼 노출 판단에 쓴다(자기 메모만 지울 수 있다).",
              ),
            authorName: zod
              .string()
              .describe(
                '작성자 표시명. 이름이 없으면 이메일, 둘 다 없으면 \"알 수 없음\"',
              ),
            createdAt: zod.string().describe("작성 시각 (ISO 8601)"),
          })
          .strict()
          .describe("작성된 메모"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 본인이 작성한 메모만 삭제할 수 있습니다. 남이 남긴 줄이 사라지면 "왜 이렇게 처리했는지" 를 되짚을 근거가 없어지기 때문입니다.
 * @summary 공고 운영 메모 삭제 (Admin)
 */
export const adminProjectsControllerDeleteProjectNoteParams = zod
  .object({
    id: zod.coerce.string(),
    noteId: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerDeleteProjectNoteResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 특정 채팅방 메시지 내역 조회 (Admin)
 */
export const adminProjectsControllerGetChatMessagesParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

/**
 * 이 참여(채팅방 + 딸린 견적)를 발주기관·공급사 화면에서 감춥니다. 마스터 화면에는 흐리게 남고 언제든 되살릴 수 있습니다. 계약이 진행 중이거나 결제가 오간 참여는 409 로 막힙니다.
 * @summary 공급사 참여 이력 숨기기 (Admin)
 */
export const adminProjectsControllerHideParticipationParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerHideParticipationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        chatRoomId: zod.string().describe("대상 참여의 채팅방 ID"),
        state: zod
          .enum(["visible", "hidden"])
          .describe(
            "바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게)",
          ),
        previousState: zod
          .enum(["visible", "hidden"])
          .optional()
          .describe("바뀌기 전 상태. 이미 같은 상태였으면 생략된다."),
        changed: zod
          .boolean()
          .describe(
            "실제로 상태가 바뀌었는지. false 면 이미 그 상태였다는 뜻이다.",
          ),
        quoteResponses: zod
          .number()
          .describe(
            "함께 표시된 견적 행 수. 견적을 내지 않고 방만 열린 참여는 0 이다.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 숨김 상태의 참여를 발주기관·공급사 화면으로 되돌립니다.
 * @summary 숨긴 참여 이력 되살리기 (Admin)
 */
export const adminProjectsControllerUnhideParticipationParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerUnhideParticipationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        chatRoomId: zod.string().describe("대상 참여의 채팅방 ID"),
        state: zod
          .enum(["visible", "hidden"])
          .describe(
            "바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게)",
          ),
        previousState: zod
          .enum(["visible", "hidden"])
          .optional()
          .describe("바뀌기 전 상태. 이미 같은 상태였으면 생략된다."),
        changed: zod
          .boolean()
          .describe(
            "실제로 상태가 바뀌었는지. false 면 이미 그 상태였다는 뜻이다.",
          ),
        quoteResponses: zod
          .number()
          .describe(
            "함께 표시된 견적 행 수. 견적을 내지 않고 방만 열린 참여는 0 이다.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 숨김 상태의 참여를 **실제로 지웁니다.** 견적·견적서 버전·대화방과 그 업체와 주고받은 대화가 함께 사라지며 되돌릴 수 없습니다. 숨김 처리를 거치지 않았거나 계약·결제가 걸린 참여는 409 로 막힙니다. 무엇이 사라졌는지를 수치로 돌려줍니다 — 지운 뒤에는 셀 수 없습니다.
 * @summary 참여 이력 삭제 (Admin) — 되돌릴 수 없음
 */
export const adminProjectsControllerDeleteParticipationParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerDeleteParticipationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        chatRoomId: zod.string().describe("지운 참여의 채팅방 ID"),
        quoteRequestId: zod.string().describe("이 참여가 속했던 공고 ID"),
        supplierId: zod.string().describe("이 참여의 공급사 users.id"),
        quoteResponses: zod.number().describe("함께 사라진 견적 수"),
        quoteVersions: zod.number().describe("함께 사라진 견적서 버전 수"),
        chatMessages: zod
          .number()
          .describe("함께 사라진 대화 메시지 수. 되돌릴 수 없다."),
        chatRooms: zod.number().describe("함께 사라진 대화방 수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * "삭제됨" 탭의 프로젝트를 원래 목록으로 되돌립니다.
 * @summary 삭제된 프로젝트 복원 (Admin)
 */
export const adminProjectsControllerRestoreProjectParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminProjectsControllerRestoreProjectResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 여러 계약의 정산 상태를 일괄 변경합니다.
 * @summary 정산 상태 일괄 변경 (Admin)
 */
export const adminSettlementControllerBatchUpdateStatusBody = zod
  .object({
    contractIds: zod.array(zod.string()).describe("변경할 계약 ID 목록"),
    status: zod
      .enum(["WAITING", "PENDING", "COMPLETED", "DEFERRED"])
      .describe("변경할 정산 상태"),
  })
  .strict();

/**
 * 현재 필터 조건에 맞는 정산 내역을 국세청 세금계산서 일괄발급 양식의 엑셀 파일로 다운로드합니다.
 * @summary 국세청 홈택스 일괄발급 엑셀 다운로드 (Admin)
 */
export const adminSettlementControllerExportHometaxQueryParams = zod
  .object({
    status: zod.coerce.string().optional(),
    paymentMethod: zod.coerce.string().optional(),
    startDate: zod.coerce.string().optional(),
    endDate: zod.coerce.string().optional(),
    searchTerm: zod.coerce.string().optional(),
  })
  .strict();

/**
 * 전체 정산 목록을 조회합니다 (페이지네이션 지원)
 * @summary 정산 목록 조회 (Admin)
 */
export const adminSettlementControllerGetSettlementsQueryParams = zod
  .object({
    status: zod.coerce.string().optional(),
    paymentMethod: zod.coerce.string().optional(),
    searchTerm: zod.coerce.string().optional(),
    limit: zod.coerce.number().optional(),
    page: zod.coerce.number().optional(),
  })
  .strict();

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemNameMax = 255;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemUnitPriceMin = 0;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemUnitMax = 10;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemSpec1Max = 255;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemSpec2Max = 255;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemSpec3Max = 255;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemAmountMin = 0;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemItemCodeMax = 100;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemManufacturerMax = 100;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemBrandMax = 100;

export const adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneIsPrepaidDefault = true;

export const adminSettlementControllerGetSettlementsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().uuid().describe("계약 ID"),
              contract: zod
                .object({
                  id: zod.string().uuid().describe("계약 ID"),
                  paymentTransactionId: zod.string().describe("결제 거래 ID"),
                  contractNumber: zod.string().describe("계약번호"),
                  totalAmount: zod.number().describe("총 금액"),
                  taxAmount: zod
                    .number()
                    .optional()
                    .describe("세금 (선택사항)"),
                  status: zod
                    .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                    .describe("계약 상태"),
                  pdfUrl: zod.string().nullable().describe("계약서 PDF URL"),
                  pdfGeneratedAt: zod
                    .string()
                    .datetime({})
                    .describe("계약서 PDF 생성 일시 (ISO 8601)"),
                  items: zod
                    .array(
                      zod
                        .object({
                          name: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemNameMax,
                            )
                            .describe("품목명 (필수)"),
                          unitPrice: zod
                            .number()
                            .min(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemUnitPriceMin,
                            )
                            .describe("단가 (부가세 포함, 원 단위)"),
                          unit: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemUnitMax,
                            )
                            .describe("단위 (예: EA, 박스, 세트)"),
                          spec1: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemSpec1Max,
                            )
                            .optional()
                            .describe("규격 1 (예: A4, 500ml)"),
                          spec2: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemSpec2Max,
                            )
                            .optional()
                            .describe(
                              "규격 2 - 재질/타입 (예: 80g, 스테인리스)",
                            ),
                          spec3: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemSpec3Max,
                            )
                            .optional()
                            .describe("규격 3 - 패키징 (예: 2500매/박스)"),
                          quantity: zod
                            .number()
                            .min(1)
                            .describe(
                              "수량 (견적응답 전용 - items 테이블에는 없음)",
                            ),
                          amount: zod
                            .number()
                            .min(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemAmountMin,
                            )
                            .describe(
                              "품목별 총액 (단가 x 수량, 견적응답 전용)",
                            ),
                          itemCode: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemItemCodeMax,
                            )
                            .optional()
                            .describe("상품코드 (items 테이블 선택사항)"),
                          manufacturer: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemManufacturerMax,
                            )
                            .optional()
                            .describe("제조사 (items 테이블 선택사항)"),
                          brand: zod
                            .string()
                            .max(
                              adminSettlementControllerGetSettlementsResponseTwoDataItemsItemContractOneItemsItemBrandMax,
                            )
                            .optional()
                            .describe("브랜드 (items 테이블 선택사항)"),
                          itemId: zod
                            .string()
                            .optional()
                            .describe("시스템 아이템 ID (자동 견적 매칭용)"),
                        })
                        .strict(),
                    )
                    .describe("계약 항목"),
                  supplier: zod
                    .object({
                      id: zod.string().uuid().describe("공급자 ID"),
                      name: zod.string().describe("공급자 회사명"),
                      ceoName: zod.string().describe("대표자명"),
                      businessNumber: zod.string().describe("사업자등록번호"),
                      address: zod.string().optional().describe("회사 주소"),
                      phone: zod.string().optional().describe("회사 전화번호"),
                      email: zod.string().optional().describe("공급자 이메일"),
                      managerName: zod.string().optional().describe("담당자명"),
                      managerPhone: zod
                        .string()
                        .optional()
                        .describe("담당자 전화번호"),
                      companySealUrl: zod
                        .string()
                        .optional()
                        .describe("회사 직인 URL"),
                      bankName: zod.string().optional().describe("은행명"),
                      bankAccountNumber: zod
                        .string()
                        .optional()
                        .describe("계좌번호"),
                      bankAccountHolder: zod
                        .string()
                        .optional()
                        .describe("예금주"),
                    })
                    .strict()
                    .describe("공급자 정보"),
                  description: zod
                    .string()
                    .optional()
                    .describe("견적 설명/비고"),
                  createdAt: zod
                    .string()
                    .datetime({})
                    .describe("계약 생성 일시 (ISO 8601)"),
                  updatedAt: zod
                    .string()
                    .datetime({})
                    .describe("계약 수정 일시 (ISO 8601)"),
                  canceledAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
                  cancellationReason: zod
                    .string()
                    .nullish()
                    .describe(
                      "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
                    ),
                  cancellationRequestedAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe(
                      "계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)",
                    ),
                  cancellationRequestedBy: zod
                    .enum(["buyer", "supplier"])
                    .nullish()
                    .describe(
                      "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
                    ),
                  completedAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe("구매확정 일시 (status=COMPLETED일 때만 존재)"),
                  projectName: zod
                    .string()
                    .optional()
                    .describe("프로젝트명 (거래명)"),
                  categoryType: zod
                    .enum(["product", "construction", "manufacturing", "used"])
                    .optional()
                    .describe("카테고리 유형"),
                  quoteRequestId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("견적 요청 ID"),
                  quoteResponseVersionId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe(
                      "견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다.",
                    ),
                  chatRoomId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("채팅방 ID (채팅 시작용)"),
                  chatMessageId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("채팅 메시지 ID"),
                  reviewId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("리뷰 ID (작성된 리뷰가 있는 경우)"),
                  paymentMethod: zod
                    .enum(["CARD", "BANK_TRANSFER"])
                    .optional()
                    .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
                  settlementStatus: zod
                    .enum(["PENDING", "COMPLETED", "DEFERRED"])
                    .describe("정산상태"),
                  refundStatus: zod
                    .string()
                    .nullish()
                    .describe(
                      "환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)",
                    ),
                  rejectionReason: zod
                    .string()
                    .nullish()
                    .describe(
                      "환불 반려 사유 (refundStatus=REJECTED일 때만 존재)",
                    ),
                  buyer: zod
                    .object({
                      name: zod.string().optional().describe("구매자명"),
                      company: zod.string().optional().describe("발주기관명"),
                      representativeName: zod
                        .string()
                        .optional()
                        .describe("발주기관 대표자"),
                      businessNumber: zod
                        .string()
                        .optional()
                        .describe("발주기관 사업자등록번호"),
                      address: zod
                        .string()
                        .optional()
                        .describe("발주기관 주소"),
                      phone: zod
                        .string()
                        .optional()
                        .describe("구매자 전화번호"),
                      email: zod.string().optional().describe("구매자 이메일"),
                    })
                    .strict()
                    .nullish()
                    .describe("발주자 정보"),
                  deliveryAddress: zod
                    .object({
                      id: zod.string().describe("주소 ID (UUID)"),
                      userId: zod.string().describe("사용자 ID (UUID)"),
                      label: zod
                        .string()
                        .optional()
                        .describe("주소 라벨 (회사, 집, 창고 등)"),
                      isDefault: zod.boolean().describe("기본 배송지 여부"),
                      postalCode: zod
                        .string()
                        .describe("우편번호 (5자리 숫자)"),
                      province: zod
                        .string()
                        .describe("시/도 (광역시 또는 도 단위)"),
                      city: zod.string().describe("시/군/구 (기초자치단체)"),
                      district: zod
                        .string()
                        .optional()
                        .describe("읍/면/동 (선택사항)"),
                      streetAddress: zod.string().describe("도로명 주소"),
                      addressDetail: zod
                        .string()
                        .optional()
                        .describe("상세 주소 (건물명, 동/호 등)"),
                      recipientName: zod
                        .string()
                        .optional()
                        .describe("수령인 이름"),
                      recipientPhone: zod
                        .string()
                        .optional()
                        .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
                      createdAt: zod
                        .string()
                        .optional()
                        .describe("생성일 (ISO 8601 형식)"),
                      updatedAt: zod
                        .string()
                        .optional()
                        .describe("수정일 (ISO 8601 형식)"),
                    })
                    .strict()
                    .nullish()
                    .describe("배송지 정보"),
                  isPrepaid: zod
                    .boolean()
                    .describe(
                      "결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제).",
                    ),
                  paidAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe(
                      "결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.",
                    ),
                  paymentChannel: zod
                    .enum(["cash", "card"])
                    .nullish()
                    .describe(
                      "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                    ),
                  taxInvoiceStatus: zod
                    .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                    .nullish()
                    .describe(
                      "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.",
                    ),
                  taxInvoiceTargetId: zod
                    .object({})
                    .nullish()
                    .describe(
                      "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).",
                    ),
                })
                .strict()
                .optional()
                .describe("계약 상세 정보"),
              contractNumber: zod.string().describe("계약 번호"),
              contractDate: zod.string().describe("계약 생성 일시"),
              totalAmount: zod.number().describe("총 계약 금액"),
              commissionAmount: zod.number().describe("플랫폼 수수료"),
              commissionOverrideAmount: zod
                .number()
                .nullish()
                .describe(
                  "계약 건별로 직접 지정한 수수료 정액(원). null 이면 전역 요율로 계산한 값이다.",
                ),
              settlementAmount: zod
                .number()
                .describe("정산 예정 금액 (총액 - 수수료)"),
              paymentMethod: zod.enum(["CARD", "CASH"]).describe("결제 수단"),
              settlementStatus: zod
                .enum(["WAITING", "PENDING", "COMPLETED", "DEFERRED"])
                .describe("정산 상태"),
              settlementExpectedDate: zod
                .string()
                .datetime({})
                .nullish()
                .describe("정산 예정일 (구매확정일 + 15일)"),
              completedAt: zod
                .string()
                .datetime({})
                .nullish()
                .describe("구매확정 일시"),
              settledAt: zod
                .string()
                .datetime({})
                .nullish()
                .describe("정산 지급 완료 일시"),
              clientName: zod.string().describe("구매자(발주)명"),
              supplierName: zod.string().describe("공급자(수주)명"),
              supplierBusinessNumber: zod
                .string()
                .optional()
                .describe("공급자 사업자번호"),
              note: zod.string().optional().describe("비고"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 정산 통계를 조회합니다. 목록과 같은 필터를 받아 카드 숫자가 표와 어긋나지 않게 합니다. 파라미터를 비우면 전체 누적입니다.
 * @summary 정산 통계 조회 (Admin)
 */
export const adminSettlementControllerGetStatsQueryParams = zod
  .object({
    status: zod.coerce.string().optional(),
    searchTerm: zod.coerce.string().optional(),
    startDate: zod.coerce.string().optional(),
    endDate: zod.coerce.string().optional(),
  })
  .strict();

export const adminSettlementControllerGetStatsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        unpaidCommission: zod
          .number()
          .describe(
            "미수 수수료 합계 — 계약이 서서 청구됐으나 아직 받지 못한 수수료",
          ),
        collectedCommission: zod
          .number()
          .describe("누적 수납 수수료 — 업체에서 실제로 받은 수수료"),
        unpaidCount: zod.number().describe("미수 건수"),
        totalPendingAmount: zod
          .number()
          .describe(
            "(레거시·대금 축) 정산 예정 총액. 직거래 전환으로 세모가 지급할 대금이 없어 화면에서 쓰지 않는다.",
          ),
        totalCompletedAmount: zod
          .number()
          .describe("(레거시·대금 축) 정산 완료 총액"),
        pendingCount: zod
          .number()
          .describe("(레거시) 대기 건수 — `unpaidCount` 와 같은 값이다"),
        totalCommission: zod
          .number()
          .describe(
            "수수료 청구액 합계 — 건별 10원 절사 후 합산이라 목록 표의 수수료 합과 정의가 같다.",
          ),
        safePaymentRevenue: zod.number().describe("안심결제 매출 총액"),
        directPaymentGMV: zod.number().describe("직접결제 유통 총액 (GMV)"),
        totalContractAmount: zod
          .number()
          .describe("계약금액 합계 — 현재 필터에 해당하는 계약의 총액 합"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 청구월의 수수료를 공급기업별로 모아 조회합니다. 명세 1줄은 거래일자입니다. 기본은 아직 계산서가 발행되지 않은 건만 보여 줍니다.
 * @summary 기업별 월 수수료 청구 조회 (Admin)
 */
export const adminSettlementControllerGetMonthlyBillingQueryParams = zod
  .object({
    month: zod.coerce.string(),
    includeIssued: zod.coerce.boolean().optional(),
    searchTerm: zod.coerce.string().optional(),
    supplierId: zod.coerce.string().optional(),
  })
  .strict();

export const adminSettlementControllerGetMonthlyBillingResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        month: zod.string().describe("청구월 'YYYY-MM'"),
        invoices: zod
          .array(
            zod
              .object({
                supplierId: zod.string().uuid().describe("공급기업 ID"),
                companyName: zod.string().describe("공급기업 상호"),
                businessNumber: zod.string().describe("사업자등록번호"),
                ceoName: zod.string().describe("대표자명"),
                addressFull: zod.string().describe("사업장 주소"),
                businessType: zod.string().describe("업태"),
                businessItem: zod.string().describe("종목"),
                email: zod
                  .string()
                  .describe(
                    "계산서 수신 이메일 (계산서 전용 → 담당자 → 계정 순)",
                  ),
                txCount: zod.number().describe("청구월 거래 건수"),
                txDateCount: zod.number().describe("청구월 거래일자 수"),
                contractAmount: zod.number().describe("계약금액 합계"),
                commission: zod
                  .number()
                  .describe("수수료 청구액 (부가세 포함)"),
                supplyAmount: zod.number().describe("공급가액"),
                taxAmount: zod.number().describe("세액"),
                lineItems: zod
                  .array(
                    zod
                      .object({
                        txDate: zod.string().describe("거래일자 (KST)"),
                        txCount: zod.number().describe("그 날의 계약 건수"),
                        contractAmount: zod
                          .number()
                          .describe("그 날의 계약금액 합계"),
                        commission: zod
                          .number()
                          .describe(
                            "그 날의 수수료 합계 (건별 10원 절사 후 합산, 부가세 포함)",
                          ),
                        supplyAmount: zod.number().describe("공급가액"),
                        taxAmount: zod.number().describe("세액"),
                      })
                      .strict(),
                  )
                  .describe("거래일자별 명세 (오름차순)"),
                itemizedByDate: zod
                  .boolean()
                  .describe(
                    "계산서 품목칸을 거래일자별로 채울 수 있는지. 거래일자가 4개를 넘으면 false 가 되고 월합계 1줄로 접힌다.",
                  ),
                issuedCount: zod
                  .number()
                  .describe(
                    "이 기업의 청구월 계약 중 이미 계산서가 발행된 건수",
                  ),
                lastIssuedAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe("마지막 발행 일시"),
              })
              .strict(),
          )
          .describe("기업별 청구서"),
        summary: zod
          .object({
            supplierCount: zod.number().describe("청구 대상 기업 수"),
            txCount: zod.number().describe("거래 건수 합계"),
            contractAmount: zod.number().describe("계약금액 합계"),
            commission: zod.number().describe("수수료 청구액 합계"),
          })
          .strict()
          .describe("조회 조건 합계"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 청구월의 수수료를 공급기업별로 1장씩 모아 국세청 전자세금계산서 일괄발급 양식(59컬럼)으로 내려받습니다. 거래일자별 상세는 같은 워크북의 [거래명세] 시트에 담깁니다. 다운로드가 성공하면 포함된 계약에 발행 도장이 찍혀 다음 조회에서 빠집니다.
 * @summary 기업별 월 수수료 계산서 발급 엑셀 (Admin)
 */
export const adminSettlementControllerExportMonthlyTaxInvoicesQueryParams = zod
  .object({
    month: zod.coerce.string(),
    includeIssued: zod.coerce.boolean().optional(),
    searchTerm: zod.coerce.string().optional(),
    supplierIds: zod.coerce
      .string()
      .optional()
      .describe("쉼표로 구분한 공급기업 ID. 비우면 조회된 전체."),
  })
  .strict();

/**
 * 정산 건의 상세 정보를 조회합니다.
 * @summary 정산 상세 조회 (Admin)
 */
export const adminSettlementControllerGetSettlementParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemNameMax = 255;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemUnitPriceMin = 0;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemUnitMax = 10;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemSpec1Max = 255;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemSpec2Max = 255;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemSpec3Max = 255;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemAmountMin = 0;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemItemCodeMax = 100;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemManufacturerMax = 100;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemBrandMax = 100;

export const adminSettlementControllerGetSettlementResponseTwoDataContractOneIsPrepaidDefault = true;

export const adminSettlementControllerGetSettlementResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("계약 ID"),
        contract: zod
          .object({
            id: zod.string().uuid().describe("계약 ID"),
            paymentTransactionId: zod.string().describe("결제 거래 ID"),
            contractNumber: zod.string().describe("계약번호"),
            totalAmount: zod.number().describe("총 금액"),
            taxAmount: zod.number().optional().describe("세금 (선택사항)"),
            status: zod
              .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
              .describe("계약 상태"),
            pdfUrl: zod.string().nullable().describe("계약서 PDF URL"),
            pdfGeneratedAt: zod
              .string()
              .datetime({})
              .describe("계약서 PDF 생성 일시 (ISO 8601)"),
            items: zod
              .array(
                zod
                  .object({
                    name: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemNameMax,
                      )
                      .describe("품목명 (필수)"),
                    unitPrice: zod
                      .number()
                      .min(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemUnitPriceMin,
                      )
                      .describe("단가 (부가세 포함, 원 단위)"),
                    unit: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemUnitMax,
                      )
                      .describe("단위 (예: EA, 박스, 세트)"),
                    spec1: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemSpec1Max,
                      )
                      .optional()
                      .describe("규격 1 (예: A4, 500ml)"),
                    spec2: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemSpec2Max,
                      )
                      .optional()
                      .describe("규격 2 - 재질/타입 (예: 80g, 스테인리스)"),
                    spec3: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemSpec3Max,
                      )
                      .optional()
                      .describe("규격 3 - 패키징 (예: 2500매/박스)"),
                    quantity: zod
                      .number()
                      .min(1)
                      .describe("수량 (견적응답 전용 - items 테이블에는 없음)"),
                    amount: zod
                      .number()
                      .min(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemAmountMin,
                      )
                      .describe("품목별 총액 (단가 x 수량, 견적응답 전용)"),
                    itemCode: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemItemCodeMax,
                      )
                      .optional()
                      .describe("상품코드 (items 테이블 선택사항)"),
                    manufacturer: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemManufacturerMax,
                      )
                      .optional()
                      .describe("제조사 (items 테이블 선택사항)"),
                    brand: zod
                      .string()
                      .max(
                        adminSettlementControllerGetSettlementResponseTwoDataContractOneItemsItemBrandMax,
                      )
                      .optional()
                      .describe("브랜드 (items 테이블 선택사항)"),
                    itemId: zod
                      .string()
                      .optional()
                      .describe("시스템 아이템 ID (자동 견적 매칭용)"),
                  })
                  .strict(),
              )
              .describe("계약 항목"),
            supplier: zod
              .object({
                id: zod.string().uuid().describe("공급자 ID"),
                name: zod.string().describe("공급자 회사명"),
                ceoName: zod.string().describe("대표자명"),
                businessNumber: zod.string().describe("사업자등록번호"),
                address: zod.string().optional().describe("회사 주소"),
                phone: zod.string().optional().describe("회사 전화번호"),
                email: zod.string().optional().describe("공급자 이메일"),
                managerName: zod.string().optional().describe("담당자명"),
                managerPhone: zod
                  .string()
                  .optional()
                  .describe("담당자 전화번호"),
                companySealUrl: zod
                  .string()
                  .optional()
                  .describe("회사 직인 URL"),
                bankName: zod.string().optional().describe("은행명"),
                bankAccountNumber: zod.string().optional().describe("계좌번호"),
                bankAccountHolder: zod.string().optional().describe("예금주"),
              })
              .strict()
              .describe("공급자 정보"),
            description: zod.string().optional().describe("견적 설명/비고"),
            createdAt: zod
              .string()
              .datetime({})
              .describe("계약 생성 일시 (ISO 8601)"),
            updatedAt: zod
              .string()
              .datetime({})
              .describe("계약 수정 일시 (ISO 8601)"),
            canceledAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
            cancellationReason: zod
              .string()
              .nullish()
              .describe(
                "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
              ),
            cancellationRequestedAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe(
                "계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)",
              ),
            cancellationRequestedBy: zod
              .enum(["buyer", "supplier"])
              .nullish()
              .describe(
                "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
              ),
            completedAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe("구매확정 일시 (status=COMPLETED일 때만 존재)"),
            projectName: zod
              .string()
              .optional()
              .describe("프로젝트명 (거래명)"),
            categoryType: zod
              .enum(["product", "construction", "manufacturing", "used"])
              .optional()
              .describe("카테고리 유형"),
            quoteRequestId: zod
              .string()
              .uuid()
              .optional()
              .describe("견적 요청 ID"),
            quoteResponseVersionId: zod
              .string()
              .uuid()
              .optional()
              .describe(
                "견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다.",
              ),
            chatRoomId: zod
              .string()
              .uuid()
              .optional()
              .describe("채팅방 ID (채팅 시작용)"),
            chatMessageId: zod
              .string()
              .uuid()
              .optional()
              .describe("채팅 메시지 ID"),
            reviewId: zod
              .string()
              .uuid()
              .optional()
              .describe("리뷰 ID (작성된 리뷰가 있는 경우)"),
            paymentMethod: zod
              .enum(["CARD", "BANK_TRANSFER"])
              .optional()
              .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
            settlementStatus: zod
              .enum(["PENDING", "COMPLETED", "DEFERRED"])
              .describe("정산상태"),
            refundStatus: zod
              .string()
              .nullish()
              .describe(
                "환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)",
              ),
            rejectionReason: zod
              .string()
              .nullish()
              .describe("환불 반려 사유 (refundStatus=REJECTED일 때만 존재)"),
            buyer: zod
              .object({
                name: zod.string().optional().describe("구매자명"),
                company: zod.string().optional().describe("발주기관명"),
                representativeName: zod
                  .string()
                  .optional()
                  .describe("발주기관 대표자"),
                businessNumber: zod
                  .string()
                  .optional()
                  .describe("발주기관 사업자등록번호"),
                address: zod.string().optional().describe("발주기관 주소"),
                phone: zod.string().optional().describe("구매자 전화번호"),
                email: zod.string().optional().describe("구매자 이메일"),
              })
              .strict()
              .nullish()
              .describe("발주자 정보"),
            deliveryAddress: zod
              .object({
                id: zod.string().describe("주소 ID (UUID)"),
                userId: zod.string().describe("사용자 ID (UUID)"),
                label: zod
                  .string()
                  .optional()
                  .describe("주소 라벨 (회사, 집, 창고 등)"),
                isDefault: zod.boolean().describe("기본 배송지 여부"),
                postalCode: zod.string().describe("우편번호 (5자리 숫자)"),
                province: zod.string().describe("시/도 (광역시 또는 도 단위)"),
                city: zod.string().describe("시/군/구 (기초자치단체)"),
                district: zod
                  .string()
                  .optional()
                  .describe("읍/면/동 (선택사항)"),
                streetAddress: zod.string().describe("도로명 주소"),
                addressDetail: zod
                  .string()
                  .optional()
                  .describe("상세 주소 (건물명, 동/호 등)"),
                recipientName: zod.string().optional().describe("수령인 이름"),
                recipientPhone: zod
                  .string()
                  .optional()
                  .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
                createdAt: zod
                  .string()
                  .optional()
                  .describe("생성일 (ISO 8601 형식)"),
                updatedAt: zod
                  .string()
                  .optional()
                  .describe("수정일 (ISO 8601 형식)"),
              })
              .strict()
              .nullish()
              .describe("배송지 정보"),
            isPrepaid: zod
              .boolean()
              .describe(
                "결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제).",
              ),
            paidAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe(
                "결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.",
              ),
            paymentChannel: zod
              .enum(["cash", "card"])
              .nullish()
              .describe(
                "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
              ),
            taxInvoiceStatus: zod
              .enum(["REQUESTED", "ISSUED", "CANCELLED"])
              .nullish()
              .describe(
                "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.",
              ),
            taxInvoiceTargetId: zod
              .object({})
              .nullish()
              .describe(
                "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).",
              ),
          })
          .strict()
          .optional()
          .describe("계약 상세 정보"),
        contractNumber: zod.string().describe("계약 번호"),
        contractDate: zod.string().describe("계약 생성 일시"),
        totalAmount: zod.number().describe("총 계약 금액"),
        commissionAmount: zod.number().describe("플랫폼 수수료"),
        commissionOverrideAmount: zod
          .number()
          .nullish()
          .describe(
            "계약 건별로 직접 지정한 수수료 정액(원). null 이면 전역 요율로 계산한 값이다.",
          ),
        settlementAmount: zod
          .number()
          .describe("정산 예정 금액 (총액 - 수수료)"),
        paymentMethod: zod.enum(["CARD", "CASH"]).describe("결제 수단"),
        settlementStatus: zod
          .enum(["WAITING", "PENDING", "COMPLETED", "DEFERRED"])
          .describe("정산 상태"),
        settlementExpectedDate: zod
          .string()
          .datetime({})
          .nullish()
          .describe("정산 예정일 (구매확정일 + 15일)"),
        completedAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("구매확정 일시"),
        settledAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("정산 지급 완료 일시"),
        clientName: zod.string().describe("구매자(발주)명"),
        supplierName: zod.string().describe("공급자(수주)명"),
        supplierBusinessNumber: zod
          .string()
          .optional()
          .describe("공급자 사업자번호"),
        note: zod.string().optional().describe("비고"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 계약의 정산 상태를 변경합니다.
 * @summary 정산 상태 변경 (Admin)
 */
export const adminSettlementControllerUpdateStatusParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminSettlementControllerUpdateStatusBody = zod
  .object({
    status: zod
      .enum(["WAITING", "PENDING", "COMPLETED", "DEFERRED"])
      .describe("변경할 정산 상태"),
  })
  .strict();

/**
 * 계약 체결 시 만들어졌어야 할 [계약 서류가 필요하신가요?] 카드를 채팅방에 다시 만듭니다. 이미 있으면 `already_exists` 로 아무 것도 하지 않습니다(멱등).

만들지 못하면 **사유를 응답에 담습니다** — `buyer_not_cmarket_member`(세모 직가입 발주기관, 의도된 미지원) · `no_documents`(씨마켓이 빈 목록) · `error`(씨마켓 호출 실패 등, `detail` 에 원문) 등.

생성되면 채팅방에 실시간으로 나타나며, 발주기관은 평소와 같은 흐름으로 서류를 고르면 됩니다.
 * @summary 계약서류 선택 카드 재생성 (누락 복구)
 */
export const adminContractControllerRecreateDocumentRequestMessageParams = zod
  .object({
    id: zod.coerce.string().describe("계약 UUID"),
  })
  .strict();

export const adminContractControllerRecreateDocumentRequestMessageResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 계약 목록 조회 (필터링/검색 지원)
 */
export const adminContractControllerGetContractsQueryParams = zod
  .object({
    status: zod.coerce
      .string()
      .optional()
      .describe("계약 상태 (IN_PROGRESS, COMPLETED, CANCELED 등)"),
    searchTerm: zod.coerce.string().optional().describe("계약번호 검색"),
    limit: zod.coerce.number().optional(),
    offset: zod.coerce.number().optional(),
  })
  .strict();

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemNameMax = 255;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemUnitPriceMin = 0;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemUnitMax = 10;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemSpec1Max = 255;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemSpec2Max = 255;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemSpec3Max = 255;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemAmountMin = 0;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemItemCodeMax = 100;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemManufacturerMax = 100;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemBrandMax = 100;

export const adminContractControllerGetContractsResponseTwoDataItemsItemContractOneIsPrepaidDefault = true;

export const adminContractControllerGetContractsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().uuid().describe("계약 ID"),
              contract: zod
                .object({
                  id: zod.string().uuid().describe("계약 ID"),
                  paymentTransactionId: zod.string().describe("결제 거래 ID"),
                  contractNumber: zod.string().describe("계약번호"),
                  totalAmount: zod.number().describe("총 금액"),
                  taxAmount: zod
                    .number()
                    .optional()
                    .describe("세금 (선택사항)"),
                  status: zod
                    .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                    .describe("계약 상태"),
                  pdfUrl: zod.string().nullable().describe("계약서 PDF URL"),
                  pdfGeneratedAt: zod
                    .string()
                    .datetime({})
                    .describe("계약서 PDF 생성 일시 (ISO 8601)"),
                  items: zod
                    .array(
                      zod
                        .object({
                          name: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemNameMax,
                            )
                            .describe("품목명 (필수)"),
                          unitPrice: zod
                            .number()
                            .min(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemUnitPriceMin,
                            )
                            .describe("단가 (부가세 포함, 원 단위)"),
                          unit: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemUnitMax,
                            )
                            .describe("단위 (예: EA, 박스, 세트)"),
                          spec1: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemSpec1Max,
                            )
                            .optional()
                            .describe("규격 1 (예: A4, 500ml)"),
                          spec2: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemSpec2Max,
                            )
                            .optional()
                            .describe(
                              "규격 2 - 재질/타입 (예: 80g, 스테인리스)",
                            ),
                          spec3: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemSpec3Max,
                            )
                            .optional()
                            .describe("규격 3 - 패키징 (예: 2500매/박스)"),
                          quantity: zod
                            .number()
                            .min(1)
                            .describe(
                              "수량 (견적응답 전용 - items 테이블에는 없음)",
                            ),
                          amount: zod
                            .number()
                            .min(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemAmountMin,
                            )
                            .describe(
                              "품목별 총액 (단가 x 수량, 견적응답 전용)",
                            ),
                          itemCode: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemItemCodeMax,
                            )
                            .optional()
                            .describe("상품코드 (items 테이블 선택사항)"),
                          manufacturer: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemManufacturerMax,
                            )
                            .optional()
                            .describe("제조사 (items 테이블 선택사항)"),
                          brand: zod
                            .string()
                            .max(
                              adminContractControllerGetContractsResponseTwoDataItemsItemContractOneItemsItemBrandMax,
                            )
                            .optional()
                            .describe("브랜드 (items 테이블 선택사항)"),
                          itemId: zod
                            .string()
                            .optional()
                            .describe("시스템 아이템 ID (자동 견적 매칭용)"),
                        })
                        .strict(),
                    )
                    .describe("계약 항목"),
                  supplier: zod
                    .object({
                      id: zod.string().uuid().describe("공급자 ID"),
                      name: zod.string().describe("공급자 회사명"),
                      ceoName: zod.string().describe("대표자명"),
                      businessNumber: zod.string().describe("사업자등록번호"),
                      address: zod.string().optional().describe("회사 주소"),
                      phone: zod.string().optional().describe("회사 전화번호"),
                      email: zod.string().optional().describe("공급자 이메일"),
                      managerName: zod.string().optional().describe("담당자명"),
                      managerPhone: zod
                        .string()
                        .optional()
                        .describe("담당자 전화번호"),
                      companySealUrl: zod
                        .string()
                        .optional()
                        .describe("회사 직인 URL"),
                      bankName: zod.string().optional().describe("은행명"),
                      bankAccountNumber: zod
                        .string()
                        .optional()
                        .describe("계좌번호"),
                      bankAccountHolder: zod
                        .string()
                        .optional()
                        .describe("예금주"),
                    })
                    .strict()
                    .describe("공급자 정보"),
                  description: zod
                    .string()
                    .optional()
                    .describe("견적 설명/비고"),
                  createdAt: zod
                    .string()
                    .datetime({})
                    .describe("계약 생성 일시 (ISO 8601)"),
                  updatedAt: zod
                    .string()
                    .datetime({})
                    .describe("계약 수정 일시 (ISO 8601)"),
                  canceledAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
                  cancellationReason: zod
                    .string()
                    .nullish()
                    .describe(
                      "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
                    ),
                  cancellationRequestedAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe(
                      "계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)",
                    ),
                  cancellationRequestedBy: zod
                    .enum(["buyer", "supplier"])
                    .nullish()
                    .describe(
                      "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
                    ),
                  completedAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe("구매확정 일시 (status=COMPLETED일 때만 존재)"),
                  projectName: zod
                    .string()
                    .optional()
                    .describe("프로젝트명 (거래명)"),
                  categoryType: zod
                    .enum(["product", "construction", "manufacturing", "used"])
                    .optional()
                    .describe("카테고리 유형"),
                  quoteRequestId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("견적 요청 ID"),
                  quoteResponseVersionId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe(
                      "견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다.",
                    ),
                  chatRoomId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("채팅방 ID (채팅 시작용)"),
                  chatMessageId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("채팅 메시지 ID"),
                  reviewId: zod
                    .string()
                    .uuid()
                    .optional()
                    .describe("리뷰 ID (작성된 리뷰가 있는 경우)"),
                  paymentMethod: zod
                    .enum(["CARD", "BANK_TRANSFER"])
                    .optional()
                    .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
                  settlementStatus: zod
                    .enum(["PENDING", "COMPLETED", "DEFERRED"])
                    .describe("정산상태"),
                  refundStatus: zod
                    .string()
                    .nullish()
                    .describe(
                      "환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)",
                    ),
                  rejectionReason: zod
                    .string()
                    .nullish()
                    .describe(
                      "환불 반려 사유 (refundStatus=REJECTED일 때만 존재)",
                    ),
                  buyer: zod
                    .object({
                      name: zod.string().optional().describe("구매자명"),
                      company: zod.string().optional().describe("발주기관명"),
                      representativeName: zod
                        .string()
                        .optional()
                        .describe("발주기관 대표자"),
                      businessNumber: zod
                        .string()
                        .optional()
                        .describe("발주기관 사업자등록번호"),
                      address: zod
                        .string()
                        .optional()
                        .describe("발주기관 주소"),
                      phone: zod
                        .string()
                        .optional()
                        .describe("구매자 전화번호"),
                      email: zod.string().optional().describe("구매자 이메일"),
                    })
                    .strict()
                    .nullish()
                    .describe("발주자 정보"),
                  deliveryAddress: zod
                    .object({
                      id: zod.string().describe("주소 ID (UUID)"),
                      userId: zod.string().describe("사용자 ID (UUID)"),
                      label: zod
                        .string()
                        .optional()
                        .describe("주소 라벨 (회사, 집, 창고 등)"),
                      isDefault: zod.boolean().describe("기본 배송지 여부"),
                      postalCode: zod
                        .string()
                        .describe("우편번호 (5자리 숫자)"),
                      province: zod
                        .string()
                        .describe("시/도 (광역시 또는 도 단위)"),
                      city: zod.string().describe("시/군/구 (기초자치단체)"),
                      district: zod
                        .string()
                        .optional()
                        .describe("읍/면/동 (선택사항)"),
                      streetAddress: zod.string().describe("도로명 주소"),
                      addressDetail: zod
                        .string()
                        .optional()
                        .describe("상세 주소 (건물명, 동/호 등)"),
                      recipientName: zod
                        .string()
                        .optional()
                        .describe("수령인 이름"),
                      recipientPhone: zod
                        .string()
                        .optional()
                        .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
                      createdAt: zod
                        .string()
                        .optional()
                        .describe("생성일 (ISO 8601 형식)"),
                      updatedAt: zod
                        .string()
                        .optional()
                        .describe("수정일 (ISO 8601 형식)"),
                    })
                    .strict()
                    .nullish()
                    .describe("배송지 정보"),
                  isPrepaid: zod
                    .boolean()
                    .describe(
                      "결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제).",
                    ),
                  paidAt: zod
                    .string()
                    .datetime({})
                    .nullish()
                    .describe(
                      "결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.",
                    ),
                  paymentChannel: zod
                    .enum(["cash", "card"])
                    .nullish()
                    .describe(
                      "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                    ),
                  taxInvoiceStatus: zod
                    .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                    .nullish()
                    .describe(
                      "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.",
                    ),
                  taxInvoiceTargetId: zod
                    .object({})
                    .nullish()
                    .describe(
                      "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).",
                    ),
                })
                .strict()
                .optional()
                .describe("계약 상세 정보 (전체 DTO)"),
              contractNumber: zod.string().describe("계약 번호"),
              createdAt: zod.string().describe("계약 생성 일시"),
              totalAmount: zod.number().describe("총 계약 금액"),
              status: zod.string().describe("계약 상태"),
              projectName: zod.string().optional().describe("프로젝트명"),
              categoryType: zod.string().optional().describe("카테고리 타입"),
              buyerName: zod.string().describe("구매자(발주)명"),
              supplierName: zod.string().describe("공급자(수주)명"),
              pdfUrl: zod.string().nullish().describe("PDF URL"),
              chatRoomId: zod.string().uuid().optional().describe("채팅방 ID"),
              buyerExternalId: zod
                .string()
                .nullish()
                .describe("씨마켓 회원 아이디 (씨마켓 연동 발주기관만)"),
              buyerOrganizationName: zod
                .string()
                .nullish()
                .describe("씨마켓 기관명 (씨마켓 연동 발주기관만)"),
              paymentMethod: zod
                .string()
                .nullish()
                .describe(
                  "결제 방식 — 'prepaid'(선불, 엔씨하이 수취) | 'postpaid'(후불, 공급사 직접 수취)",
                ),
              paymentChannel: zod
                .string()
                .nullish()
                .describe(
                  "결제 수단 (카드/무통장 등). 후불은 결제 거래 자체가 없어 null",
                ),
              paidAt: zod
                .string()
                .nullish()
                .describe(
                  "엔씨하이(주) 입금 확인 일시. null 이면 아직 입금 전",
                ),
              completedAt: zod
                .string()
                .nullish()
                .describe("검수(구매확정) 완료 일시. null 이면 검수 전"),
              settlementStatus: zod
                .string()
                .nullish()
                .describe("정산 상태 — WAITING | DEFERRED | COMPLETED"),
              settledAt: zod
                .string()
                .nullish()
                .describe("공급사 대금 지급 일시. null 이면 아직 안 나감"),
              settlementExpectedAt: zod
                .string()
                .nullish()
                .describe("정산 예정일"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 계약 상세 조회
 */
export const adminContractControllerGetContractParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemNameMax = 255;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemUnitPriceMin = 0;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemUnitMax = 10;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemSpec1Max = 255;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemSpec2Max = 255;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemSpec3Max = 255;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemAmountMin = 0;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemItemCodeMax = 100;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemManufacturerMax = 100;

export const adminContractControllerGetContractResponseTwoDataContractOneItemsItemBrandMax = 100;

export const adminContractControllerGetContractResponseTwoDataContractOneIsPrepaidDefault = true;

export const adminContractControllerGetContractResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("계약 ID"),
        contract: zod
          .object({
            id: zod.string().uuid().describe("계약 ID"),
            paymentTransactionId: zod.string().describe("결제 거래 ID"),
            contractNumber: zod.string().describe("계약번호"),
            totalAmount: zod.number().describe("총 금액"),
            taxAmount: zod.number().optional().describe("세금 (선택사항)"),
            status: zod
              .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
              .describe("계약 상태"),
            pdfUrl: zod.string().nullable().describe("계약서 PDF URL"),
            pdfGeneratedAt: zod
              .string()
              .datetime({})
              .describe("계약서 PDF 생성 일시 (ISO 8601)"),
            items: zod
              .array(
                zod
                  .object({
                    name: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemNameMax,
                      )
                      .describe("품목명 (필수)"),
                    unitPrice: zod
                      .number()
                      .min(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemUnitPriceMin,
                      )
                      .describe("단가 (부가세 포함, 원 단위)"),
                    unit: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemUnitMax,
                      )
                      .describe("단위 (예: EA, 박스, 세트)"),
                    spec1: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemSpec1Max,
                      )
                      .optional()
                      .describe("규격 1 (예: A4, 500ml)"),
                    spec2: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemSpec2Max,
                      )
                      .optional()
                      .describe("규격 2 - 재질/타입 (예: 80g, 스테인리스)"),
                    spec3: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemSpec3Max,
                      )
                      .optional()
                      .describe("규격 3 - 패키징 (예: 2500매/박스)"),
                    quantity: zod
                      .number()
                      .min(1)
                      .describe("수량 (견적응답 전용 - items 테이블에는 없음)"),
                    amount: zod
                      .number()
                      .min(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemAmountMin,
                      )
                      .describe("품목별 총액 (단가 x 수량, 견적응답 전용)"),
                    itemCode: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemItemCodeMax,
                      )
                      .optional()
                      .describe("상품코드 (items 테이블 선택사항)"),
                    manufacturer: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemManufacturerMax,
                      )
                      .optional()
                      .describe("제조사 (items 테이블 선택사항)"),
                    brand: zod
                      .string()
                      .max(
                        adminContractControllerGetContractResponseTwoDataContractOneItemsItemBrandMax,
                      )
                      .optional()
                      .describe("브랜드 (items 테이블 선택사항)"),
                    itemId: zod
                      .string()
                      .optional()
                      .describe("시스템 아이템 ID (자동 견적 매칭용)"),
                  })
                  .strict(),
              )
              .describe("계약 항목"),
            supplier: zod
              .object({
                id: zod.string().uuid().describe("공급자 ID"),
                name: zod.string().describe("공급자 회사명"),
                ceoName: zod.string().describe("대표자명"),
                businessNumber: zod.string().describe("사업자등록번호"),
                address: zod.string().optional().describe("회사 주소"),
                phone: zod.string().optional().describe("회사 전화번호"),
                email: zod.string().optional().describe("공급자 이메일"),
                managerName: zod.string().optional().describe("담당자명"),
                managerPhone: zod
                  .string()
                  .optional()
                  .describe("담당자 전화번호"),
                companySealUrl: zod
                  .string()
                  .optional()
                  .describe("회사 직인 URL"),
                bankName: zod.string().optional().describe("은행명"),
                bankAccountNumber: zod.string().optional().describe("계좌번호"),
                bankAccountHolder: zod.string().optional().describe("예금주"),
              })
              .strict()
              .describe("공급자 정보"),
            description: zod.string().optional().describe("견적 설명/비고"),
            createdAt: zod
              .string()
              .datetime({})
              .describe("계약 생성 일시 (ISO 8601)"),
            updatedAt: zod
              .string()
              .datetime({})
              .describe("계약 수정 일시 (ISO 8601)"),
            canceledAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
            cancellationReason: zod
              .string()
              .nullish()
              .describe(
                "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
              ),
            cancellationRequestedAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe(
                "계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)",
              ),
            cancellationRequestedBy: zod
              .enum(["buyer", "supplier"])
              .nullish()
              .describe(
                "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
              ),
            completedAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe("구매확정 일시 (status=COMPLETED일 때만 존재)"),
            projectName: zod
              .string()
              .optional()
              .describe("프로젝트명 (거래명)"),
            categoryType: zod
              .enum(["product", "construction", "manufacturing", "used"])
              .optional()
              .describe("카테고리 유형"),
            quoteRequestId: zod
              .string()
              .uuid()
              .optional()
              .describe("견적 요청 ID"),
            quoteResponseVersionId: zod
              .string()
              .uuid()
              .optional()
              .describe(
                "견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다.",
              ),
            chatRoomId: zod
              .string()
              .uuid()
              .optional()
              .describe("채팅방 ID (채팅 시작용)"),
            chatMessageId: zod
              .string()
              .uuid()
              .optional()
              .describe("채팅 메시지 ID"),
            reviewId: zod
              .string()
              .uuid()
              .optional()
              .describe("리뷰 ID (작성된 리뷰가 있는 경우)"),
            paymentMethod: zod
              .enum(["CARD", "BANK_TRANSFER"])
              .optional()
              .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
            settlementStatus: zod
              .enum(["PENDING", "COMPLETED", "DEFERRED"])
              .describe("정산상태"),
            refundStatus: zod
              .string()
              .nullish()
              .describe(
                "환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)",
              ),
            rejectionReason: zod
              .string()
              .nullish()
              .describe("환불 반려 사유 (refundStatus=REJECTED일 때만 존재)"),
            buyer: zod
              .object({
                name: zod.string().optional().describe("구매자명"),
                company: zod.string().optional().describe("발주기관명"),
                representativeName: zod
                  .string()
                  .optional()
                  .describe("발주기관 대표자"),
                businessNumber: zod
                  .string()
                  .optional()
                  .describe("발주기관 사업자등록번호"),
                address: zod.string().optional().describe("발주기관 주소"),
                phone: zod.string().optional().describe("구매자 전화번호"),
                email: zod.string().optional().describe("구매자 이메일"),
              })
              .strict()
              .nullish()
              .describe("발주자 정보"),
            deliveryAddress: zod
              .object({
                id: zod.string().describe("주소 ID (UUID)"),
                userId: zod.string().describe("사용자 ID (UUID)"),
                label: zod
                  .string()
                  .optional()
                  .describe("주소 라벨 (회사, 집, 창고 등)"),
                isDefault: zod.boolean().describe("기본 배송지 여부"),
                postalCode: zod.string().describe("우편번호 (5자리 숫자)"),
                province: zod.string().describe("시/도 (광역시 또는 도 단위)"),
                city: zod.string().describe("시/군/구 (기초자치단체)"),
                district: zod
                  .string()
                  .optional()
                  .describe("읍/면/동 (선택사항)"),
                streetAddress: zod.string().describe("도로명 주소"),
                addressDetail: zod
                  .string()
                  .optional()
                  .describe("상세 주소 (건물명, 동/호 등)"),
                recipientName: zod.string().optional().describe("수령인 이름"),
                recipientPhone: zod
                  .string()
                  .optional()
                  .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
                createdAt: zod
                  .string()
                  .optional()
                  .describe("생성일 (ISO 8601 형식)"),
                updatedAt: zod
                  .string()
                  .optional()
                  .describe("수정일 (ISO 8601 형식)"),
              })
              .strict()
              .nullish()
              .describe("배송지 정보"),
            isPrepaid: zod
              .boolean()
              .describe(
                "결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제).",
              ),
            paidAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe(
                "결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.",
              ),
            paymentChannel: zod
              .enum(["cash", "card"])
              .nullish()
              .describe(
                "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
              ),
            taxInvoiceStatus: zod
              .enum(["REQUESTED", "ISSUED", "CANCELLED"])
              .nullish()
              .describe(
                "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.",
              ),
            taxInvoiceTargetId: zod
              .object({})
              .nullish()
              .describe(
                "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).",
              ),
          })
          .strict()
          .optional()
          .describe("계약 상세 정보 (전체 DTO)"),
        contractNumber: zod.string().describe("계약 번호"),
        createdAt: zod.string().describe("계약 생성 일시"),
        totalAmount: zod.number().describe("총 계약 금액"),
        status: zod.string().describe("계약 상태"),
        projectName: zod.string().optional().describe("프로젝트명"),
        categoryType: zod.string().optional().describe("카테고리 타입"),
        buyerName: zod.string().describe("구매자(발주)명"),
        supplierName: zod.string().describe("공급자(수주)명"),
        pdfUrl: zod.string().nullish().describe("PDF URL"),
        chatRoomId: zod.string().uuid().optional().describe("채팅방 ID"),
        buyerExternalId: zod
          .string()
          .nullish()
          .describe("씨마켓 회원 아이디 (씨마켓 연동 발주기관만)"),
        buyerOrganizationName: zod
          .string()
          .nullish()
          .describe("씨마켓 기관명 (씨마켓 연동 발주기관만)"),
        paymentMethod: zod
          .string()
          .nullish()
          .describe(
            "결제 방식 — 'prepaid'(선불, 엔씨하이 수취) | 'postpaid'(후불, 공급사 직접 수취)",
          ),
        paymentChannel: zod
          .string()
          .nullish()
          .describe(
            "결제 수단 (카드/무통장 등). 후불은 결제 거래 자체가 없어 null",
          ),
        paidAt: zod
          .string()
          .nullish()
          .describe("엔씨하이(주) 입금 확인 일시. null 이면 아직 입금 전"),
        completedAt: zod
          .string()
          .nullish()
          .describe("검수(구매확정) 완료 일시. null 이면 검수 전"),
        settlementStatus: zod
          .string()
          .nullish()
          .describe("정산 상태 — WAITING | DEFERRED | COMPLETED"),
        settledAt: zod
          .string()
          .nullish()
          .describe("공급사 대금 지급 일시. null 이면 아직 안 나감"),
        settlementExpectedAt: zod.string().nullish().describe("정산 예정일"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 지금 계약 내용으로 계약서 PDF 를 다시 만듭니다. `items` 를 함께 보내면 계약 품목을 그 목록으로 바꾼 뒤 만듭니다.

기존 파일은 새 파일이 완성된 뒤에 교체되므로, 만드는 동안에도 계약서를 받을 수 있습니다. 취소된 계약은 거절합니다.
 * @summary 계약서 재생성 (품목 교정 포함)
 */
export const adminContractControllerRegeneratePdfParams = zod
  .object({
    id: zod.coerce.string().describe("계약 UUID"),
  })
  .strict();

export const adminContractControllerRegeneratePdfBody = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품명"),
            quantity: zod.number().describe("수량"),
            unit: zod.string().describe("단위"),
            amount: zod.number().describe("금액(공급가액)"),
            unitPrice: zod.number().optional().describe("단가"),
            spec1: zod.string().optional().describe("규격1"),
            spec2: zod.string().optional().describe("규격2"),
            spec3: zod.string().optional().describe("규격3"),
          })
          .strict(),
      )
      .optional()
      .describe(
        "교정한 계약 품목 전체. 주면 계약의 품목을 이 목록으로 바꾼 뒤 계약서를 다시 만든다. 생략하면 지금 계약 내용 그대로 다시 만들기만 한다.",
      ),
  })
  .strict();

export const adminContractControllerRegeneratePdfResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        enqueued: zod
          .boolean()
          .describe("계약서 재생성 작업이 대기줄에 실렸는지"),
        itemsUpdated: zod.boolean().describe("품목을 바꿨는지"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이 계약에만 적용할 수수료 금액(원)을 지정합니다. 전역 요율보다 우선하며, null 을 보내면 해제하고 현재 전역 요율로 다시 계산합니다. 10원 미만은 절사됩니다.
 * @summary 계약 건별 수수료 정액 설정/해제
 */
export const adminContractControllerUpdateCommissionParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminContractControllerUpdateCommissionBodyCommissionOverrideAmountMin = 0;

export const adminContractControllerUpdateCommissionBody = zod
  .object({
    commissionOverrideAmount: zod
      .number()
      .min(
        adminContractControllerUpdateCommissionBodyCommissionOverrideAmountMin,
      )
      .nullable()
      .describe(
        "이 계약에만 적용할 수수료 정액(원). null 이면 override 를 해제하고 전역 요율 계산으로 되돌린다. 저장 시 10원 미만은 절사된다.",
      ),
  })
  .strict();

/**
 * @summary 전역 수수료 정책 조회
 */
export const adminFeePolicyControllerGetPolicyResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        feeRate: zod.number().describe("전역 수수료율(%)"),
        updatedAt: zod.string().nullable().describe("마지막 변경 시각(ISO)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이후 생성되는 계약부터 적용됩니다. 기존 계약의 수수료는 재계산하지 않습니다.
 * @summary 전역 수수료율 변경
 */
export const adminFeePolicyControllerUpdatePolicyBodyFeeRateMin = 0;
export const adminFeePolicyControllerUpdatePolicyBodyFeeRateMax = 100;

export const adminFeePolicyControllerUpdatePolicyBody = zod
  .object({
    feeRate: zod
      .number()
      .min(adminFeePolicyControllerUpdatePolicyBodyFeeRateMin)
      .max(adminFeePolicyControllerUpdatePolicyBodyFeeRateMax)
      .describe(
        "전역 수수료율(%). 0 이면 수수료 면제. 변경해도 기존 계약은 재계산하지 않는다.",
      ),
  })
  .strict();

export const adminFeePolicyControllerUpdatePolicyResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        feeRate: zod.number().describe("전역 수수료율(%)"),
        updatedAt: zod.string().nullable().describe("마지막 변경 시각(ISO)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 새로운 버전의 약관을 생성합니다.
 * @summary 약관 생성
 */
export const adminTermsControllerCreateTermsBodyIsActiveDefault = true;

export const adminTermsControllerCreateTermsBody = zod
  .object({
    type: zod
      .enum(["terms", "privacy", "marketing"])
      .describe(
        "약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의)",
      ),
    version: zod.string().describe("약관 버전 (Semantic Versioning 권장)"),
    title: zod.string().describe("약관 제목"),
    content: zod.string().describe("약관 내용 (HTML 또는 Markdown)"),
    isRequired: zod.boolean().describe("필수 동의 여부"),
    isActive: zod
      .boolean()
      .describe(
        "공개(활성) 여부. true일 경우 해당 타입의 기존 활성 약관은 비활성화됩니다.",
      ),
  })
  .strict();

/**
 * 모든 약관을 조회합니다.
 * @summary 약관 목록 조회
 */
export const adminTermsControllerGetAllTermsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().describe("약관 ID (UUID)"),
            type: zod
              .enum(["terms", "privacy", "marketing"])
              .describe("약관 타입"),
            version: zod.string().describe("버전"),
            title: zod.string().describe("약관 제목"),
            content: zod.string().describe("약관 내용"),
            isRequired: zod.boolean().describe("필수 여부"),
            isActive: zod.boolean().describe("활성(공개) 여부"),
            publishedAt: zod.string().describe("게시일"),
            createdAt: zod.string().describe("생성일"),
            updatedAt: zod.string().describe("수정일"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 약관의 상세 정보를 조회합니다.
 * @summary 약관 상세 조회
 */
export const adminTermsControllerGetTermsByIdParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminTermsControllerGetTermsByIdResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("약관 ID (UUID)"),
        type: zod.enum(["terms", "privacy", "marketing"]).describe("약관 타입"),
        version: zod.string().describe("버전"),
        title: zod.string().describe("약관 제목"),
        content: zod.string().describe("약관 내용"),
        isRequired: zod.boolean().describe("필수 여부"),
        isActive: zod.boolean().describe("활성(공개) 여부"),
        publishedAt: zod.string().describe("게시일"),
        createdAt: zod.string().describe("생성일"),
        updatedAt: zod.string().describe("수정일"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 약관 정보를 수정합니다.
 * @summary 약관 수정
 */
export const adminTermsControllerUpdateTermsParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminTermsControllerUpdateTermsBody = zod
  .object({
    title: zod.string().optional().describe("약관 제목"),
    content: zod.string().optional().describe("약관 내용"),
    isRequired: zod.boolean().optional().describe("필수 동의 여부"),
    type: zod
      .enum(["terms", "privacy", "marketing"])
      .optional()
      .describe(
        "약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의)",
      ),
    isActive: zod
      .boolean()
      .optional()
      .describe(
        "공개(활성) 여부. true로 변경 시 해당 타입의 다른 약관은 비활성화됩니다.",
      ),
  })
  .strict();

export const adminTermsControllerUpdateTermsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("약관 ID (UUID)"),
        type: zod.enum(["terms", "privacy", "marketing"]).describe("약관 타입"),
        version: zod.string().describe("버전"),
        title: zod.string().describe("약관 제목"),
        content: zod.string().describe("약관 내용"),
        isRequired: zod.boolean().describe("필수 여부"),
        isActive: zod.boolean().describe("활성(공개) 여부"),
        publishedAt: zod.string().describe("게시일"),
        createdAt: zod.string().describe("생성일"),
        updatedAt: zod.string().describe("수정일"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 지정된 엔씨하이 계정과, 못 쓰는 상태라면 그 이유를 함께 준다.
 * @summary 구매대행 당사자 조회 (Admin)
 */
export const adminAgencyPartyControllerGetResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        enabled: zod.boolean().describe("구매대행을 쓸 수 있는 상태인가"),
        cmarketMemberId: zod.string().nullable().describe("씨마켓 회원 ID"),
        displayName: zod.string().nullable().describe("상호"),
        buyerUserId: zod.string().nullable().describe("매입축 계정 id"),
        supplierUserId: zod.string().nullable().describe("판매축 계정 id"),
        updatedAt: zod.string().nullable().describe("마지막 변경 시각"),
        unavailableReason: zod
          .string()
          .nullable()
          .describe("못 쓰는 상태면 그 이유"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 씨마켓 회원 ID 하나로 판매축·매입축 계정을 함께 찾아 지정한다. 배포 없이 즉시 반영된다.
 * @summary 구매대행 당사자 지정 (Admin)
 */
export const adminAgencyPartyControllerSetBody = zod
  .object({
    cmarketMemberId: zod
      .string()
      .describe(
        "엔씨하이의 씨마켓 회원 ID. 이 값으로 판매축(공급사)·매입축(발주기관) 계정을 함께 찾는다.",
      ),
  })
  .strict();

export const adminAgencyPartyControllerSetResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        enabled: zod.boolean().describe("구매대행을 쓸 수 있는 상태인가"),
        cmarketMemberId: zod.string().nullable().describe("씨마켓 회원 ID"),
        displayName: zod.string().nullable().describe("상호"),
        buyerUserId: zod.string().nullable().describe("매입축 계정 id"),
        supplierUserId: zod.string().nullable().describe("판매축 계정 id"),
        updatedAt: zod.string().nullable().describe("마지막 변경 시각"),
        unavailableReason: zod
          .string()
          .nullable()
          .describe("못 쓰는 상태면 그 이유"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 구매대행을 끈다. 이미 성립한 계약은 건드리지 않는다.
 * @summary 구매대행 당사자 해제 (Admin)
 */
export const adminAgencyPartyControllerClearResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        enabled: zod.boolean().describe("구매대행을 쓸 수 있는 상태인가"),
        cmarketMemberId: zod.string().nullable().describe("씨마켓 회원 ID"),
        displayName: zod.string().nullable().describe("상호"),
        buyerUserId: zod.string().nullable().describe("매입축 계정 id"),
        supplierUserId: zod.string().nullable().describe("판매축 계정 id"),
        updatedAt: zod.string().nullable().describe("마지막 변경 시각"),
        unavailableReason: zod
          .string()
          .nullable()
          .describe("못 쓰는 상태면 그 이유"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 구매대행 지급 원장 목록 (Admin)
 */
export const adminAgencyPayoutsControllerListQueryPageDefault = 1;
export const adminAgencyPayoutsControllerListQueryLimitDefault = 20;

export const adminAgencyPayoutsControllerListQueryParams = zod
  .object({
    status: zod
      .enum(["scheduled", "on_hold", "paid", "failed", "canceled"])
      .optional()
      .describe("지급 상태"),
    supplierId: zod.coerce
      .string()
      .optional()
      .describe("공급기업 id (users.id)"),
    page: zod.coerce
      .number()
      .default(adminAgencyPayoutsControllerListQueryPageDefault),
    limit: zod.coerce
      .number()
      .default(adminAgencyPayoutsControllerListQueryLimitDefault),
  })
  .strict();

export const adminAgencyPayoutsControllerListResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string(),
              purchaseContractId: zod.string(),
              contractNumber: zod.string().describe("매입계약 번호"),
              supplierId: zod.string(),
              supplierName: zod.string().describe("공급기업 상호"),
              kind: zod.enum(["payment", "offset"]),
              amount: zod
                .number()
                .describe("금액(부가세 포함). 방향은 kind 가 정한다."),
              purchaseTotalAmount: zod.number().describe("매입계약 총액"),
              status: zod.enum([
                "scheduled",
                "on_hold",
                "paid",
                "failed",
                "canceled",
              ]),
              paidAt: zod.string().nullable().describe("지급 완료 시각"),
              holdReason: zod.string().nullable().describe("보류 사유"),
              transferRef: zod.string().nullable().describe("이체 결과 식별자"),
              createdAt: zod.string(),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * Σ(지급) − Σ(상계) 를 매입계약 총액과 비교한 값. 지급완료 처리는 이 잔여를 넘지 못한다.
 * @summary 매입계약 지급 잔여 한도 (Admin)
 */
export const adminAgencyPayoutsControllerBalanceParams = zod
  .object({
    purchaseContractId: zod.coerce.string(),
  })
  .strict();

export const adminAgencyPayoutsControllerBalanceResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        contractAmount: zod.number(),
        paidAmount: zod.number().describe("이미 나간 돈 — Σ(지급) − Σ(상계)"),
        remainingAmount: zod.number().describe("아직 더 나갈 수 있는 돈"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 은행 이체를 마친 뒤 원장에 찍는다. 한도 초과·이미 지급된 건은 거절된다.
 * @summary 지급완료 처리 (Admin)
 */
export const adminAgencyPayoutsControllerMarkPaidParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminAgencyPayoutsControllerMarkPaidBody = zod
  .object({
    transferRef: zod
      .string()
      .optional()
      .describe("이체 결과 식별자(은행 거래번호 등). 대사에 쓴다."),
  })
  .strict();

export const adminAgencyPayoutsControllerMarkPaidResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string(),
        purchaseContractId: zod.string(),
        contractNumber: zod.string().describe("매입계약 번호"),
        supplierId: zod.string(),
        supplierName: zod.string().describe("공급기업 상호"),
        kind: zod.enum(["payment", "offset"]),
        amount: zod
          .number()
          .describe("금액(부가세 포함). 방향은 kind 가 정한다."),
        purchaseTotalAmount: zod.number().describe("매입계약 총액"),
        status: zod.enum([
          "scheduled",
          "on_hold",
          "paid",
          "failed",
          "canceled",
        ]),
        paidAt: zod.string().nullable().describe("지급 완료 시각"),
        holdReason: zod.string().nullable().describe("보류 사유"),
        transferRef: zod.string().nullable().describe("이체 결과 식별자"),
        createdAt: zod.string(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 검수 미완료·분쟁 등으로 지급을 멈춘다. 사유는 필수다.
 * @summary 지급 보류 (Admin)
 */
export const adminAgencyPayoutsControllerHoldParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminAgencyPayoutsControllerHoldBody = zod
  .object({
    reason: zod.string().describe("보류 사유"),
  })
  .strict();

export const adminAgencyPayoutsControllerHoldResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string(),
        purchaseContractId: zod.string(),
        contractNumber: zod.string().describe("매입계약 번호"),
        supplierId: zod.string(),
        supplierName: zod.string().describe("공급기업 상호"),
        kind: zod.enum(["payment", "offset"]),
        amount: zod
          .number()
          .describe("금액(부가세 포함). 방향은 kind 가 정한다."),
        purchaseTotalAmount: zod.number().describe("매입계약 총액"),
        status: zod.enum([
          "scheduled",
          "on_hold",
          "paid",
          "failed",
          "canceled",
        ]),
        paidAt: zod.string().nullable().describe("지급 완료 시각"),
        holdReason: zod.string().nullable().describe("보류 사유"),
        transferRef: zod.string().nullable().describe("이체 결과 식별자"),
        createdAt: zod.string(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 전체 활동 로그 조회 (관리자용)
 */
export const adminActivityLogsControllerGetAllActivityLogsQueryPageDefault = 1;

export const adminActivityLogsControllerGetAllActivityLogsQueryLimitDefault = 20;
export const adminActivityLogsControllerGetAllActivityLogsQueryLimitMax = 100;

export const adminActivityLogsControllerGetAllActivityLogsQuerySortByDefault =
  "created_at";
export const adminActivityLogsControllerGetAllActivityLogsQuerySortOrderDefault =
  "desc";

export const adminActivityLogsControllerGetAllActivityLogsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(adminActivityLogsControllerGetAllActivityLogsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(adminActivityLogsControllerGetAllActivityLogsQueryLimitMax)
      .default(adminActivityLogsControllerGetAllActivityLogsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(adminActivityLogsControllerGetAllActivityLogsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(
        adminActivityLogsControllerGetAllActivityLogsQuerySortOrderDefault,
      )
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    category: zod
      .enum([
        "auth",
        "quote",
        "chat",
        "profile",
        "payment",
        "contract",
        "security",
        "promotion",
      ])
      .optional()
      .describe("활동 카테고리 필터"),
    from: zod.coerce.string().optional().describe("조회 시작 날짜 (ISO8601)"),
    to: zod.coerce.string().optional().describe("조회 종료 날짜 (ISO8601)"),
    userId: zod.coerce.string().optional().describe("특정 사용자 ID로 필터"),
  })
  .strict();

export const adminActivityLogsControllerGetAllActivityLogsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("로그 ID"),
              category: zod
                .enum([
                  "auth",
                  "quote",
                  "chat",
                  "profile",
                  "payment",
                  "contract",
                  "security",
                  "promotion",
                ])
                .describe("카테고리"),
              action: zod.string().describe("액션 타입"),
              actionLabel: zod.string().describe("액션 한글 라벨"),
              resourceType: zod.string().optional().describe("리소스 타입"),
              resourceId: zod.string().optional().describe("리소스 ID"),
              metadata: zod.object({}).optional().describe("추가 메타데이터"),
              createdAt: zod.string().describe("생성 시간"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 활동 로그 통계 조회 (관리자용)
 */
export const adminActivityLogsControllerGetStatsQueryParams = zod
  .object({
    from: zod.coerce.string(),
    to: zod.coerce.string(),
  })
  .strict();

/**
 * @summary 리소스별 활동 이력 조회
 */
export const adminActivityLogsControllerGetResourceLogsParams = zod
  .object({
    type: zod.coerce.string(),
    id: zod.coerce.string(),
  })
  .strict();

export const adminActivityLogsControllerGetResourceLogsQueryPageDefault = 1;

export const adminActivityLogsControllerGetResourceLogsQueryLimitDefault = 20;
export const adminActivityLogsControllerGetResourceLogsQueryLimitMax = 100;

export const adminActivityLogsControllerGetResourceLogsQuerySortByDefault =
  "created_at";
export const adminActivityLogsControllerGetResourceLogsQuerySortOrderDefault =
  "desc";

export const adminActivityLogsControllerGetResourceLogsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(adminActivityLogsControllerGetResourceLogsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(adminActivityLogsControllerGetResourceLogsQueryLimitMax)
      .default(adminActivityLogsControllerGetResourceLogsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(adminActivityLogsControllerGetResourceLogsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(adminActivityLogsControllerGetResourceLogsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    category: zod
      .enum([
        "auth",
        "quote",
        "chat",
        "profile",
        "payment",
        "contract",
        "security",
        "promotion",
      ])
      .optional()
      .describe("활동 카테고리 필터"),
    from: zod.coerce.string().optional().describe("조회 시작 날짜 (ISO8601)"),
    to: zod.coerce.string().optional().describe("조회 종료 날짜 (ISO8601)"),
    userId: zod.coerce.string().optional().describe("특정 사용자 ID로 필터"),
  })
  .strict();

export const adminActivityLogsControllerGetResourceLogsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("로그 ID"),
              category: zod
                .enum([
                  "auth",
                  "quote",
                  "chat",
                  "profile",
                  "payment",
                  "contract",
                  "security",
                  "promotion",
                ])
                .describe("카테고리"),
              action: zod.string().describe("액션 타입"),
              actionLabel: zod.string().describe("액션 한글 라벨"),
              resourceType: zod.string().optional().describe("리소스 타입"),
              resourceId: zod.string().optional().describe("리소스 ID"),
              metadata: zod.object({}).optional().describe("추가 메타데이터"),
              createdAt: zod.string().describe("생성 시간"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
